"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Announcer = exports.Portal = exports.SpawnPoint = exports.WirePoint = exports.NookDiff = exports.CoworkingInfo = exports.RecordingInfo = exports.RequestedUsers_UsersEntry = exports.RequestedUsers = exports.RequestUser = exports.AllowedUsers = exports.NookCoords = exports.Space = exports.ObjectTime = exports.Text = exports.Sound = exports.MapAndDesk = exports.DeskInfoV2 = exports.DeskObjects_ObjectsEntry = exports.DeskObjects = exports.BackedUpDeskObject = exports.WireObject = exports.WireObjectSpritesheet_AnimationsEntry = exports.WireObjectSpritesheet = exports.WireObjectSpriteAnimConfig = exports.WireObjectSpritesheetFraming = exports.DBOutfit = exports.PlayerInitInfo = exports.ChatV2ActionTypeEnum = exports.ChatV2ChannelTypeEnum = exports.RequestToLeadResponseEnum = exports.InteractionEnum = exports.MoveDirectionEnum = exports.SpriteDirectionEnum = exports.Deprecated = exports.StopRecording_Reason = exports.RespondToAccessRequest_LocationTypeEnum = exports.RequestPromoteToMemberResponseEnum_ENUM = exports.AnnotationDelta_Type = exports.Annotation_AnnotationSession = exports.Annotation_Tool = exports.WireMappableKind_ENUM = exports.DeskPodMode_ENUM = exports.ChatV2ActionTypeEnum_ENUM = exports.ChatV2ChannelTypeEnum_ENUM = exports.RequestToLeadResponseEnum_ENUM = exports.InteractionEnum_ENUM = exports.MoveDirectionEnum_ENUM = exports.SpriteDirectionEnum_ENUM = exports.protobufPackage = void 0;
exports.ItemAbility = exports.SpaceItem_AbilitiesEntry = exports.SpaceItem_MetaEntry = exports.SpaceItem = exports.InventoryItem = exports.Inventory_OrderEntry = exports.Inventory_ItemsEntry = exports.Inventory = exports.TutorialTaskMapArea = exports.WireTutorialTasks = exports.MapSetTutorialTasks = exports.MapSetDecoration = exports.MapSetDescription = exports.MapSetEnabledChats = exports.MapSetMiniMapImagePath = exports.MapDeleteObjectById = exports.MapDeleteObjectByKey = exports.MapSetAreas_AreasEntry = exports.MapSetAreas = exports.MapSetFloors_FloorsEntry = exports.MapSetFloors = exports.MapSetWalls_WallsEntry = exports.MapSetWalls = exports.MapSetUseDrawnBG = exports.MapSetMuteOnEntry = exports.MapSetName = exports.MapSetObjectsV2_ObjectsEntry = exports.MapSetObjectsV2 = exports.MapSetAssets = exports.MapSetAnnouncer = exports.MapSetPortals = exports.MapSetSpawns = exports.MapSetSpawn = exports.MapSetNooks_NooksEntry = exports.MapSetNooks = exports.MapSetInitialInfo = exports.MapSetForegroundImagePath = exports.MapSetBackgroundImagePath = exports.MapSetCollisionsBits = exports.MapSetCollisions = exports.MapSetDimensions = exports.WireDeskPod = exports.WireDeskPodSettings = exports.DeskPodMode = exports.DeskPodCoords = exports.DBDesk = exports.WireArea = exports.AreaMetaData = exports.AreaPosition = exports.Asset = void 0;
exports.PlayerMoves = exports.GotRequestMute = exports.PlayerJoins = exports.TransactionStatus = exports.Ready = exports.ErrorEvent = exports.Warn = exports.Info = exports.ServerHeartbeat = exports.SubscriptionsUpdated = exports.ServerClientEvent = exports.ServerClientBatch = exports.WirePlacedMappable = exports.MapApplyChanges = exports.MapApplyEditActions = exports.MapEditAction = exports.ResizeArea = exports.UpdateFontColor = exports.UpdateFontSize = exports.UpdateFontLabel = exports.UpdateFont = exports.UpdateOrCreateWallStyle = exports.UpdateOrCreateGroundStyle = exports.UpdateInteraction = exports.UpdateBookableCapacity = exports.DeleteMappable = exports.AddMappable = exports.MoveMappable = exports.SetCatalogItemId = exports.WireRelativePosition = exports.WireMappable = exports.WireInteractable = exports.WireNoteInteractable = exports.WireElevatorInteractable = exports.WireWebsiteInteractable = exports.WireVideoInteractable = exports.WireImpassable = exports.WireBookable = exports.WireRenderable = exports.WireTextRenderable = exports.WireWallsAndGroundRenderable = exports.WireImageRenderable = exports.WireMappableKind = exports.WireNameable = exports.WireSpatial = exports.WireAuthored = exports.MapSetDeskPods_DeskPodsEntry = exports.MapSetDeskPods = exports.ActivityStatus = exports.MapLocation = void 0;
exports.PlayerSetsPersonalImageId = exports.PlayerSetsProfileImageId = exports.PlayerSetsDescription = exports.PlayerSetsDisplayEmail = exports.PlayerSetsPhone = exports.PlayerSetsTimezone = exports.PlayerSetsStartDate = exports.PlayerSetsCountry = exports.PlayerSetsCity = exports.PlayerSetsTitle = exports.PlayerSetsPronouns = exports.PlayerSetsTextStatus = exports.PlayerSetsName = exports.PlayerSetsLastActive = exports.PlayerSetsLastRaisedHand = exports.PlayerSetsHandRaisedAt = exports.PlayerSetsEmoteV2 = exports.PlayerActivelySpeaks = exports.PlayerLeavesWhisper = exports.PlayerEntersWhisperV2 = exports.PlayerEntersWhisper = exports.PlayerShimmys = exports.PlayerGhosts = exports.PlayerInteractsWithObject = exports.Timestamp = exports.PlayerWaves = exports.ChatV2Notification = exports.PlayerChats = exports.ClearAnnotations = exports.ClearAllAnnotations = exports.RequestAnnotations = exports.RequestAnnotationSession = exports.AnnotationRequest = exports.AnnotationRequestDenied = exports.ActiveAnnotationSessions = exports.AnnotationSession = exports.SendAnnotationSession = exports.LoadAnnotationSession = exports.StartAnnotationSession = exports.AnnotationSessionNotFound = exports.AnnotationDelta = exports.Annotation_Point = exports.Annotation = exports.SetScreenPointerServer = exports.PlayerSetsImagePointer = exports.PlayerRings = exports.PlayerSpotlights = exports.PlayerSetsStatusV2 = exports.PlayerSetsAvailability = exports.PlayerSetsStatus = void 0;
exports.PlayerCrafts_InputsEntry = exports.PlayerCrafts = exports.PlayerSetsSubtitle = exports.PlayerSetsIsNpc = exports.PlayerSetsManualVideoSrc = exports.RequestToLeadRespondedTo = exports.RequestToLeadCanceled = exports.PlayerRequestsToLeadV2 = exports.PlayerRequestsToLead = exports.PlayerSetsFollowTarget = exports.PlayerNotifies = exports.PlayerTriggersObject = exports.PlayerSetsItemString = exports.PlayerUpdatesFocusModeStatus = exports.CustomEvent = exports.PlayerBlocks = exports.PlayerSetsActivityStatus = exports.PlayerSetsAmbientPlayersMuted_AmbientPlayersMutedEntry = exports.PlayerSetsAmbientPlayersMuted = exports.PlayerSetsFocusModeEndTime = exports.SpaceStopsSound = exports.SpacePlaysSound = exports.PlayerSetsIsAlone = exports.PlayerSetsSpeedModifier = exports.PlayerSetsVehicleId = exports.PlayerSetsGoKartId = exports.PlayerSetsInConversation = exports.PlayerSetsEventStatus = exports.PlayerShootsConfetti = exports.SpaceSetsIdMapping = exports.SpaceSetsActiveMobileUsers_MobileUsersEntry = exports.SpaceSetsActiveMobileUsers = exports.WireSpaceActiveMobileUser = exports.CookieFound = exports.PlayerEntersPortal = exports.SpaceIsClosed = exports.SpaceSetsSpaceUsers_SpaceUsersEntry = exports.SpaceSetsSpaceUsers = exports.WireSpaceUser = exports.DynamicGates = exports.DynamicGate = exports.SpaceOverwrites = exports.PlayerSetsIsSignedIn = exports.PlayerSetsCurrentlyEquippedWearables = exports.PlayerExits = exports.PlayerSetsAffiliation = exports.PlayerSetsEmojiStatus = exports.PlayerSetsIsMobile = exports.PlayerSetsPersonalImageUrl = exports.PlayerSetsProfileImageUrl = void 0;
exports.SetStatus = exports.SetAffiliation = exports.RequestMute = exports.Move = exports.UpdateSubscriptions_MapUpdateIdsEntry = exports.UpdateSubscriptions_SubscriptionsEntry = exports.UpdateSubscriptions = exports.ClientBackupHeartbeat = exports.ClientHeartbeat = exports.ClientServerAction = exports.ClientServerBatch = exports.PlayerLiveCursor = exports.ChatReactsToGift = exports.NookAccessRequestRespondedTo = exports.OfflinePlayerSetsDeskInfo = exports.PlayerShouldSendGrapes = exports.PlayerInvitesAsMember = exports.RespondToRequestPromoteToMember = exports.RequestPromoteToMemberResponseEnum = exports.PromoteToMemberRespondedTo = exports.PlayerRequestsPromoteToMember = exports.PlayerPromotesToMember = exports.ChatCreatesGroupDmChannel = exports.ChatSetsSessionToken = exports.PlayerRequestsToCowork = exports.SpaceRolePermissionOverrideUpdated = exports.SetDeskFromNextAvailableDesk = exports.PlayerGuestPassStatus = exports.AccessRequestRespondedTo = exports.AccessRequestsUpdated = exports.AccessRequest = exports.PlayerSetsAway = exports.SpaceOverCapacityDeniesUser = exports.SpaceSetsCapacity = exports.PlayerSetsDeskInfo = exports.PrecomputedEnterLocation = exports.PlayerSetsAllowScreenPointer = exports.PlayerTriggersInventoryItem = exports.SpaceUpdatesItems_ItemsEntry = exports.SpaceUpdatesItems = exports.PlayerUpdatesInventory_OrderEntry = exports.PlayerUpdatesInventory_ItemsEntry = exports.PlayerUpdatesInventory = exports.SpaceRegistersCommand = exports.PlayerSendsCommand = exports.PlayerHighFives = exports.FXShakeCamera = exports.FXShakeObject = exports.PlayerEditsChatMessage = exports.MapMoveObject = void 0;
exports.Respawn = exports.Spawn = exports.Teleport = exports.SetEmojiStatus = exports.PrecomputeEnter = exports.Enter = exports.Exit = exports.LiveCursor = exports.SetPersonalImageUrl = exports.SetProfileImageUrl = exports.SetPersonalImageId = exports.SetProfileImageId = exports.SetDescription = exports.SetDisplayEmail = exports.SetPhone = exports.SetTimezone = exports.SetStartDate = exports.SetCountry = exports.SetCity = exports.SetTitle = exports.SetPronouns = exports.SetTextStatus = exports.SetName = exports.SetHandRaised = exports.SetEmoteV2 = exports.Shimmy = exports.Ghost = exports.LeaveWhisper = exports.ChatTombstoneMessage = exports.ChatAddUsersToGroupChannel = exports.ReactToObject = exports.InvokeGrapes = exports.EnterWhisper = exports.ActivelySpeaking = exports.InteractWithObject = exports.Notify = exports.ChatV2SendMessage = exports.ChatV2 = exports.Chat = exports.SetImpassable = exports.Block = exports.Kick = exports.Ban = exports.SetScreenPointer = exports.SetImagePointer = exports.Ring = exports.Spotlight = exports.SetCurrentlyEquippedWearables = exports.SetStatusV2 = exports.SetAvailability = void 0;
exports.RespondToAccessRequest = exports.RequestAccessViaCheckIn = exports.SetAway = exports.Wave = exports.SetDeskInfo = exports.SetAllowScreenPointer = exports.TriggerInventoryItem = exports.HipToBeSquare = exports.RemoveInventoryItem = exports.AddInventoryItem = exports.HighFive = exports.Craft_InputsEntry = exports.Craft = exports.RegisterCommand = exports.SendCommand = exports.ChatMessageUpdated = exports.ChatReply = exports.SpeakerUpdatesSession = exports.MapCommitsChanges = exports.SetSubtitle = exports.SetManualVideoSrc = exports.EnterPortal = exports.RespondToRequestToLead = exports.CancelRequestToLead = exports.RequestToLead = exports.SetFollowTarget = exports.CustomAction = exports.TriggerObject = exports.SetItemString = exports.SetMobileLastActive = exports.SetActivityStatus = exports.SetAmbientPlayersMuted_AmbientPlayersMutedEntry = exports.SetAmbientPlayersMuted = exports.SetFocusModeEndTime = exports.StopSound = exports.PlaySound = exports.SetIsMobile = exports.SetIsAlone = exports.SetSpeedModifier = exports.SetVehicleId = exports.SetInConversation = exports.SetEventStatus = exports.ShootConfetti = exports.MapUpdateObjects_ObjectsEntry = exports.MapUpdateObjects = exports.MapAddObject = exports.Init = exports.UpdateNookPermission = exports.RequestToJoinNook = exports.RespawnAtDesk = void 0;
exports.protobufWriterLibrary = exports.GetAnnotationSessions = exports.RequestPromoteToMember = exports.PromoteToMember = exports.MapDeleteObjectsById = exports.MapAddObjects = exports.ChatInitiateDm = exports.ChatRefreshSessionToken = exports.RequestToCowork = exports.StopRecording = exports.StartRecording = exports.SetSpaceRolePermissionOverride = void 0;
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = "";
var SpriteDirectionEnum_ENUM;
(function (SpriteDirectionEnum_ENUM) {
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["Stand"] = 0] = "Stand";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["Down"] = 1] = "Down";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["DownAlt"] = 2] = "DownAlt";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["Up"] = 3] = "Up";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["UpAlt"] = 4] = "UpAlt";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["Left"] = 5] = "Left";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["LeftAlt"] = 6] = "LeftAlt";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["Right"] = 7] = "Right";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["RightAlt"] = 8] = "RightAlt";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["Dance1"] = 9] = "Dance1";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["Dance2"] = 10] = "Dance2";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["Dance3"] = 11] = "Dance3";
    SpriteDirectionEnum_ENUM[SpriteDirectionEnum_ENUM["Dance4"] = 12] = "Dance4";
})(SpriteDirectionEnum_ENUM || (exports.SpriteDirectionEnum_ENUM = SpriteDirectionEnum_ENUM = {}));
var MoveDirectionEnum_ENUM;
(function (MoveDirectionEnum_ENUM) {
    MoveDirectionEnum_ENUM[MoveDirectionEnum_ENUM["Left"] = 0] = "Left";
    MoveDirectionEnum_ENUM[MoveDirectionEnum_ENUM["Right"] = 1] = "Right";
    MoveDirectionEnum_ENUM[MoveDirectionEnum_ENUM["Up"] = 2] = "Up";
    MoveDirectionEnum_ENUM[MoveDirectionEnum_ENUM["Down"] = 3] = "Down";
    MoveDirectionEnum_ENUM[MoveDirectionEnum_ENUM["Dance"] = 4] = "Dance";
})(MoveDirectionEnum_ENUM || (exports.MoveDirectionEnum_ENUM = MoveDirectionEnum_ENUM = {}));
var InteractionEnum_ENUM;
(function (InteractionEnum_ENUM) {
    InteractionEnum_ENUM[InteractionEnum_ENUM["NONE"] = 0] = "NONE";
    InteractionEnum_ENUM[InteractionEnum_ENUM["EMBEDDED_WEBSITE"] = 1] = "EMBEDDED_WEBSITE";
    InteractionEnum_ENUM[InteractionEnum_ENUM["POSTER"] = 2] = "POSTER";
    InteractionEnum_ENUM[InteractionEnum_ENUM["VIDEO"] = 3] = "VIDEO";
    InteractionEnum_ENUM[InteractionEnum_ENUM["EXTERNAL_CALL"] = 4] = "EXTERNAL_CALL";
    InteractionEnum_ENUM[InteractionEnum_ENUM["EXTENSION"] = 5] = "EXTENSION";
    InteractionEnum_ENUM[InteractionEnum_ENUM["NOTE"] = 6] = "NOTE";
    InteractionEnum_ENUM[InteractionEnum_ENUM["MODAL_EXTENSION"] = 7] = "MODAL_EXTENSION";
    InteractionEnum_ENUM[InteractionEnum_ENUM["COMPONENT_MODAL"] = 8] = "COMPONENT_MODAL";
    InteractionEnum_ENUM[InteractionEnum_ENUM["SIDE_PANEL_TRIGGER"] = 9] = "SIDE_PANEL_TRIGGER";
})(InteractionEnum_ENUM || (exports.InteractionEnum_ENUM = InteractionEnum_ENUM = {}));
var RequestToLeadResponseEnum_ENUM;
(function (RequestToLeadResponseEnum_ENUM) {
    RequestToLeadResponseEnum_ENUM[RequestToLeadResponseEnum_ENUM["ACCEPTED"] = 0] = "ACCEPTED";
    RequestToLeadResponseEnum_ENUM[RequestToLeadResponseEnum_ENUM["DECLINED"] = 1] = "DECLINED";
    RequestToLeadResponseEnum_ENUM[RequestToLeadResponseEnum_ENUM["IGNORED"] = 2] = "IGNORED";
})(RequestToLeadResponseEnum_ENUM || (exports.RequestToLeadResponseEnum_ENUM = RequestToLeadResponseEnum_ENUM = {}));
var ChatV2ChannelTypeEnum_ENUM;
(function (ChatV2ChannelTypeEnum_ENUM) {
    ChatV2ChannelTypeEnum_ENUM[ChatV2ChannelTypeEnum_ENUM["UNKNOWN"] = 0] = "UNKNOWN";
    ChatV2ChannelTypeEnum_ENUM[ChatV2ChannelTypeEnum_ENUM["EVERYONE"] = 1] = "EVERYONE";
    ChatV2ChannelTypeEnum_ENUM[ChatV2ChannelTypeEnum_ENUM["NOOK"] = 2] = "NOOK";
    ChatV2ChannelTypeEnum_ENUM[ChatV2ChannelTypeEnum_ENUM["DM"] = 3] = "DM";
    ChatV2ChannelTypeEnum_ENUM[ChatV2ChannelTypeEnum_ENUM["CANONICAL_DM"] = 4] = "CANONICAL_DM";
})(ChatV2ChannelTypeEnum_ENUM || (exports.ChatV2ChannelTypeEnum_ENUM = ChatV2ChannelTypeEnum_ENUM = {}));
var ChatV2ActionTypeEnum_ENUM;
(function (ChatV2ActionTypeEnum_ENUM) {
    ChatV2ActionTypeEnum_ENUM[ChatV2ActionTypeEnum_ENUM["MESSAGE"] = 0] = "MESSAGE";
    ChatV2ActionTypeEnum_ENUM[ChatV2ActionTypeEnum_ENUM["ATTACHMENT"] = 1] = "ATTACHMENT";
    ChatV2ActionTypeEnum_ENUM[ChatV2ActionTypeEnum_ENUM["EDIT"] = 2] = "EDIT";
    ChatV2ActionTypeEnum_ENUM[ChatV2ActionTypeEnum_ENUM["DELETE"] = 3] = "DELETE";
    ChatV2ActionTypeEnum_ENUM[ChatV2ActionTypeEnum_ENUM["REACT"] = 4] = "REACT";
})(ChatV2ActionTypeEnum_ENUM || (exports.ChatV2ActionTypeEnum_ENUM = ChatV2ActionTypeEnum_ENUM = {}));
var DeskPodMode_ENUM;
(function (DeskPodMode_ENUM) {
    DeskPodMode_ENUM[DeskPodMode_ENUM["Ambient"] = 0] = "Ambient";
    DeskPodMode_ENUM[DeskPodMode_ENUM["Cubicle"] = 1] = "Cubicle";
})(DeskPodMode_ENUM || (exports.DeskPodMode_ENUM = DeskPodMode_ENUM = {}));
var WireMappableKind_ENUM;
(function (WireMappableKind_ENUM) {
    WireMappableKind_ENUM[WireMappableKind_ENUM["GameObject"] = 0] = "GameObject";
    WireMappableKind_ENUM[WireMappableKind_ENUM["Floor"] = 1] = "Floor";
    WireMappableKind_ENUM[WireMappableKind_ENUM["MeetingArea"] = 2] = "MeetingArea";
    WireMappableKind_ENUM[WireMappableKind_ENUM["CoworkingArea"] = 3] = "CoworkingArea";
})(WireMappableKind_ENUM || (exports.WireMappableKind_ENUM = WireMappableKind_ENUM = {}));
var Annotation_Tool;
(function (Annotation_Tool) {
    Annotation_Tool[Annotation_Tool["Pencil"] = 0] = "Pencil";
    Annotation_Tool[Annotation_Tool["Rectangle"] = 1] = "Rectangle";
    Annotation_Tool[Annotation_Tool["Ellipse"] = 2] = "Ellipse";
    Annotation_Tool[Annotation_Tool["Arrow"] = 3] = "Arrow";
    Annotation_Tool[Annotation_Tool["Text"] = 4] = "Text";
    Annotation_Tool[Annotation_Tool["Sticker"] = 5] = "Sticker";
    Annotation_Tool[Annotation_Tool["Laser"] = 6] = "Laser";
    Annotation_Tool[Annotation_Tool["Eraser"] = 7] = "Eraser";
    Annotation_Tool[Annotation_Tool["Cursor"] = 8] = "Cursor";
    Annotation_Tool[Annotation_Tool["Triangle"] = 9] = "Triangle";
    Annotation_Tool[Annotation_Tool["Line"] = 10] = "Line";
})(Annotation_Tool || (exports.Annotation_Tool = Annotation_Tool = {}));
var Annotation_AnnotationSession;
(function (Annotation_AnnotationSession) {
    Annotation_AnnotationSession[Annotation_AnnotationSession["SuccessfulOperation"] = 0] = "SuccessfulOperation";
    Annotation_AnnotationSession[Annotation_AnnotationSession["SessionNotFound"] = 1] = "SessionNotFound";
    Annotation_AnnotationSession[Annotation_AnnotationSession["DrawerNotFound"] = 2] = "DrawerNotFound";
    Annotation_AnnotationSession[Annotation_AnnotationSession["AnnotationNotFound"] = 3] = "AnnotationNotFound";
})(Annotation_AnnotationSession || (exports.Annotation_AnnotationSession = Annotation_AnnotationSession = {}));
var AnnotationDelta_Type;
(function (AnnotationDelta_Type) {
    AnnotationDelta_Type[AnnotationDelta_Type["Add"] = 0] = "Add";
    AnnotationDelta_Type[AnnotationDelta_Type["Delete"] = 1] = "Delete";
    AnnotationDelta_Type[AnnotationDelta_Type["Resize"] = 2] = "Resize";
    AnnotationDelta_Type[AnnotationDelta_Type["Move"] = 3] = "Move";
})(AnnotationDelta_Type || (exports.AnnotationDelta_Type = AnnotationDelta_Type = {}));
var RequestPromoteToMemberResponseEnum_ENUM;
(function (RequestPromoteToMemberResponseEnum_ENUM) {
    RequestPromoteToMemberResponseEnum_ENUM[RequestPromoteToMemberResponseEnum_ENUM["ACCEPTED"] = 0] = "ACCEPTED";
    RequestPromoteToMemberResponseEnum_ENUM[RequestPromoteToMemberResponseEnum_ENUM["DECLINED"] = 1] = "DECLINED";
    RequestPromoteToMemberResponseEnum_ENUM[RequestPromoteToMemberResponseEnum_ENUM["IGNORED"] = 2] = "IGNORED";
})(RequestPromoteToMemberResponseEnum_ENUM || (exports.RequestPromoteToMemberResponseEnum_ENUM = RequestPromoteToMemberResponseEnum_ENUM = {}));
var RespondToAccessRequest_LocationTypeEnum;
(function (RespondToAccessRequest_LocationTypeEnum) {
    RespondToAccessRequest_LocationTypeEnum[RespondToAccessRequest_LocationTypeEnum["MyLocation"] = 0] = "MyLocation";
    RespondToAccessRequest_LocationTypeEnum[RespondToAccessRequest_LocationTypeEnum["DefaultSpawn"] = 1] = "DefaultSpawn";
    RespondToAccessRequest_LocationTypeEnum[RespondToAccessRequest_LocationTypeEnum["SpecificNook"] = 2] = "SpecificNook";
})(RespondToAccessRequest_LocationTypeEnum || (exports.RespondToAccessRequest_LocationTypeEnum = RespondToAccessRequest_LocationTypeEnum = {}));
var StopRecording_Reason;
(function (StopRecording_Reason) {
    StopRecording_Reason[StopRecording_Reason["Intentional"] = 0] = "Intentional";
    StopRecording_Reason[StopRecording_Reason["RecordingClientExited"] = 1] = "RecordingClientExited";
    StopRecording_Reason[StopRecording_Reason["MaxRecordingLengthExceeded"] = 2] = "MaxRecordingLengthExceeded";
    StopRecording_Reason[StopRecording_Reason["EveryoneLeft"] = 3] = "EveryoneLeft";
    StopRecording_Reason[StopRecording_Reason["StuckConnectingLimit"] = 4] = "StuckConnectingLimit";
    StopRecording_Reason[StopRecording_Reason["ObstructionDetected"] = 5] = "ObstructionDetected";
    StopRecording_Reason[StopRecording_Reason["RecordingInitializeTimeout"] = 6] = "RecordingInitializeTimeout";
    StopRecording_Reason[StopRecording_Reason["NoVideosDetected"] = 7] = "NoVideosDetected";
    StopRecording_Reason[StopRecording_Reason["InitFailure"] = 8] = "InitFailure";
    StopRecording_Reason[StopRecording_Reason["NoVideosDetectedOnStart"] = 9] = "NoVideosDetectedOnStart";
})(StopRecording_Reason || (exports.StopRecording_Reason = StopRecording_Reason = {}));
function createBaseDeprecated() {
    return {};
}
exports.Deprecated = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeprecated();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpriteDirectionEnum() {
    return {};
}
exports.SpriteDirectionEnum = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpriteDirectionEnum();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMoveDirectionEnum() {
    return {};
}
exports.MoveDirectionEnum = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMoveDirectionEnum();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseInteractionEnum() {
    return {};
}
exports.InteractionEnum = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInteractionEnum();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestToLeadResponseEnum() {
    return {};
}
exports.RequestToLeadResponseEnum = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestToLeadResponseEnum();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatV2ChannelTypeEnum() {
    return {};
}
exports.ChatV2ChannelTypeEnum = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatV2ChannelTypeEnum();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatV2ActionTypeEnum() {
    return {};
}
exports.ChatV2ActionTypeEnum = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatV2ActionTypeEnum();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerInitInfo() {
    return {};
}
exports.PlayerInitInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.x !== undefined) {
            writer.uint32(24).uint32(message.x);
        }
        if (message.y !== undefined) {
            writer.uint32(32).uint32(message.y);
        }
        if (message.map !== undefined) {
            writer.uint32(42).string(message.map);
        }
        if (message.affiliation !== undefined) {
            writer.uint32(50).string(message.affiliation);
        }
        if (message.busy !== undefined) {
            writer.uint32(56).bool(message.busy);
        }
        if (message.textStatus !== undefined) {
            writer.uint32(66).string(message.textStatus);
        }
        if (message.emojiStatus !== undefined) {
            writer.uint32(74).string(message.emojiStatus);
        }
        if (message.currentlyEquippedWearables !== undefined) {
            exports.DBOutfit.encode(message.currentlyEquippedWearables, writer.uint32(82).fork()).ldelim();
        }
        if (message.focusModeEndTime !== undefined) {
            writer.uint32(90).string(message.focusModeEndTime);
        }
        if (message.itemString !== undefined) {
            writer.uint32(114).string(message.itemString);
        }
        if (message.isNpc !== undefined) {
            writer.uint32(120).bool(message.isNpc);
        }
        if (message.status !== undefined) {
            writer.uint32(130).string(message.status);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerInitInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.map = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.affiliation = reader.string();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.busy = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.textStatus = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.emojiStatus = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.currentlyEquippedWearables = exports.DBOutfit.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.focusModeEndTime = reader.string();
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.itemString = reader.string();
                    continue;
                case 15:
                    if (tag !== 120) {
                        break;
                    }
                    message.isNpc = reader.bool();
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.status = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseDBOutfit() {
    return { skin: "", hair: "", facial_hair: "", top: "", bottom: "", shoes: "", hat: "", glasses: "", other: "" };
}
exports.DBOutfit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.skin !== "") {
            writer.uint32(10).string(message.skin);
        }
        if (message.hair !== "") {
            writer.uint32(18).string(message.hair);
        }
        if (message.facial_hair !== "") {
            writer.uint32(26).string(message.facial_hair);
        }
        if (message.top !== "") {
            writer.uint32(34).string(message.top);
        }
        if (message.bottom !== "") {
            writer.uint32(42).string(message.bottom);
        }
        if (message.shoes !== "") {
            writer.uint32(50).string(message.shoes);
        }
        if (message.hat !== "") {
            writer.uint32(58).string(message.hat);
        }
        if (message.glasses !== "") {
            writer.uint32(66).string(message.glasses);
        }
        if (message.other !== "") {
            writer.uint32(74).string(message.other);
        }
        if (message.costume !== undefined) {
            writer.uint32(82).string(message.costume);
        }
        if (message.mobility !== undefined) {
            writer.uint32(90).string(message.mobility);
        }
        if (message.jacket !== undefined) {
            writer.uint32(98).string(message.jacket);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDBOutfit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.skin = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.hair = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.facial_hair = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.top = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.bottom = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.shoes = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.hat = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.glasses = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.other = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.costume = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.mobility = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.jacket = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireObjectSpritesheetFraming() {
    return { frameWidth: 0, frameHeight: 0 };
}
exports.WireObjectSpritesheetFraming = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.frameWidth !== 0) {
            writer.uint32(8).int32(message.frameWidth);
        }
        if (message.frameHeight !== 0) {
            writer.uint32(16).int32(message.frameHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireObjectSpritesheetFraming();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.frameWidth = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.frameHeight = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireObjectSpriteAnimConfig() {
    return { sequence: [], frameRate: 0 };
}
exports.WireObjectSpriteAnimConfig = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.useSequenceAsRange !== undefined) {
            writer.uint32(8).bool(message.useSequenceAsRange);
        }
        writer.uint32(18).fork();
        for (const v of message.sequence) {
            writer.uint32(v);
        }
        writer.ldelim();
        if (message.loop !== undefined) {
            writer.uint32(24).bool(message.loop);
        }
        if (message.frameRate !== 0) {
            writer.uint32(32).uint32(message.frameRate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireObjectSpriteAnimConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.useSequenceAsRange = reader.bool();
                    continue;
                case 2:
                    if (tag === 16) {
                        message.sequence.push(reader.uint32());
                        continue;
                    }
                    if (tag === 18) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.sequence.push(reader.uint32());
                        }
                        continue;
                    }
                    break;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.loop = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.frameRate = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireObjectSpritesheet() {
    return { spritesheetUrl: "", framing: undefined, animations: {} };
}
exports.WireObjectSpritesheet = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spritesheetUrl !== "") {
            writer.uint32(10).string(message.spritesheetUrl);
        }
        if (message.framing !== undefined) {
            exports.WireObjectSpritesheetFraming.encode(message.framing, writer.uint32(18).fork()).ldelim();
        }
        Object.entries(message.animations).forEach(([key, value]) => {
            exports.WireObjectSpritesheet_AnimationsEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        if (message.currentAnim !== undefined) {
            writer.uint32(34).string(message.currentAnim);
        }
        if (message.pauseAnimationsIfFpsBelowFramerate !== undefined) {
            writer.uint32(40).bool(message.pauseAnimationsIfFpsBelowFramerate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireObjectSpritesheet();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spritesheetUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.framing = exports.WireObjectSpritesheetFraming.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    const entry3 = exports.WireObjectSpritesheet_AnimationsEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.animations[entry3.key] = entry3.value;
                    }
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.currentAnim = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.pauseAnimationsIfFpsBelowFramerate = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireObjectSpritesheet_AnimationsEntry() {
    return { key: "", value: undefined };
}
exports.WireObjectSpritesheet_AnimationsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.WireObjectSpriteAnimConfig.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireObjectSpritesheet_AnimationsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.WireObjectSpriteAnimConfig.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireObject() {
    return { _tags: [] };
}
exports.WireObject = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.templateId !== undefined) {
            writer.uint32(10).string(message.templateId);
        }
        if (message._name !== undefined) {
            writer.uint32(18).string(message._name);
        }
        for (const v of message._tags) {
            writer.uint32(26).string(v);
        }
        if (message.x !== undefined) {
            writer.uint32(32).uint32(message.x);
        }
        if (message.y !== undefined) {
            writer.uint32(40).uint32(message.y);
        }
        if (message.offsetX !== undefined) {
            writer.uint32(53).float(message.offsetX);
        }
        if (message.offsetY !== undefined) {
            writer.uint32(61).float(message.offsetY);
        }
        if (message.color !== undefined) {
            writer.uint32(66).string(message.color);
        }
        if (message.orientation !== undefined) {
            writer.uint32(72).uint32(message.orientation);
        }
        if (message.normal !== undefined) {
            writer.uint32(82).string(message.normal);
        }
        if (message.highlighted !== undefined) {
            writer.uint32(90).string(message.highlighted);
        }
        if (message.type !== undefined) {
            writer.uint32(96).int32(message.type);
        }
        if (message.width !== undefined) {
            writer.uint32(104).uint32(message.width);
        }
        if (message.height !== undefined) {
            writer.uint32(112).uint32(message.height);
        }
        if (message.extensionClass !== undefined) {
            writer.uint32(122).string(message.extensionClass);
        }
        if (message.previewMessage !== undefined) {
            writer.uint32(130).string(message.previewMessage);
        }
        if (message.distThreshold !== undefined) {
            writer.uint32(136).uint32(message.distThreshold);
        }
        if (message.propertiesJson !== undefined) {
            writer.uint32(146).string(message.propertiesJson);
        }
        if (message.sound !== undefined) {
            exports.Sound.encode(message.sound, writer.uint32(154).fork()).ldelim();
        }
        if (message.objectStartTime !== undefined) {
            exports.ObjectTime.encode(message.objectStartTime, writer.uint32(162).fork()).ldelim();
        }
        if (message.objectExpireTime !== undefined) {
            exports.ObjectTime.encode(message.objectExpireTime, writer.uint32(170).fork()).ldelim();
        }
        if (message.id !== undefined) {
            writer.uint32(178).string(message.id);
        }
        if (message.customState !== undefined) {
            writer.uint32(186).string(message.customState);
        }
        if (message.objectPlacerId !== undefined) {
            writer.uint32(194).string(message.objectPlacerId);
        }
        if (message.numGoKarts !== undefined) {
            writer.uint32(200).uint32(message.numGoKarts);
        }
        if (message.spritesheet !== undefined) {
            exports.WireObjectSpritesheet.encode(message.spritesheet, writer.uint32(210).fork()).ldelim();
        }
        if (message.zIndex !== undefined) {
            writer.uint32(221).float(message.zIndex);
        }
        if (message.text !== undefined) {
            exports.Text.encode(message.text, writer.uint32(226).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.templateId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message._name = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message._tags.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 53) {
                        break;
                    }
                    message.offsetX = reader.float();
                    continue;
                case 7:
                    if (tag !== 61) {
                        break;
                    }
                    message.offsetY = reader.float();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.orientation = reader.uint32();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.normal = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.highlighted = reader.string();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.width = reader.uint32();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.height = reader.uint32();
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.extensionClass = reader.string();
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.previewMessage = reader.string();
                    continue;
                case 17:
                    if (tag !== 136) {
                        break;
                    }
                    message.distThreshold = reader.uint32();
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.propertiesJson = reader.string();
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.sound = exports.Sound.decode(reader, reader.uint32());
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.objectStartTime = exports.ObjectTime.decode(reader, reader.uint32());
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.objectExpireTime = exports.ObjectTime.decode(reader, reader.uint32());
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.customState = reader.string();
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.objectPlacerId = reader.string();
                    continue;
                case 25:
                    if (tag !== 200) {
                        break;
                    }
                    message.numGoKarts = reader.uint32();
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.spritesheet = exports.WireObjectSpritesheet.decode(reader, reader.uint32());
                    continue;
                case 27:
                    if (tag !== 221) {
                        break;
                    }
                    message.zIndex = reader.float();
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.text = exports.Text.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseBackedUpDeskObject() {
    return { obj: undefined, offsetX: 0, offsetY: 0 };
}
exports.BackedUpDeskObject = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.obj !== undefined) {
            exports.WireObject.encode(message.obj, writer.uint32(10).fork()).ldelim();
        }
        if (message.offsetX !== 0) {
            writer.uint32(16).int32(message.offsetX);
        }
        if (message.offsetY !== 0) {
            writer.uint32(24).int32(message.offsetY);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBackedUpDeskObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.obj = exports.WireObject.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.offsetX = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.offsetY = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseDeskObjects() {
    return { objects: {} };
}
exports.DeskObjects = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.objects).forEach(([key, value]) => {
            exports.DeskObjects_ObjectsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeskObjects();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.DeskObjects_ObjectsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.objects[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseDeskObjects_ObjectsEntry() {
    return { key: "", value: undefined };
}
exports.DeskObjects_ObjectsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.BackedUpDeskObject.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeskObjects_ObjectsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.BackedUpDeskObject.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseDeskInfoV2() {
    return {};
}
exports.DeskInfoV2 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.deskId !== undefined) {
            writer.uint32(10).string(message.deskId);
        }
        if (message.locked !== undefined) {
            writer.uint32(24).bool(message.locked);
        }
        if (message.lastDeskObjects !== undefined) {
            exports.DeskObjects.encode(message.lastDeskObjects, writer.uint32(34).fork()).ldelim();
        }
        if (message.mapId !== undefined) {
            writer.uint32(42).string(message.mapId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeskInfoV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.deskId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.locked = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.lastDeskObjects = exports.DeskObjects.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapAndDesk() {
    return { mapId: "", deskId: "" };
}
exports.MapAndDesk = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.deskId !== "") {
            writer.uint32(18).string(message.deskId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapAndDesk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.deskId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSound() {
    return { src: "", volume: 0, loop: false, maxDistance: 0 };
}
exports.Sound = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.src !== "") {
            writer.uint32(10).string(message.src);
        }
        if (message.volume !== 0) {
            writer.uint32(21).float(message.volume);
        }
        if (message.loop === true) {
            writer.uint32(24).bool(message.loop);
        }
        if (message.maxDistance !== 0) {
            writer.uint32(32).uint32(message.maxDistance);
        }
        if (message.isPositional !== undefined) {
            writer.uint32(40).bool(message.isPositional);
        }
        if (message.stream !== undefined) {
            writer.uint32(48).bool(message.stream);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSound();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.src = reader.string();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.volume = reader.float();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.loop = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.maxDistance = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.isPositional = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.stream = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseText() {
    return { text: "", size: 0, font: "", color: "" };
}
exports.Text = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        if (message.size !== 0) {
            writer.uint32(16).uint32(message.size);
        }
        if (message.font !== "") {
            writer.uint32(26).string(message.font);
        }
        if (message.color !== "") {
            writer.uint32(34).string(message.color);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseText();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.size = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.font = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseObjectTime() {
    return { _seconds: 0 };
}
exports.ObjectTime = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message._seconds !== 0) {
            writer.uint32(8).uint32(message._seconds);
        }
        if (message._timezone !== undefined) {
            writer.uint32(18).string(message._timezone);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseObjectTime();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message._seconds = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message._timezone = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpace() {
    return { spaceId: "", x: 0, y: 0 };
}
exports.Space = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        if (message.x !== 0) {
            writer.uint32(16).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(24).uint32(message.y);
        }
        if (message.colored !== undefined) {
            writer.uint32(32).bool(message.colored);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpace();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.colored = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseNookCoords() {
    return { coords: [] };
}
exports.NookCoords = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.coords) {
            exports.WirePoint.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNookCoords();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.coords.push(exports.WirePoint.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAllowedUsers() {
    return { users: [] };
}
exports.AllowedUsers = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.users) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAllowedUsers();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.users.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestUser() {
    return {};
}
exports.RequestUser = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestUser();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestedUsers() {
    return { users: {} };
}
exports.RequestedUsers = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.users).forEach(([key, value]) => {
            exports.RequestedUsers_UsersEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestedUsers();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.RequestedUsers_UsersEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.users[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestedUsers_UsersEntry() {
    return { key: "", value: undefined };
}
exports.RequestedUsers_UsersEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.RequestUser.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestedUsers_UsersEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.RequestUser.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRecordingInfo() {
    return {};
}
exports.RecordingInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.initiatingPlayer !== undefined) {
            writer.uint32(10).string(message.initiatingPlayer);
        }
        if (message.recordingClientId !== undefined) {
            writer.uint32(42).string(message.recordingClientId);
        }
        if (message.initiatedAtMs !== undefined) {
            writer.uint32(48).uint64(message.initiatedAtMs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRecordingInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.initiatingPlayer = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.recordingClientId = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.initiatedAtMs = longToNumber(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseCoworkingInfo() {
    return {};
}
exports.CoworkingInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.statusMessage !== undefined) {
            writer.uint32(10).string(message.statusMessage);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCoworkingInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.statusMessage = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseNookDiff() {
    return {};
}
exports.NookDiff = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.nookCoords !== undefined) {
            exports.NookCoords.encode(message.nookCoords, writer.uint32(10).fork()).ldelim();
        }
        if (message.colored !== undefined) {
            writer.uint32(16).bool(message.colored);
        }
        if (message.name !== undefined) {
            writer.uint32(26).string(message.name);
        }
        if (message.bookable !== undefined) {
            writer.uint32(32).bool(message.bookable);
        }
        if (message.capacity !== undefined) {
            writer.uint32(40).uint32(message.capacity);
        }
        if (message.restricted !== undefined) {
            writer.uint32(48).bool(message.restricted);
        }
        if (message.allowedUsers !== undefined) {
            exports.AllowedUsers.encode(message.allowedUsers, writer.uint32(58).fork()).ldelim();
        }
        if (message.requestedUsers !== undefined) {
            exports.RequestedUsers.encode(message.requestedUsers, writer.uint32(66).fork()).ldelim();
        }
        if (message.isInMeeting !== undefined) {
            writer.uint32(72).bool(message.isInMeeting);
        }
        if (message.isDesk !== undefined) {
            writer.uint32(80).bool(message.isDesk);
        }
        if (message.recordingInfo !== undefined) {
            exports.RecordingInfo.encode(message.recordingInfo, writer.uint32(90).fork()).ldelim();
        }
        if (message.audioLocked !== undefined) {
            writer.uint32(96).bool(message.audioLocked);
        }
        if (message.isAmbient !== undefined) {
            writer.uint32(104).bool(message.isAmbient);
        }
        if (message.isCoworking !== undefined) {
            writer.uint32(112).bool(message.isCoworking);
        }
        if (message.coworkingInfo !== undefined) {
            exports.CoworkingInfo.encode(message.coworkingInfo, writer.uint32(122).fork()).ldelim();
        }
        if (message.chatChannelUrl !== undefined) {
            writer.uint32(130).string(message.chatChannelUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNookDiff();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.nookCoords = exports.NookCoords.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.colored = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.bookable = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.capacity = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.restricted = reader.bool();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.allowedUsers = exports.AllowedUsers.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.requestedUsers = exports.RequestedUsers.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.isInMeeting = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.isDesk = reader.bool();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.recordingInfo = exports.RecordingInfo.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.audioLocked = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.isAmbient = reader.bool();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.isCoworking = reader.bool();
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.coworkingInfo = exports.CoworkingInfo.decode(reader, reader.uint32());
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.chatChannelUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWirePoint() {
    return { x: 0, y: 0 };
}
exports.WirePoint = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.x !== 0) {
            writer.uint32(8).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(16).uint32(message.y);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWirePoint();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpawnPoint() {
    return { x: 0, y: 0 };
}
exports.SpawnPoint = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.x !== 0) {
            writer.uint32(8).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(16).uint32(message.y);
        }
        if (message.spawnId !== undefined) {
            writer.uint32(26).string(message.spawnId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpawnPoint();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.spawnId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePortal() {
    return { x: 0, y: 0 };
}
exports.Portal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.x !== 0) {
            writer.uint32(8).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(16).uint32(message.y);
        }
        if (message.targetMap !== undefined) {
            writer.uint32(26).string(message.targetMap);
        }
        if (message.targetUrl !== undefined) {
            writer.uint32(34).string(message.targetUrl);
        }
        if (message.targetX !== undefined) {
            writer.uint32(40).uint32(message.targetX);
        }
        if (message.targetY !== undefined) {
            writer.uint32(48).uint32(message.targetY);
        }
        if (message.twoWay !== undefined) {
            writer.uint32(56).bool(message.twoWay);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePortal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.targetMap = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.targetUrl = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.targetX = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.targetY = reader.uint32();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.twoWay = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAnnouncer() {
    return { x: 0, y: 0 };
}
exports.Announcer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.x !== 0) {
            writer.uint32(8).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(16).uint32(message.y);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAnnouncer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAsset() {
    return { x: 0, y: 0, src: "" };
}
exports.Asset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.x !== 0) {
            writer.uint32(13).float(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(21).float(message.y);
        }
        if (message.src !== "") {
            writer.uint32(26).string(message.src);
        }
        if (message.width !== undefined) {
            writer.uint32(32).uint32(message.width);
        }
        if (message.height !== undefined) {
            writer.uint32(40).uint32(message.height);
        }
        if (message.inFront !== undefined) {
            writer.uint32(48).bool(message.inFront);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAsset();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.x = reader.float();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.y = reader.float();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.src = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.width = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.height = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.inFront = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAreaPosition() {
    return { x1: 0, y1: 0, x2: 0, y2: 0 };
}
exports.AreaPosition = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.x1 !== 0) {
            writer.uint32(8).uint32(message.x1);
        }
        if (message.y1 !== 0) {
            writer.uint32(16).uint32(message.y1);
        }
        if (message.x2 !== 0) {
            writer.uint32(24).uint32(message.x2);
        }
        if (message.y2 !== 0) {
            writer.uint32(32).uint32(message.y2);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAreaPosition();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.x1 = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.y1 = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.x2 = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.y2 = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAreaMetaData() {
    return {};
}
exports.AreaMetaData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.statusMessage !== undefined) {
            writer.uint32(10).string(message.statusMessage);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAreaMetaData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.statusMessage = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireArea() {
    return { coords: [] };
}
exports.WireArea = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.category !== undefined) {
            writer.uint32(10).string(message.category);
        }
        for (const v of message.coords) {
            exports.AreaPosition.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.metadata !== undefined) {
            exports.AreaMetaData.encode(message.metadata, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireArea();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.category = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.coords.push(exports.AreaPosition.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.metadata = exports.AreaMetaData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseDBDesk() {
    return { coords: [] };
}
exports.DBDesk = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.coords) {
            exports.AreaPosition.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDBDesk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.coords.push(exports.AreaPosition.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseDeskPodCoords() {
    return { coords: [] };
}
exports.DeskPodCoords = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.coords) {
            exports.AreaPosition.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeskPodCoords();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.coords.push(exports.AreaPosition.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseDeskPodMode() {
    return {};
}
exports.DeskPodMode = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeskPodMode();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireDeskPodSettings() {
    return { mode: 0 };
}
exports.WireDeskPodSettings = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mode !== 0) {
            writer.uint32(8).int32(message.mode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireDeskPodSettings();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.mode = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireDeskPod() {
    return {};
}
exports.WireDeskPod = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.deskPodCoords !== undefined) {
            exports.DeskPodCoords.encode(message.deskPodCoords, writer.uint32(18).fork()).ldelim();
        }
        if (message.settings !== undefined) {
            exports.WireDeskPodSettings.encode(message.settings, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireDeskPod();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.deskPodCoords = exports.DeskPodCoords.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.settings = exports.WireDeskPodSettings.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetDimensions() {
    return { mapId: "", width: 0, height: 0 };
}
exports.MapSetDimensions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.width !== 0) {
            writer.uint32(16).uint32(message.width);
        }
        if (message.height !== 0) {
            writer.uint32(24).uint32(message.height);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetDimensions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.width = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.height = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetCollisions() {
    return { mapId: "", x: 0, y: 0, w: 0, h: 0, mask: "" };
}
exports.MapSetCollisions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.x !== 0) {
            writer.uint32(16).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(24).uint32(message.y);
        }
        if (message.w !== 0) {
            writer.uint32(32).uint32(message.w);
        }
        if (message.h !== 0) {
            writer.uint32(40).uint32(message.h);
        }
        if (message.mask !== "") {
            writer.uint32(50).string(message.mask);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetCollisions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.w = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.h = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.mask = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetCollisionsBits() {
    return { mapId: "", overwrite: false, x: 0, y: 0, w: 0, h: 0, mask: new Uint8Array(0) };
}
exports.MapSetCollisionsBits = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.overwrite === true) {
            writer.uint32(16).bool(message.overwrite);
        }
        if (message.x !== 0) {
            writer.uint32(24).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(32).uint32(message.y);
        }
        if (message.w !== 0) {
            writer.uint32(40).uint32(message.w);
        }
        if (message.h !== 0) {
            writer.uint32(48).uint32(message.h);
        }
        if (message.mask.length !== 0) {
            writer.uint32(58).bytes(message.mask);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetCollisionsBits();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.overwrite = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.w = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.h = reader.uint32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.mask = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetBackgroundImagePath() {
    return { mapId: "", backgroundImagePath: "" };
}
exports.MapSetBackgroundImagePath = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.backgroundImagePath !== "") {
            writer.uint32(18).string(message.backgroundImagePath);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetBackgroundImagePath();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.backgroundImagePath = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetForegroundImagePath() {
    return { mapId: "", foregroundImagePath: "" };
}
exports.MapSetForegroundImagePath = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.foregroundImagePath !== "") {
            writer.uint32(18).string(message.foregroundImagePath);
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetForegroundImagePath();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.foregroundImagePath = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetInitialInfo() {
    return { mapId: "", backgroundImagePath: "", foregroundImagePath: "", totalObjects: 0 };
}
exports.MapSetInitialInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.backgroundImagePath !== "") {
            writer.uint32(18).string(message.backgroundImagePath);
        }
        if (message.foregroundImagePath !== "") {
            writer.uint32(26).string(message.foregroundImagePath);
        }
        if (message.totalObjects !== 0) {
            writer.uint32(32).uint32(message.totalObjects);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetInitialInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.backgroundImagePath = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.foregroundImagePath = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.totalObjects = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetNooks() {
    return { mapId: "", nooks: {} };
}
exports.MapSetNooks = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        Object.entries(message.nooks).forEach(([key, value]) => {
            exports.MapSetNooks_NooksEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        if (message.overwrite !== undefined) {
            writer.uint32(24).bool(message.overwrite);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetNooks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.MapSetNooks_NooksEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.nooks[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.overwrite = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetNooks_NooksEntry() {
    return { key: "", value: undefined };
}
exports.MapSetNooks_NooksEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.NookDiff.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetNooks_NooksEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.NookDiff.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetSpawn() {
    return { mapId: "", spawn: undefined };
}
exports.MapSetSpawn = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.spawn !== undefined) {
            exports.WirePoint.encode(message.spawn, writer.uint32(18).fork()).ldelim();
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetSpawn();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.spawn = exports.WirePoint.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetSpawns() {
    return { mapId: "", spawns: [] };
}
exports.MapSetSpawns = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        for (const v of message.spawns) {
            exports.SpawnPoint.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetSpawns();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.spawns.push(exports.SpawnPoint.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetPortals() {
    return { mapId: "", portals: [] };
}
exports.MapSetPortals = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        for (const v of message.portals) {
            exports.Portal.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetPortals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.portals.push(exports.Portal.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetAnnouncer() {
    return { mapId: "", announcer: [] };
}
exports.MapSetAnnouncer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        for (const v of message.announcer) {
            exports.Announcer.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetAnnouncer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.announcer.push(exports.Announcer.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetAssets() {
    return { mapId: "", assets: [] };
}
exports.MapSetAssets = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        for (const v of message.assets) {
            exports.Asset.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetAssets();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.assets.push(exports.Asset.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetObjectsV2() {
    return { mapId: "", objects: {} };
}
exports.MapSetObjectsV2 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        Object.entries(message.objects).forEach(([key, value]) => {
            exports.MapSetObjectsV2_ObjectsEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        if (message.updatesAreOverwrites !== undefined) {
            writer.uint32(24).bool(message.updatesAreOverwrites);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetObjectsV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.MapSetObjectsV2_ObjectsEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.objects[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.updatesAreOverwrites = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetObjectsV2_ObjectsEntry() {
    return { key: "", value: undefined };
}
exports.MapSetObjectsV2_ObjectsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.WireObject.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetObjectsV2_ObjectsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.WireObject.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetName() {
    return { mapId: "", name: "" };
}
exports.MapSetName = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetName();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetMuteOnEntry() {
    return { mapId: "", muteOnEntry: false };
}
exports.MapSetMuteOnEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.muteOnEntry === true) {
            writer.uint32(16).bool(message.muteOnEntry);
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetMuteOnEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.muteOnEntry = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetUseDrawnBG() {
    return { mapId: "", useDrawnBG: false };
}
exports.MapSetUseDrawnBG = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.useDrawnBG === true) {
            writer.uint32(16).bool(message.useDrawnBG);
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetUseDrawnBG();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.useDrawnBG = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetWalls() {
    return { mapId: "", walls: {} };
}
exports.MapSetWalls = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        Object.entries(message.walls).forEach(([key, value]) => {
            exports.MapSetWalls_WallsEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetWalls();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.MapSetWalls_WallsEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.walls[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetWalls_WallsEntry() {
    return { key: "", value: "" };
}
exports.MapSetWalls_WallsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetWalls_WallsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetFloors() {
    return { mapId: "", floors: {} };
}
exports.MapSetFloors = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        Object.entries(message.floors).forEach(([key, value]) => {
            exports.MapSetFloors_FloorsEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetFloors();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.MapSetFloors_FloorsEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.floors[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetFloors_FloorsEntry() {
    return { key: "", value: "" };
}
exports.MapSetFloors_FloorsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetFloors_FloorsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetAreas() {
    return { mapId: "", areas: {} };
}
exports.MapSetAreas = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        Object.entries(message.areas).forEach(([key, value]) => {
            exports.MapSetAreas_AreasEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetAreas();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.MapSetAreas_AreasEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.areas[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetAreas_AreasEntry() {
    return { key: "", value: undefined };
}
exports.MapSetAreas_AreasEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.WireArea.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetAreas_AreasEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.WireArea.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapDeleteObjectByKey() {
    return { mapId: "", key: "" };
}
exports.MapDeleteObjectByKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.key !== "") {
            writer.uint32(18).string(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapDeleteObjectByKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapDeleteObjectById() {
    return { mapId: "", id: "" };
}
exports.MapDeleteObjectById = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapDeleteObjectById();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetMiniMapImagePath() {
    return { mapId: "", miniMapImagePath: "" };
}
exports.MapSetMiniMapImagePath = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.miniMapImagePath !== "") {
            writer.uint32(18).string(message.miniMapImagePath);
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetMiniMapImagePath();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.miniMapImagePath = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetEnabledChats() {
    return { mapId: "", enabledChats: [] };
}
exports.MapSetEnabledChats = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        for (const v of message.enabledChats) {
            writer.uint32(18).string(v);
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetEnabledChats();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.enabledChats.push(reader.string());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetDescription() {
    return { mapId: "", description: "" };
}
exports.MapSetDescription = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetDescription();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetDecoration() {
    return { mapId: "", decoration: "" };
}
exports.MapSetDecoration = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.decoration !== "") {
            writer.uint32(18).string(message.decoration);
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetDecoration();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.decoration = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetTutorialTasks() {
    return { mapId: "", tutorialTasks: undefined };
}
exports.MapSetTutorialTasks = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.tutorialTasks !== undefined) {
            exports.WireTutorialTasks.encode(message.tutorialTasks, writer.uint32(18).fork()).ldelim();
        }
        if (message.delete !== undefined) {
            writer.uint32(24).bool(message.delete);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetTutorialTasks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.tutorialTasks = exports.WireTutorialTasks.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireTutorialTasks() {
    return { groupSetId: "", areas: [] };
}
exports.WireTutorialTasks = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.groupSetId !== "") {
            writer.uint32(10).string(message.groupSetId);
        }
        for (const v of message.areas) {
            exports.TutorialTaskMapArea.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.autoStart !== undefined) {
            writer.uint32(24).bool(message.autoStart);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireTutorialTasks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.groupSetId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.areas.push(exports.TutorialTaskMapArea.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.autoStart = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseTutorialTaskMapArea() {
    return { areaId: "", x: 0, y: 0, height: 0, width: 0 };
}
exports.TutorialTaskMapArea = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.areaId !== "") {
            writer.uint32(10).string(message.areaId);
        }
        if (message.x !== 0) {
            writer.uint32(16).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(24).uint32(message.y);
        }
        if (message.height !== 0) {
            writer.uint32(32).uint32(message.height);
        }
        if (message.width !== 0) {
            writer.uint32(40).uint32(message.width);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTutorialTaskMapArea();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.areaId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.height = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.width = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseInventory() {
    return { items: {}, order: {} };
}
exports.Inventory = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.items).forEach(([key, value]) => {
            exports.Inventory_ItemsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        Object.entries(message.order).forEach(([key, value]) => {
            exports.Inventory_OrderEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInventory();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.Inventory_ItemsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.items[entry1.key] = entry1.value;
                    }
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.Inventory_OrderEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.order[entry2.key] = entry2.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseInventory_ItemsEntry() {
    return { key: "", value: undefined };
}
exports.Inventory_ItemsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.InventoryItem.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInventory_ItemsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.InventoryItem.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseInventory_OrderEntry() {
    return { key: "", value: "" };
}
exports.Inventory_OrderEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInventory_OrderEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseInventoryItem() {
    return { count: 0 };
}
exports.InventoryItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.count !== 0) {
            writer.uint32(8).uint32(message.count);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInventoryItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.count = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceItem() {
    return { name: "", previewUrl: "", meta: {}, abilities: {} };
}
exports.SpaceItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.category !== undefined) {
            writer.uint32(18).string(message.category);
        }
        if (message.description !== undefined) {
            writer.uint32(26).string(message.description);
        }
        if (message.previewUrl !== "") {
            writer.uint32(34).string(message.previewUrl);
        }
        Object.entries(message.meta).forEach(([key, value]) => {
            exports.SpaceItem_MetaEntry.encode({ key: key, value }, writer.uint32(42).fork()).ldelim();
        });
        Object.entries(message.abilities).forEach(([key, value]) => {
            exports.SpaceItem_AbilitiesEntry.encode({ key: key, value }, writer.uint32(50).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.category = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.previewUrl = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    const entry5 = exports.SpaceItem_MetaEntry.decode(reader, reader.uint32());
                    if (entry5.value !== undefined) {
                        message.meta[entry5.key] = entry5.value;
                    }
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    const entry6 = exports.SpaceItem_AbilitiesEntry.decode(reader, reader.uint32());
                    if (entry6.value !== undefined) {
                        message.abilities[entry6.key] = entry6.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceItem_MetaEntry() {
    return { key: "", value: "" };
}
exports.SpaceItem_MetaEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceItem_MetaEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceItem_AbilitiesEntry() {
    return { key: "", value: undefined };
}
exports.SpaceItem_AbilitiesEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.ItemAbility.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceItem_AbilitiesEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.ItemAbility.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseItemAbility() {
    return { name: "" };
}
exports.ItemAbility = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseItemAbility();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapLocation() {
    return { map: "", x: 0, y: 0 };
}
exports.MapLocation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.map !== "") {
            writer.uint32(10).string(message.map);
        }
        if (message.x !== 0) {
            writer.uint32(16).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(24).uint32(message.y);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapLocation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.map = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseActivityStatus() {
    return {};
}
exports.ActivityStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.activeWindowName !== undefined) {
            writer.uint32(10).string(message.activeWindowName);
        }
        if (message.idleTime !== undefined) {
            writer.uint32(16).uint64(message.idleTime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseActivityStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.activeWindowName = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.idleTime = longToNumber(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetDeskPods() {
    return { mapId: "", deskPods: {} };
}
exports.MapSetDeskPods = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        Object.entries(message.deskPods).forEach(([key, value]) => {
            exports.MapSetDeskPods_DeskPodsEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        if (message.overwrite !== undefined) {
            writer.uint32(24).bool(message.overwrite);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetDeskPods();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.MapSetDeskPods_DeskPodsEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.deskPods[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.overwrite = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapSetDeskPods_DeskPodsEntry() {
    return { key: "", value: undefined };
}
exports.MapSetDeskPods_DeskPodsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.WireDeskPod.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapSetDeskPods_DeskPodsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.WireDeskPod.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireAuthored() {
    return { catalogItemId: "" };
}
exports.WireAuthored = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.catalogItemId !== "") {
            writer.uint32(10).string(message.catalogItemId);
        }
        if (message.placerId !== undefined) {
            writer.uint32(18).string(message.placerId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireAuthored();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.catalogItemId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.placerId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireSpatial() {
    return {};
}
exports.WireSpatial = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.width !== undefined) {
            writer.uint32(8).int32(message.width);
        }
        if (message.height !== undefined) {
            writer.uint32(16).int32(message.height);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireSpatial();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.width = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireNameable() {
    return {};
}
exports.WireNameable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== undefined) {
            writer.uint32(10).string(message.name);
        }
        if (message.description !== undefined) {
            writer.uint32(18).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireNameable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireMappableKind() {
    return {};
}
exports.WireMappableKind = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireMappableKind();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireImageRenderable() {
    return {};
}
exports.WireImageRenderable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.backgroundImageUrl !== undefined) {
            writer.uint32(10).string(message.backgroundImageUrl);
        }
        if (message.foregroundImageUrl !== undefined) {
            writer.uint32(18).string(message.foregroundImageUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireImageRenderable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.backgroundImageUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.foregroundImageUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireWallsAndGroundRenderable() {
    return {};
}
exports.WireWallsAndGroundRenderable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.wallStyle !== undefined) {
            writer.uint32(10).string(message.wallStyle);
        }
        if (message.groundStyle !== undefined) {
            writer.uint32(18).string(message.groundStyle);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireWallsAndGroundRenderable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.wallStyle = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.groundStyle = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireTextRenderable() {
    return {};
}
exports.WireTextRenderable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.text !== undefined) {
            writer.uint32(10).string(message.text);
        }
        if (message.font !== undefined) {
            writer.uint32(18).string(message.font);
        }
        if (message.size !== undefined) {
            writer.uint32(29).float(message.size);
        }
        if (message.color !== undefined) {
            writer.uint32(34).string(message.color);
        }
        if (message.backgroundImageUrl !== undefined) {
            writer.uint32(42).string(message.backgroundImageUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireTextRenderable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.font = reader.string();
                    continue;
                case 3:
                    if (tag !== 29) {
                        break;
                    }
                    message.size = reader.float();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.backgroundImageUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireRenderable() {
    return { renderable: undefined };
}
exports.WireRenderable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        switch (message.renderable?.$case) {
            case "image":
                exports.WireImageRenderable.encode(message.renderable.image, writer.uint32(10).fork()).ldelim();
                break;
            case "wallsAndGround":
                exports.WireWallsAndGroundRenderable.encode(message.renderable.wallsAndGround, writer.uint32(18).fork()).ldelim();
                break;
            case "text":
                exports.WireTextRenderable.encode(message.renderable.text, writer.uint32(26).fork()).ldelim();
                break;
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireRenderable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.renderable = { $case: "image", image: exports.WireImageRenderable.decode(reader, reader.uint32()) };
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.renderable = {
                        $case: "wallsAndGround",
                        wallsAndGround: exports.WireWallsAndGroundRenderable.decode(reader, reader.uint32()),
                    };
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.renderable = { $case: "text", text: exports.WireTextRenderable.decode(reader, reader.uint32()) };
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireBookable() {
    return {};
}
exports.WireBookable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.capacity !== undefined) {
            writer.uint32(8).int32(message.capacity);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireBookable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.capacity = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireImpassable() {
    return { x: 0, y: 0, w: 0, h: 0, mask: new Uint8Array(0) };
}
exports.WireImpassable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.x !== 0) {
            writer.uint32(24).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(32).uint32(message.y);
        }
        if (message.w !== 0) {
            writer.uint32(40).uint32(message.w);
        }
        if (message.h !== 0) {
            writer.uint32(48).uint32(message.h);
        }
        if (message.mask.length !== 0) {
            writer.uint32(58).bytes(message.mask);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireImpassable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.w = reader.uint32();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.h = reader.uint32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.mask = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireVideoInteractable() {
    return {};
}
exports.WireVideoInteractable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.url !== undefined) {
            writer.uint32(10).string(message.url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireVideoInteractable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireWebsiteInteractable() {
    return {};
}
exports.WireWebsiteInteractable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.url !== undefined) {
            writer.uint32(10).string(message.url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireWebsiteInteractable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireElevatorInteractable() {
    return {};
}
exports.WireElevatorInteractable = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireElevatorInteractable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireNoteInteractable() {
    return {};
}
exports.WireNoteInteractable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.note !== undefined) {
            writer.uint32(10).string(message.note);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireNoteInteractable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.note = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireInteractable() {
    return { interactable: undefined };
}
exports.WireInteractable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.activationDistance !== undefined) {
            writer.uint32(8).int32(message.activationDistance);
        }
        if (message.highlighted !== undefined) {
            writer.uint32(18).string(message.highlighted);
        }
        if (message.previewMessage !== undefined) {
            writer.uint32(26).string(message.previewMessage);
        }
        switch (message.interactable?.$case) {
            case "video":
                exports.WireVideoInteractable.encode(message.interactable.video, writer.uint32(34).fork()).ldelim();
                break;
            case "website":
                exports.WireWebsiteInteractable.encode(message.interactable.website, writer.uint32(42).fork()).ldelim();
                break;
            case "elevator":
                exports.WireElevatorInteractable.encode(message.interactable.elevator, writer.uint32(50).fork()).ldelim();
                break;
            case "note":
                exports.WireNoteInteractable.encode(message.interactable.note, writer.uint32(58).fork()).ldelim();
                break;
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireInteractable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.activationDistance = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.highlighted = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.previewMessage = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.interactable = { $case: "video", video: exports.WireVideoInteractable.decode(reader, reader.uint32()) };
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.interactable = { $case: "website", website: exports.WireWebsiteInteractable.decode(reader, reader.uint32()) };
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.interactable = {
                        $case: "elevator",
                        elevator: exports.WireElevatorInteractable.decode(reader, reader.uint32()),
                    };
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.interactable = { $case: "note", note: exports.WireNoteInteractable.decode(reader, reader.uint32()) };
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireMappable() {
    return { kind: 0, authored: undefined };
}
exports.WireMappable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.kind !== 0) {
            writer.uint32(8).int32(message.kind);
        }
        if (message.authored !== undefined) {
            exports.WireAuthored.encode(message.authored, writer.uint32(18).fork()).ldelim();
        }
        if (message.spatial !== undefined) {
            exports.WireSpatial.encode(message.spatial, writer.uint32(26).fork()).ldelim();
        }
        if (message.renderable !== undefined) {
            exports.WireRenderable.encode(message.renderable, writer.uint32(34).fork()).ldelim();
        }
        if (message.impassable !== undefined) {
            exports.WireImpassable.encode(message.impassable, writer.uint32(42).fork()).ldelim();
        }
        if (message.nameable !== undefined) {
            exports.WireNameable.encode(message.nameable, writer.uint32(50).fork()).ldelim();
        }
        if (message.bookable !== undefined) {
            exports.WireBookable.encode(message.bookable, writer.uint32(58).fork()).ldelim();
        }
        if (message.interactable !== undefined) {
            exports.WireInteractable.encode(message.interactable, writer.uint32(66).fork()).ldelim();
        }
        if (message.status !== undefined) {
            writer.uint32(74).string(message.status);
        }
        if (message.muteOnEntry !== undefined) {
            writer.uint32(80).bool(message.muteOnEntry);
        }
        if (message.legacyProperties !== undefined) {
            writer.uint32(90).string(message.legacyProperties);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireMappable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.kind = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.authored = exports.WireAuthored.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.spatial = exports.WireSpatial.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.renderable = exports.WireRenderable.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.impassable = exports.WireImpassable.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.nameable = exports.WireNameable.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.bookable = exports.WireBookable.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.interactable = exports.WireInteractable.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.status = reader.string();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.muteOnEntry = reader.bool();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.legacyProperties = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireRelativePosition() {
    return { x: 0, y: 0 };
}
exports.WireRelativePosition = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.x !== 0) {
            writer.uint32(13).float(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(21).float(message.y);
        }
        if (message.parentId !== undefined) {
            writer.uint32(26).string(message.parentId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireRelativePosition();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.x = reader.float();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.y = reader.float();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.parentId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetCatalogItemId() {
    return { mappableId: "", catalogItemId: "" };
}
exports.SetCatalogItemId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.catalogItemId !== "") {
            writer.uint32(18).string(message.catalogItemId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetCatalogItemId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.catalogItemId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMoveMappable() {
    return { mappableId: "", x: 0, y: 0 };
}
exports.MoveMappable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.x !== 0) {
            writer.uint32(21).float(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(29).float(message.y);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMoveMappable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.x = reader.float();
                    continue;
                case 3:
                    if (tag !== 29) {
                        break;
                    }
                    message.y = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAddMappable() {
    return { mappableId: "", position: undefined, mappable: undefined };
}
exports.AddMappable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.position !== undefined) {
            exports.WireRelativePosition.encode(message.position, writer.uint32(18).fork()).ldelim();
        }
        if (message.mappable !== undefined) {
            exports.WireMappable.encode(message.mappable, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddMappable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.position = exports.WireRelativePosition.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.mappable = exports.WireMappable.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseDeleteMappable() {
    return { mappableId: "" };
}
exports.DeleteMappable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteMappable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateBookableCapacity() {
    return { mappableId: "" };
}
exports.UpdateBookableCapacity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.bookable !== undefined) {
            exports.WireBookable.encode(message.bookable, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateBookableCapacity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.bookable = exports.WireBookable.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateInteraction() {
    return { mappableId: "" };
}
exports.UpdateInteraction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.interactable !== undefined) {
            exports.WireInteractable.encode(message.interactable, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateInteraction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.interactable = exports.WireInteractable.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateOrCreateGroundStyle() {
    return { mappableId: "" };
}
exports.UpdateOrCreateGroundStyle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.groundStyle !== undefined) {
            writer.uint32(18).string(message.groundStyle);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateOrCreateGroundStyle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.groundStyle = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateOrCreateWallStyle() {
    return { mappableId: "" };
}
exports.UpdateOrCreateWallStyle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.wallStyle !== undefined) {
            writer.uint32(18).string(message.wallStyle);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateOrCreateWallStyle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.wallStyle = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateFont() {
    return { mappableId: "", font: "" };
}
exports.UpdateFont = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.font !== "") {
            writer.uint32(18).string(message.font);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateFont();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.font = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateFontLabel() {
    return { mappableId: "", text: "" };
}
exports.UpdateFontLabel = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.text !== "") {
            writer.uint32(18).string(message.text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateFontLabel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateFontSize() {
    return { mappableId: "", size: 0 };
}
exports.UpdateFontSize = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.size !== 0) {
            writer.uint32(21).float(message.size);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateFontSize();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.size = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateFontColor() {
    return { mappableId: "", color: "" };
}
exports.UpdateFontColor = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.color !== "") {
            writer.uint32(18).string(message.color);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateFontColor();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseResizeArea() {
    return {
        mappableId: "",
        perDirectionResizesUp: 0,
        perDirectionResizesDown: 0,
        perDirectionResizesLeft: 0,
        perDirectionResizesRight: 0,
    };
}
exports.ResizeArea = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.perDirectionResizesUp !== 0) {
            writer.uint32(16).int32(message.perDirectionResizesUp);
        }
        if (message.perDirectionResizesDown !== 0) {
            writer.uint32(24).int32(message.perDirectionResizesDown);
        }
        if (message.perDirectionResizesLeft !== 0) {
            writer.uint32(32).int32(message.perDirectionResizesLeft);
        }
        if (message.perDirectionResizesRight !== 0) {
            writer.uint32(40).int32(message.perDirectionResizesRight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResizeArea();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.perDirectionResizesUp = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.perDirectionResizesDown = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.perDirectionResizesLeft = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.perDirectionResizesRight = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapEditAction() {
    return { action: undefined };
}
exports.MapEditAction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txnId !== undefined) {
            writer.uint32(10).string(message.txnId);
        }
        switch (message.action?.$case) {
            case "addMappable":
                exports.AddMappable.encode(message.action.addMappable, writer.uint32(18).fork()).ldelim();
                break;
            case "moveMappable":
                exports.MoveMappable.encode(message.action.moveMappable, writer.uint32(26).fork()).ldelim();
                break;
            case "setCatalogItemId":
                exports.SetCatalogItemId.encode(message.action.setCatalogItemId, writer.uint32(34).fork()).ldelim();
                break;
            case "deleteMappable":
                exports.DeleteMappable.encode(message.action.deleteMappable, writer.uint32(42).fork()).ldelim();
                break;
            case "updateBookableCapacity":
                exports.UpdateBookableCapacity.encode(message.action.updateBookableCapacity, writer.uint32(50).fork()).ldelim();
                break;
            case "updateInteraction":
                exports.UpdateInteraction.encode(message.action.updateInteraction, writer.uint32(58).fork()).ldelim();
                break;
            case "updateOrCreateGroundStyle":
                exports.UpdateOrCreateGroundStyle.encode(message.action.updateOrCreateGroundStyle, writer.uint32(66).fork()).ldelim();
                break;
            case "updateOrCreateWallStyle":
                exports.UpdateOrCreateWallStyle.encode(message.action.updateOrCreateWallStyle, writer.uint32(74).fork()).ldelim();
                break;
            case "updateFont":
                exports.UpdateFont.encode(message.action.updateFont, writer.uint32(82).fork()).ldelim();
                break;
            case "updateFontLabel":
                exports.UpdateFontLabel.encode(message.action.updateFontLabel, writer.uint32(90).fork()).ldelim();
                break;
            case "updateFontSize":
                exports.UpdateFontSize.encode(message.action.updateFontSize, writer.uint32(98).fork()).ldelim();
                break;
            case "updateFontColor":
                exports.UpdateFontColor.encode(message.action.updateFontColor, writer.uint32(106).fork()).ldelim();
                break;
            case "resizeArea":
                exports.ResizeArea.encode(message.action.resizeArea, writer.uint32(114).fork()).ldelim();
                break;
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapEditAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.txnId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.action = { $case: "addMappable", addMappable: exports.AddMappable.decode(reader, reader.uint32()) };
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.action = { $case: "moveMappable", moveMappable: exports.MoveMappable.decode(reader, reader.uint32()) };
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.action = {
                        $case: "setCatalogItemId",
                        setCatalogItemId: exports.SetCatalogItemId.decode(reader, reader.uint32()),
                    };
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.action = { $case: "deleteMappable", deleteMappable: exports.DeleteMappable.decode(reader, reader.uint32()) };
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.action = {
                        $case: "updateBookableCapacity",
                        updateBookableCapacity: exports.UpdateBookableCapacity.decode(reader, reader.uint32()),
                    };
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.action = {
                        $case: "updateInteraction",
                        updateInteraction: exports.UpdateInteraction.decode(reader, reader.uint32()),
                    };
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.action = {
                        $case: "updateOrCreateGroundStyle",
                        updateOrCreateGroundStyle: exports.UpdateOrCreateGroundStyle.decode(reader, reader.uint32()),
                    };
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.action = {
                        $case: "updateOrCreateWallStyle",
                        updateOrCreateWallStyle: exports.UpdateOrCreateWallStyle.decode(reader, reader.uint32()),
                    };
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.action = { $case: "updateFont", updateFont: exports.UpdateFont.decode(reader, reader.uint32()) };
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.action = {
                        $case: "updateFontLabel",
                        updateFontLabel: exports.UpdateFontLabel.decode(reader, reader.uint32()),
                    };
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.action = { $case: "updateFontSize", updateFontSize: exports.UpdateFontSize.decode(reader, reader.uint32()) };
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.action = {
                        $case: "updateFontColor",
                        updateFontColor: exports.UpdateFontColor.decode(reader, reader.uint32()),
                    };
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.action = { $case: "resizeArea", resizeArea: exports.ResizeArea.decode(reader, reader.uint32()) };
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapApplyEditActions() {
    return { actions: [] };
}
exports.MapApplyEditActions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.actions) {
            exports.MapEditAction.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapApplyEditActions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.actions.push(exports.MapEditAction.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapApplyChanges() {
    return { updatedMappables: [], deletedMappables: [] };
}
exports.MapApplyChanges = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txnId !== undefined) {
            writer.uint32(10).string(message.txnId);
        }
        for (const v of message.updatedMappables) {
            exports.WirePlacedMappable.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.deletedMappables) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapApplyChanges();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.txnId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.updatedMappables.push(exports.WirePlacedMappable.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.deletedMappables.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWirePlacedMappable() {
    return { mappableId: "", position: undefined, mappable: undefined };
}
exports.WirePlacedMappable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mappableId !== "") {
            writer.uint32(10).string(message.mappableId);
        }
        if (message.position !== undefined) {
            exports.WireRelativePosition.encode(message.position, writer.uint32(18).fork()).ldelim();
        }
        if (message.mappable !== undefined) {
            exports.WireMappable.encode(message.mappable, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWirePlacedMappable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mappableId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.position = exports.WireRelativePosition.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.mappable = exports.WireMappable.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseServerClientBatch() {
    return { events: [] };
}
exports.ServerClientBatch = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.events) {
            exports.ServerClientEvent.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseServerClientBatch();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.events.push(exports.ServerClientEvent.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseServerClientEvent() {
    return { event: undefined };
}
exports.ServerClientEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        switch (message.event?.$case) {
            case "info":
                exports.Info.encode(message.event.info, writer.uint32(802).fork()).ldelim();
                break;
            case "warn":
                exports.Warn.encode(message.event.warn, writer.uint32(810).fork()).ldelim();
                break;
            case "error":
                exports.ErrorEvent.encode(message.event.error, writer.uint32(818).fork()).ldelim();
                break;
            case "ready":
                exports.Ready.encode(message.event.ready, writer.uint32(826).fork()).ldelim();
                break;
            case "serverHeartbeat":
                exports.ServerHeartbeat.encode(message.event.serverHeartbeat, writer.uint32(842).fork()).ldelim();
                break;
            case "transactionStatus":
                exports.TransactionStatus.encode(message.event.transactionStatus, writer.uint32(858).fork()).ldelim();
                break;
            case "playerMoves":
                exports.PlayerMoves.encode(message.event.playerMoves, writer.uint32(10).fork()).ldelim();
                break;
            case "playerSetsStatus":
                exports.PlayerSetsStatus.encode(message.event.playerSetsStatus, writer.uint32(42).fork()).ldelim();
                break;
            case "playerSpotlights":
                exports.PlayerSpotlights.encode(message.event.playerSpotlights, writer.uint32(50).fork()).ldelim();
                break;
            case "playerRings":
                exports.PlayerRings.encode(message.event.playerRings, writer.uint32(58).fork()).ldelim();
                break;
            case "playerChats":
                exports.PlayerChats.encode(message.event.playerChats, writer.uint32(74).fork()).ldelim();
                break;
            case "playerGhosts":
                exports.PlayerGhosts.encode(message.event.playerGhosts, writer.uint32(90).fork()).ldelim();
                break;
            case "playerEntersWhisper":
                exports.PlayerEntersWhisper.encode(message.event.playerEntersWhisper, writer.uint32(98).fork()).ldelim();
                break;
            case "playerLeavesWhisper":
                exports.PlayerLeavesWhisper.encode(message.event.playerLeavesWhisper, writer.uint32(106).fork()).ldelim();
                break;
            case "playerActivelySpeaks":
                exports.PlayerActivelySpeaks.encode(message.event.playerActivelySpeaks, writer.uint32(114).fork()).ldelim();
                break;
            case "playerSetsName":
                exports.PlayerSetsName.encode(message.event.playerSetsName, writer.uint32(138).fork()).ldelim();
                break;
            case "playerSetsTextStatus":
                exports.PlayerSetsTextStatus.encode(message.event.playerSetsTextStatus, writer.uint32(146).fork()).ldelim();
                break;
            case "playerSetsEmojiStatus":
                exports.PlayerSetsEmojiStatus.encode(message.event.playerSetsEmojiStatus, writer.uint32(154).fork()).ldelim();
                break;
            case "playerSetsAffiliation":
                exports.PlayerSetsAffiliation.encode(message.event.playerSetsAffiliation, writer.uint32(162).fork()).ldelim();
                break;
            case "playerExits":
                exports.PlayerExits.encode(message.event.playerExits, writer.uint32(170).fork()).ldelim();
                break;
            case "playerSetsIsSignedIn":
                exports.PlayerSetsIsSignedIn.encode(message.event.playerSetsIsSignedIn, writer.uint32(330).fork()).ldelim();
                break;
            case "spaceOverwrites":
                exports.SpaceOverwrites.encode(message.event.spaceOverwrites, writer.uint32(354).fork()).ldelim();
                break;
            case "spaceIsClosed":
                exports.SpaceIsClosed.encode(message.event.spaceIsClosed, writer.uint32(362).fork()).ldelim();
                break;
            case "playerEntersPortal":
                exports.PlayerEntersPortal.encode(message.event.playerEntersPortal, writer.uint32(370).fork()).ldelim();
                break;
            case "spaceSetsIdMapping":
                exports.SpaceSetsIdMapping.encode(message.event.spaceSetsIdMapping, writer.uint32(378).fork()).ldelim();
                break;
            case "playerSetsLastActive":
                exports.PlayerSetsLastActive.encode(message.event.playerSetsLastActive, writer.uint32(386).fork()).ldelim();
                break;
            case "playerShootsConfetti":
                exports.PlayerShootsConfetti.encode(message.event.playerShootsConfetti, writer.uint32(394).fork()).ldelim();
                break;
            case "playerSetsEventStatus":
                exports.PlayerSetsEventStatus.encode(message.event.playerSetsEventStatus, writer.uint32(402).fork()).ldelim();
                break;
            case "playerSetsInConversation":
                exports.PlayerSetsInConversation.encode(message.event.playerSetsInConversation, writer.uint32(410).fork()).ldelim();
                break;
            case "playerSetsImagePointer":
                exports.PlayerSetsImagePointer.encode(message.event.playerSetsImagePointer, writer.uint32(434).fork()).ldelim();
                break;
            case "cookieFound":
                exports.CookieFound.encode(message.event.cookieFound, writer.uint32(442).fork()).ldelim();
                break;
            case "playerEntersWhisperV2":
                exports.PlayerEntersWhisperV2.encode(message.event.playerEntersWhisperV2, writer.uint32(450).fork()).ldelim();
                break;
            case "playerSetsGoKartId":
                exports.PlayerSetsGoKartId.encode(message.event.playerSetsGoKartId, writer.uint32(458).fork()).ldelim();
                break;
            case "mapSetDimensions":
                exports.MapSetDimensions.encode(message.event.mapSetDimensions, writer.uint32(466).fork()).ldelim();
                break;
            case "mapSetBackgroundImagePath":
                exports.MapSetBackgroundImagePath.encode(message.event.mapSetBackgroundImagePath, writer.uint32(482).fork()).ldelim();
                break;
            case "mapSetForegroundImagePath":
                exports.MapSetForegroundImagePath.encode(message.event.mapSetForegroundImagePath, writer.uint32(490).fork()).ldelim();
                break;
            case "mapSetSpawns":
                exports.MapSetSpawns.encode(message.event.mapSetSpawns, writer.uint32(514).fork()).ldelim();
                break;
            case "mapSetPortals":
                exports.MapSetPortals.encode(message.event.mapSetPortals, writer.uint32(522).fork()).ldelim();
                break;
            case "mapSetAnnouncer":
                exports.MapSetAnnouncer.encode(message.event.mapSetAnnouncer, writer.uint32(530).fork()).ldelim();
                break;
            case "mapSetAssets":
                exports.MapSetAssets.encode(message.event.mapSetAssets, writer.uint32(554).fork()).ldelim();
                break;
            case "mapSetName":
                exports.MapSetName.encode(message.event.mapSetName, writer.uint32(570).fork()).ldelim();
                break;
            case "mapSetMuteOnEntry":
                exports.MapSetMuteOnEntry.encode(message.event.mapSetMuteOnEntry, writer.uint32(586).fork()).ldelim();
                break;
            case "mapSetUseDrawnBG":
                exports.MapSetUseDrawnBG.encode(message.event.mapSetUseDrawnBG, writer.uint32(594).fork()).ldelim();
                break;
            case "mapSetWalls":
                exports.MapSetWalls.encode(message.event.mapSetWalls, writer.uint32(602).fork()).ldelim();
                break;
            case "mapSetFloors":
                exports.MapSetFloors.encode(message.event.mapSetFloors, writer.uint32(610).fork()).ldelim();
                break;
            case "mapSetAreas":
                exports.MapSetAreas.encode(message.event.mapSetAreas, writer.uint32(618).fork()).ldelim();
                break;
            case "mapSetSpawn":
                exports.MapSetSpawn.encode(message.event.mapSetSpawn, writer.uint32(634).fork()).ldelim();
                break;
            case "playerSetsIsAlone":
                exports.PlayerSetsIsAlone.encode(message.event.playerSetsIsAlone, writer.uint32(642).fork()).ldelim();
                break;
            case "playerJoins":
                exports.PlayerJoins.encode(message.event.playerJoins, writer.uint32(650).fork()).ldelim();
                break;
            case "mapSetEnabledChats":
                exports.MapSetEnabledChats.encode(message.event.mapSetEnabledChats, writer.uint32(658).fork()).ldelim();
                break;
            case "mapSetDescription":
                exports.MapSetDescription.encode(message.event.mapSetDescription, writer.uint32(666).fork()).ldelim();
                break;
            case "mapSetDecoration":
                exports.MapSetDecoration.encode(message.event.mapSetDecoration, writer.uint32(674).fork()).ldelim();
                break;
            case "mapSetTutorialTasks":
                exports.MapSetTutorialTasks.encode(message.event.mapSetTutorialTasks, writer.uint32(682).fork()).ldelim();
                break;
            case "mapSetMiniMapImagePath":
                exports.MapSetMiniMapImagePath.encode(message.event.mapSetMiniMapImagePath, writer.uint32(690).fork()).ldelim();
                break;
            case "spacePlaysSound":
                exports.SpacePlaysSound.encode(message.event.spacePlaysSound, writer.uint32(698).fork()).ldelim();
                break;
            case "mapSetScript":
                exports.Deprecated.encode(message.event.mapSetScript, writer.uint32(706).fork()).ldelim();
                break;
            case "playerSetsIsMobile":
                exports.PlayerSetsIsMobile.encode(message.event.playerSetsIsMobile, writer.uint32(722).fork()).ldelim();
                break;
            case "setScreenPointerServer":
                exports.SetScreenPointerServer.encode(message.event.setScreenPointerServer, writer.uint32(730).fork()).ldelim();
                break;
            case "playerSetsEmoteV2":
                exports.PlayerSetsEmoteV2.encode(message.event.playerSetsEmoteV2, writer.uint32(738).fork()).ldelim();
                break;
            case "playerSetsFocusModeEndTime":
                exports.PlayerSetsFocusModeEndTime.encode(message.event.playerSetsFocusModeEndTime, writer.uint32(746).fork()).ldelim();
                break;
            case "spaceSetsSpaceUsers":
                exports.SpaceSetsSpaceUsers.encode(message.event.spaceSetsSpaceUsers, writer.uint32(1338).fork()).ldelim();
                break;
            case "customEvent":
                exports.CustomEvent.encode(message.event.customEvent, writer.uint32(762).fork()).ldelim();
                break;
            case "playerBlocks":
                exports.PlayerBlocks.encode(message.event.playerBlocks, writer.uint32(778).fork()).ldelim();
                break;
            case "playerUpdatesFocusModeStatus":
                exports.PlayerUpdatesFocusModeStatus.encode(message.event.playerUpdatesFocusModeStatus, writer.uint32(786).fork())
                    .ldelim();
                break;
            case "playerNotifies":
                exports.PlayerNotifies.encode(message.event.playerNotifies, writer.uint32(794).fork()).ldelim();
                break;
            case "playerSetsItemString":
                exports.PlayerSetsItemString.encode(message.event.playerSetsItemString, writer.uint32(866).fork()).ldelim();
                break;
            case "playerSetsFollowTarget":
                exports.PlayerSetsFollowTarget.encode(message.event.playerSetsFollowTarget, writer.uint32(882).fork()).ldelim();
                break;
            case "playerRequestsToLead":
                exports.PlayerRequestsToLead.encode(message.event.playerRequestsToLead, writer.uint32(890).fork()).ldelim();
                break;
            case "playerSetsManualVideoSrc":
                exports.PlayerSetsManualVideoSrc.encode(message.event.playerSetsManualVideoSrc, writer.uint32(898).fork()).ldelim();
                break;
            case "playerSetsIsNpc":
                exports.PlayerSetsIsNpc.encode(message.event.playerSetsIsNpc, writer.uint32(906).fork()).ldelim();
                break;
            case "playerSetsSubtitle":
                exports.PlayerSetsSubtitle.encode(message.event.playerSetsSubtitle, writer.uint32(914).fork()).ldelim();
                break;
            case "mapCommitsChanges":
                exports.MapCommitsChanges.encode(message.event.mapCommitsChanges, writer.uint32(922).fork()).ldelim();
                break;
            case "mapMoveObject":
                exports.MapMoveObject.encode(message.event.mapMoveObject, writer.uint32(938).fork()).ldelim();
                break;
            case "playerEditsChatMessage":
                exports.PlayerEditsChatMessage.encode(message.event.playerEditsChatMessage, writer.uint32(946).fork()).ldelim();
                break;
            case "fxShakeObject":
                exports.FXShakeObject.encode(message.event.fxShakeObject, writer.uint32(954).fork()).ldelim();
                break;
            case "fxShakeCamera":
                exports.FXShakeCamera.encode(message.event.fxShakeCamera, writer.uint32(962).fork()).ldelim();
                break;
            case "playerSendsCommand":
                exports.PlayerSendsCommand.encode(message.event.playerSendsCommand, writer.uint32(970).fork()).ldelim();
                break;
            case "spaceRegistersCommand":
                exports.SpaceRegistersCommand.encode(message.event.spaceRegistersCommand, writer.uint32(978).fork()).ldelim();
                break;
            case "speakerUpdatesSession":
                exports.SpeakerUpdatesSession.encode(message.event.speakerUpdatesSession, writer.uint32(986).fork()).ldelim();
                break;
            case "playerUpdatesInventory":
                exports.PlayerUpdatesInventory.encode(message.event.playerUpdatesInventory, writer.uint32(994).fork()).ldelim();
                break;
            case "spaceUpdatesItems":
                exports.SpaceUpdatesItems.encode(message.event.spaceUpdatesItems, writer.uint32(1002).fork()).ldelim();
                break;
            case "playerSetsVehicleId":
                exports.PlayerSetsVehicleId.encode(message.event.playerSetsVehicleId, writer.uint32(1010).fork()).ldelim();
                break;
            case "playerSetsSpeedModifier":
                exports.PlayerSetsSpeedModifier.encode(message.event.playerSetsSpeedModifier, writer.uint32(1018).fork()).ldelim();
                break;
            case "playerHighFives":
                exports.PlayerHighFives.encode(message.event.playerHighFives, writer.uint32(1026).fork()).ldelim();
                break;
            case "spaceStopsSound":
                exports.SpaceStopsSound.encode(message.event.spaceStopsSound, writer.uint32(1042).fork()).ldelim();
                break;
            case "hipToBeSquare":
                exports.HipToBeSquare.encode(message.event.hipToBeSquare, writer.uint32(1050).fork()).ldelim();
                break;
            case "playerCrafts":
                exports.PlayerCrafts.encode(message.event.playerCrafts, writer.uint32(1058).fork()).ldelim();
                break;
            case "playerTriggersInventoryItem":
                exports.PlayerTriggersInventoryItem.encode(message.event.playerTriggersInventoryItem, writer.uint32(1066).fork())
                    .ldelim();
                break;
            case "playerSetsAllowScreenPointer":
                exports.PlayerSetsAllowScreenPointer.encode(message.event.playerSetsAllowScreenPointer, writer.uint32(1074).fork())
                    .ldelim();
                break;
            case "precomputedEnterLocation":
                exports.PrecomputedEnterLocation.encode(message.event.precomputedEnterLocation, writer.uint32(1082).fork()).ldelim();
                break;
            case "gotRequestMute":
                exports.GotRequestMute.encode(message.event.gotRequestMute, writer.uint32(1090).fork()).ldelim();
                break;
            case "playerSetsDeskInfo":
                exports.PlayerSetsDeskInfo.encode(message.event.playerSetsDeskInfo, writer.uint32(1098).fork()).ldelim();
                break;
            case "mapSetNooks":
                exports.MapSetNooks.encode(message.event.mapSetNooks, writer.uint32(1106).fork()).ldelim();
                break;
            case "dynamicGates":
                exports.DynamicGates.encode(message.event.dynamicGates, writer.uint32(1114).fork()).ldelim();
                break;
            case "playerWaves":
                exports.PlayerWaves.encode(message.event.playerWaves, writer.uint32(1122).fork()).ldelim();
                break;
            case "playerSetsPronouns":
                exports.PlayerSetsPronouns.encode(message.event.playerSetsPronouns, writer.uint32(1130).fork()).ldelim();
                break;
            case "playerSetsTitle":
                exports.PlayerSetsTitle.encode(message.event.playerSetsTitle, writer.uint32(1138).fork()).ldelim();
                break;
            case "playerSetsTimezone":
                exports.PlayerSetsTimezone.encode(message.event.playerSetsTimezone, writer.uint32(1146).fork()).ldelim();
                break;
            case "playerSetsDescription":
                exports.PlayerSetsDescription.encode(message.event.playerSetsDescription, writer.uint32(1154).fork()).ldelim();
                break;
            case "playerSetsPhone":
                exports.PlayerSetsPhone.encode(message.event.playerSetsPhone, writer.uint32(1162).fork()).ldelim();
                break;
            case "playerSetsPersonalImageUrl":
                exports.PlayerSetsPersonalImageUrl.encode(message.event.playerSetsPersonalImageUrl, writer.uint32(1170).fork())
                    .ldelim();
                break;
            case "playerSetsProfileImageUrl":
                exports.PlayerSetsProfileImageUrl.encode(message.event.playerSetsProfileImageUrl, writer.uint32(1178).fork()).ldelim();
                break;
            case "spaceSetsCapacity":
                exports.SpaceSetsCapacity.encode(message.event.spaceSetsCapacity, writer.uint32(1186).fork()).ldelim();
                break;
            case "spaceOverCapacityDeniesUser":
                exports.SpaceOverCapacityDeniesUser.encode(message.event.spaceOverCapacityDeniesUser, writer.uint32(1194).fork())
                    .ldelim();
                break;
            case "playerSetsAway":
                exports.PlayerSetsAway.encode(message.event.playerSetsAway, writer.uint32(1202).fork()).ldelim();
                break;
            case "mapSetCollisionsBits":
                exports.MapSetCollisionsBits.encode(message.event.mapSetCollisionsBits, writer.uint32(1210).fork()).ldelim();
                break;
            case "playerSetsCity":
                exports.PlayerSetsCity.encode(message.event.playerSetsCity, writer.uint32(1218).fork()).ldelim();
                break;
            case "playerSetsCountry":
                exports.PlayerSetsCountry.encode(message.event.playerSetsCountry, writer.uint32(1226).fork()).ldelim();
                break;
            case "playerSetsStartDate":
                exports.PlayerSetsStartDate.encode(message.event.playerSetsStartDate, writer.uint32(1234).fork()).ldelim();
                break;
            case "accessRequestsUpdated":
                exports.AccessRequestsUpdated.encode(message.event.accessRequestsUpdated, writer.uint32(1258).fork()).ldelim();
                break;
            case "accessRequestRespondedTo":
                exports.AccessRequestRespondedTo.encode(message.event.accessRequestRespondedTo, writer.uint32(1266).fork()).ldelim();
                break;
            case "playerSetsAvailability":
                exports.PlayerSetsAvailability.encode(message.event.playerSetsAvailability, writer.uint32(1282).fork()).ldelim();
                break;
            case "subscriptionsUpdated":
                exports.SubscriptionsUpdated.encode(message.event.subscriptionsUpdated, writer.uint32(1290).fork()).ldelim();
                break;
            case "spaceRolePermissionOverrideUpdated":
                exports.SpaceRolePermissionOverrideUpdated.encode(message.event.spaceRolePermissionOverrideUpdated, writer.uint32(1314).fork()).ldelim();
                break;
            case "playerSetsLastRaisedHand":
                exports.PlayerSetsLastRaisedHand.encode(message.event.playerSetsLastRaisedHand, writer.uint32(1322).fork()).ldelim();
                break;
            case "playerSetsCurrentlyEquippedWearables":
                exports.PlayerSetsCurrentlyEquippedWearables.encode(message.event.playerSetsCurrentlyEquippedWearables, writer.uint32(1330).fork()).ldelim();
                break;
            case "playerSetsDisplayEmail":
                exports.PlayerSetsDisplayEmail.encode(message.event.playerSetsDisplayEmail, writer.uint32(1346).fork()).ldelim();
                break;
            case "mapDeleteObjectByKey":
                exports.MapDeleteObjectByKey.encode(message.event.mapDeleteObjectByKey, writer.uint32(1354).fork()).ldelim();
                break;
            case "mapSetObjectsV2":
                exports.MapSetObjectsV2.encode(message.event.mapSetObjectsV2, writer.uint32(1362).fork()).ldelim();
                break;
            case "playerInteractsWithObject":
                exports.PlayerInteractsWithObject.encode(message.event.playerInteractsWithObject, writer.uint32(1370).fork()).ldelim();
                break;
            case "playerTriggersObject":
                exports.PlayerTriggersObject.encode(message.event.playerTriggersObject, writer.uint32(1378).fork()).ldelim();
                break;
            case "playerSetsAmbientPlayersMuted":
                exports.PlayerSetsAmbientPlayersMuted.encode(message.event.playerSetsAmbientPlayersMuted, writer.uint32(1386).fork())
                    .ldelim();
                break;
            case "spaceSetsActiveMobileUsers":
                exports.SpaceSetsActiveMobileUsers.encode(message.event.spaceSetsActiveMobileUsers, writer.uint32(1394).fork())
                    .ldelim();
                break;
            case "playerRequestsToLeadV2":
                exports.PlayerRequestsToLeadV2.encode(message.event.playerRequestsToLeadV2, writer.uint32(1402).fork()).ldelim();
                break;
            case "requestToLeadCanceled":
                exports.RequestToLeadCanceled.encode(message.event.requestToLeadCanceled, writer.uint32(1410).fork()).ldelim();
                break;
            case "requestToLeadRespondedTo":
                exports.RequestToLeadRespondedTo.encode(message.event.requestToLeadRespondedTo, writer.uint32(1418).fork()).ldelim();
                break;
            case "mapSetInitialInfo":
                exports.MapSetInitialInfo.encode(message.event.mapSetInitialInfo, writer.uint32(1426).fork()).ldelim();
                break;
            case "playerSetsActivityStatus":
                exports.PlayerSetsActivityStatus.encode(message.event.playerSetsActivityStatus, writer.uint32(1434).fork()).ldelim();
                break;
            case "playerRequestsToCowork":
                exports.PlayerRequestsToCowork.encode(message.event.playerRequestsToCowork, writer.uint32(1442).fork()).ldelim();
                break;
            case "mapSetDeskPods":
                exports.MapSetDeskPods.encode(message.event.mapSetDeskPods, writer.uint32(1450).fork()).ldelim();
                break;
            case "chatSetsSessionToken":
                exports.ChatSetsSessionToken.encode(message.event.chatSetsSessionToken, writer.uint32(1458).fork()).ldelim();
                break;
            case "chatCreatesGroupDmChannel":
                exports.ChatCreatesGroupDmChannel.encode(message.event.chatCreatesGroupDmChannel, writer.uint32(1466).fork()).ldelim();
                break;
            case "playerPromotesToMember":
                exports.PlayerPromotesToMember.encode(message.event.playerPromotesToMember, writer.uint32(1474).fork()).ldelim();
                break;
            case "playerInvitesAsMember":
                exports.PlayerInvitesAsMember.encode(message.event.playerInvitesAsMember, writer.uint32(1482).fork()).ldelim();
                break;
            case "playerShouldSendGrapes":
                exports.PlayerShouldSendGrapes.encode(message.event.playerShouldSendGrapes, writer.uint32(1490).fork()).ldelim();
                break;
            case "offlinePlayerSetsDeskInfo":
                exports.OfflinePlayerSetsDeskInfo.encode(message.event.offlinePlayerSetsDeskInfo, writer.uint32(1498).fork()).ldelim();
                break;
            case "nookAccessRequestRespondedTo":
                exports.NookAccessRequestRespondedTo.encode(message.event.nookAccessRequestRespondedTo, writer.uint32(1506).fork())
                    .ldelim();
                break;
            case "playerSetsPersonalImageId":
                exports.PlayerSetsPersonalImageId.encode(message.event.playerSetsPersonalImageId, writer.uint32(1514).fork()).ldelim();
                break;
            case "playerSetsProfileImageId":
                exports.PlayerSetsProfileImageId.encode(message.event.playerSetsProfileImageId, writer.uint32(1522).fork()).ldelim();
                break;
            case "chatReactsToGift":
                exports.ChatReactsToGift.encode(message.event.chatReactsToGift, writer.uint32(1530).fork()).ldelim();
                break;
            case "chatV2Notification":
                exports.ChatV2Notification.encode(message.event.chatV2Notification, writer.uint32(1538).fork()).ldelim();
                break;
            case "playerSetsStatusV2":
                exports.PlayerSetsStatusV2.encode(message.event.playerSetsStatusV2, writer.uint32(1546).fork()).ldelim();
                break;
            case "mapApplyChanges":
                exports.MapApplyChanges.encode(message.event.mapApplyChanges, writer.uint32(1554).fork()).ldelim();
                break;
            case "playerSetsHandRaisedAt":
                exports.PlayerSetsHandRaisedAt.encode(message.event.playerSetsHandRaisedAt, writer.uint32(1562).fork()).ldelim();
                break;
            case "playerLiveCursor":
                exports.PlayerLiveCursor.encode(message.event.playerLiveCursor, writer.uint32(1578).fork()).ldelim();
                break;
            case "playerShimmys":
                exports.PlayerShimmys.encode(message.event.playerShimmys, writer.uint32(1586).fork()).ldelim();
                break;
            case "playerStartsAnnotationSession":
                exports.AnnotationSession.encode(message.event.playerStartsAnnotationSession, writer.uint32(1594).fork()).ldelim();
                break;
            case "playerRequestsAnnotation":
                exports.AnnotationRequest.encode(message.event.playerRequestsAnnotation, writer.uint32(1602).fork()).ldelim();
                break;
            case "requestedAnnotationSessionNotFound":
                exports.AnnotationSessionNotFound.encode(message.event.requestedAnnotationSessionNotFound, writer.uint32(1610).fork())
                    .ldelim();
                break;
            case "endAnnotationSession":
                exports.ClearAllAnnotations.encode(message.event.endAnnotationSession, writer.uint32(1626).fork()).ldelim();
                break;
            case "clearPlayersAnnotations":
                exports.ClearAnnotations.encode(message.event.clearPlayersAnnotations, writer.uint32(1634).fork()).ldelim();
                break;
            case "annotationSessionLoaded":
                exports.AnnotationSession.encode(message.event.annotationSessionLoaded, writer.uint32(1642).fork()).ldelim();
                break;
            case "annotationSessionRequested":
                exports.AnnotationSession.encode(message.event.annotationSessionRequested, writer.uint32(1658).fork()).ldelim();
                break;
            case "denyAnnotationRequest":
                exports.AnnotationRequestDenied.encode(message.event.denyAnnotationRequest, writer.uint32(1666).fork()).ldelim();
                break;
            case "annotationDeltaFanout":
                exports.AnnotationDelta.encode(message.event.annotationDeltaFanout, writer.uint32(1674).fork()).ldelim();
                break;
            case "playerRequestsPromoteToMember":
                exports.PlayerRequestsPromoteToMember.encode(message.event.playerRequestsPromoteToMember, writer.uint32(1682).fork())
                    .ldelim();
                break;
            case "promoteToMemberRespondedTo":
                exports.PromoteToMemberRespondedTo.encode(message.event.promoteToMemberRespondedTo, writer.uint32(1690).fork())
                    .ldelim();
                break;
            case "activeAnnotationSessions":
                exports.ActiveAnnotationSessions.encode(message.event.activeAnnotationSessions, writer.uint32(1698).fork()).ldelim();
                break;
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseServerClientEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.event = { $case: "info", info: exports.Info.decode(reader, reader.uint32()) };
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.event = { $case: "warn", warn: exports.Warn.decode(reader, reader.uint32()) };
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.event = { $case: "error", error: exports.ErrorEvent.decode(reader, reader.uint32()) };
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.event = { $case: "ready", ready: exports.Ready.decode(reader, reader.uint32()) };
                    continue;
                case 105:
                    if (tag !== 842) {
                        break;
                    }
                    message.event = {
                        $case: "serverHeartbeat",
                        serverHeartbeat: exports.ServerHeartbeat.decode(reader, reader.uint32()),
                    };
                    continue;
                case 107:
                    if (tag !== 858) {
                        break;
                    }
                    message.event = {
                        $case: "transactionStatus",
                        transactionStatus: exports.TransactionStatus.decode(reader, reader.uint32()),
                    };
                    continue;
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.event = { $case: "playerMoves", playerMoves: exports.PlayerMoves.decode(reader, reader.uint32()) };
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsStatus",
                        playerSetsStatus: exports.PlayerSetsStatus.decode(reader, reader.uint32()),
                    };
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.event = {
                        $case: "playerSpotlights",
                        playerSpotlights: exports.PlayerSpotlights.decode(reader, reader.uint32()),
                    };
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.event = { $case: "playerRings", playerRings: exports.PlayerRings.decode(reader, reader.uint32()) };
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.event = { $case: "playerChats", playerChats: exports.PlayerChats.decode(reader, reader.uint32()) };
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.event = { $case: "playerGhosts", playerGhosts: exports.PlayerGhosts.decode(reader, reader.uint32()) };
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.event = {
                        $case: "playerEntersWhisper",
                        playerEntersWhisper: exports.PlayerEntersWhisper.decode(reader, reader.uint32()),
                    };
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.event = {
                        $case: "playerLeavesWhisper",
                        playerLeavesWhisper: exports.PlayerLeavesWhisper.decode(reader, reader.uint32()),
                    };
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.event = {
                        $case: "playerActivelySpeaks",
                        playerActivelySpeaks: exports.PlayerActivelySpeaks.decode(reader, reader.uint32()),
                    };
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.event = { $case: "playerSetsName", playerSetsName: exports.PlayerSetsName.decode(reader, reader.uint32()) };
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsTextStatus",
                        playerSetsTextStatus: exports.PlayerSetsTextStatus.decode(reader, reader.uint32()),
                    };
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsEmojiStatus",
                        playerSetsEmojiStatus: exports.PlayerSetsEmojiStatus.decode(reader, reader.uint32()),
                    };
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsAffiliation",
                        playerSetsAffiliation: exports.PlayerSetsAffiliation.decode(reader, reader.uint32()),
                    };
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.event = { $case: "playerExits", playerExits: exports.PlayerExits.decode(reader, reader.uint32()) };
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsIsSignedIn",
                        playerSetsIsSignedIn: exports.PlayerSetsIsSignedIn.decode(reader, reader.uint32()),
                    };
                    continue;
                case 44:
                    if (tag !== 354) {
                        break;
                    }
                    message.event = {
                        $case: "spaceOverwrites",
                        spaceOverwrites: exports.SpaceOverwrites.decode(reader, reader.uint32()),
                    };
                    continue;
                case 45:
                    if (tag !== 362) {
                        break;
                    }
                    message.event = { $case: "spaceIsClosed", spaceIsClosed: exports.SpaceIsClosed.decode(reader, reader.uint32()) };
                    continue;
                case 46:
                    if (tag !== 370) {
                        break;
                    }
                    message.event = {
                        $case: "playerEntersPortal",
                        playerEntersPortal: exports.PlayerEntersPortal.decode(reader, reader.uint32()),
                    };
                    continue;
                case 47:
                    if (tag !== 378) {
                        break;
                    }
                    message.event = {
                        $case: "spaceSetsIdMapping",
                        spaceSetsIdMapping: exports.SpaceSetsIdMapping.decode(reader, reader.uint32()),
                    };
                    continue;
                case 48:
                    if (tag !== 386) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsLastActive",
                        playerSetsLastActive: exports.PlayerSetsLastActive.decode(reader, reader.uint32()),
                    };
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.event = {
                        $case: "playerShootsConfetti",
                        playerShootsConfetti: exports.PlayerShootsConfetti.decode(reader, reader.uint32()),
                    };
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsEventStatus",
                        playerSetsEventStatus: exports.PlayerSetsEventStatus.decode(reader, reader.uint32()),
                    };
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsInConversation",
                        playerSetsInConversation: exports.PlayerSetsInConversation.decode(reader, reader.uint32()),
                    };
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsImagePointer",
                        playerSetsImagePointer: exports.PlayerSetsImagePointer.decode(reader, reader.uint32()),
                    };
                    continue;
                case 55:
                    if (tag !== 442) {
                        break;
                    }
                    message.event = { $case: "cookieFound", cookieFound: exports.CookieFound.decode(reader, reader.uint32()) };
                    continue;
                case 56:
                    if (tag !== 450) {
                        break;
                    }
                    message.event = {
                        $case: "playerEntersWhisperV2",
                        playerEntersWhisperV2: exports.PlayerEntersWhisperV2.decode(reader, reader.uint32()),
                    };
                    continue;
                case 57:
                    if (tag !== 458) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsGoKartId",
                        playerSetsGoKartId: exports.PlayerSetsGoKartId.decode(reader, reader.uint32()),
                    };
                    continue;
                case 58:
                    if (tag !== 466) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetDimensions",
                        mapSetDimensions: exports.MapSetDimensions.decode(reader, reader.uint32()),
                    };
                    continue;
                case 60:
                    if (tag !== 482) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetBackgroundImagePath",
                        mapSetBackgroundImagePath: exports.MapSetBackgroundImagePath.decode(reader, reader.uint32()),
                    };
                    continue;
                case 61:
                    if (tag !== 490) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetForegroundImagePath",
                        mapSetForegroundImagePath: exports.MapSetForegroundImagePath.decode(reader, reader.uint32()),
                    };
                    continue;
                case 64:
                    if (tag !== 514) {
                        break;
                    }
                    message.event = { $case: "mapSetSpawns", mapSetSpawns: exports.MapSetSpawns.decode(reader, reader.uint32()) };
                    continue;
                case 65:
                    if (tag !== 522) {
                        break;
                    }
                    message.event = { $case: "mapSetPortals", mapSetPortals: exports.MapSetPortals.decode(reader, reader.uint32()) };
                    continue;
                case 66:
                    if (tag !== 530) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetAnnouncer",
                        mapSetAnnouncer: exports.MapSetAnnouncer.decode(reader, reader.uint32()),
                    };
                    continue;
                case 69:
                    if (tag !== 554) {
                        break;
                    }
                    message.event = { $case: "mapSetAssets", mapSetAssets: exports.MapSetAssets.decode(reader, reader.uint32()) };
                    continue;
                case 71:
                    if (tag !== 570) {
                        break;
                    }
                    message.event = { $case: "mapSetName", mapSetName: exports.MapSetName.decode(reader, reader.uint32()) };
                    continue;
                case 73:
                    if (tag !== 586) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetMuteOnEntry",
                        mapSetMuteOnEntry: exports.MapSetMuteOnEntry.decode(reader, reader.uint32()),
                    };
                    continue;
                case 74:
                    if (tag !== 594) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetUseDrawnBG",
                        mapSetUseDrawnBG: exports.MapSetUseDrawnBG.decode(reader, reader.uint32()),
                    };
                    continue;
                case 75:
                    if (tag !== 602) {
                        break;
                    }
                    message.event = { $case: "mapSetWalls", mapSetWalls: exports.MapSetWalls.decode(reader, reader.uint32()) };
                    continue;
                case 76:
                    if (tag !== 610) {
                        break;
                    }
                    message.event = { $case: "mapSetFloors", mapSetFloors: exports.MapSetFloors.decode(reader, reader.uint32()) };
                    continue;
                case 77:
                    if (tag !== 618) {
                        break;
                    }
                    message.event = { $case: "mapSetAreas", mapSetAreas: exports.MapSetAreas.decode(reader, reader.uint32()) };
                    continue;
                case 79:
                    if (tag !== 634) {
                        break;
                    }
                    message.event = { $case: "mapSetSpawn", mapSetSpawn: exports.MapSetSpawn.decode(reader, reader.uint32()) };
                    continue;
                case 80:
                    if (tag !== 642) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsIsAlone",
                        playerSetsIsAlone: exports.PlayerSetsIsAlone.decode(reader, reader.uint32()),
                    };
                    continue;
                case 81:
                    if (tag !== 650) {
                        break;
                    }
                    message.event = { $case: "playerJoins", playerJoins: exports.PlayerJoins.decode(reader, reader.uint32()) };
                    continue;
                case 82:
                    if (tag !== 658) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetEnabledChats",
                        mapSetEnabledChats: exports.MapSetEnabledChats.decode(reader, reader.uint32()),
                    };
                    continue;
                case 83:
                    if (tag !== 666) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetDescription",
                        mapSetDescription: exports.MapSetDescription.decode(reader, reader.uint32()),
                    };
                    continue;
                case 84:
                    if (tag !== 674) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetDecoration",
                        mapSetDecoration: exports.MapSetDecoration.decode(reader, reader.uint32()),
                    };
                    continue;
                case 85:
                    if (tag !== 682) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetTutorialTasks",
                        mapSetTutorialTasks: exports.MapSetTutorialTasks.decode(reader, reader.uint32()),
                    };
                    continue;
                case 86:
                    if (tag !== 690) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetMiniMapImagePath",
                        mapSetMiniMapImagePath: exports.MapSetMiniMapImagePath.decode(reader, reader.uint32()),
                    };
                    continue;
                case 87:
                    if (tag !== 698) {
                        break;
                    }
                    message.event = {
                        $case: "spacePlaysSound",
                        spacePlaysSound: exports.SpacePlaysSound.decode(reader, reader.uint32()),
                    };
                    continue;
                case 88:
                    if (tag !== 706) {
                        break;
                    }
                    message.event = { $case: "mapSetScript", mapSetScript: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 90:
                    if (tag !== 722) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsIsMobile",
                        playerSetsIsMobile: exports.PlayerSetsIsMobile.decode(reader, reader.uint32()),
                    };
                    continue;
                case 91:
                    if (tag !== 730) {
                        break;
                    }
                    message.event = {
                        $case: "setScreenPointerServer",
                        setScreenPointerServer: exports.SetScreenPointerServer.decode(reader, reader.uint32()),
                    };
                    continue;
                case 92:
                    if (tag !== 738) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsEmoteV2",
                        playerSetsEmoteV2: exports.PlayerSetsEmoteV2.decode(reader, reader.uint32()),
                    };
                    continue;
                case 93:
                    if (tag !== 746) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsFocusModeEndTime",
                        playerSetsFocusModeEndTime: exports.PlayerSetsFocusModeEndTime.decode(reader, reader.uint32()),
                    };
                    continue;
                case 167:
                    if (tag !== 1338) {
                        break;
                    }
                    message.event = {
                        $case: "spaceSetsSpaceUsers",
                        spaceSetsSpaceUsers: exports.SpaceSetsSpaceUsers.decode(reader, reader.uint32()),
                    };
                    continue;
                case 95:
                    if (tag !== 762) {
                        break;
                    }
                    message.event = { $case: "customEvent", customEvent: exports.CustomEvent.decode(reader, reader.uint32()) };
                    continue;
                case 97:
                    if (tag !== 778) {
                        break;
                    }
                    message.event = { $case: "playerBlocks", playerBlocks: exports.PlayerBlocks.decode(reader, reader.uint32()) };
                    continue;
                case 98:
                    if (tag !== 786) {
                        break;
                    }
                    message.event = {
                        $case: "playerUpdatesFocusModeStatus",
                        playerUpdatesFocusModeStatus: exports.PlayerUpdatesFocusModeStatus.decode(reader, reader.uint32()),
                    };
                    continue;
                case 99:
                    if (tag !== 794) {
                        break;
                    }
                    message.event = { $case: "playerNotifies", playerNotifies: exports.PlayerNotifies.decode(reader, reader.uint32()) };
                    continue;
                case 108:
                    if (tag !== 866) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsItemString",
                        playerSetsItemString: exports.PlayerSetsItemString.decode(reader, reader.uint32()),
                    };
                    continue;
                case 110:
                    if (tag !== 882) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsFollowTarget",
                        playerSetsFollowTarget: exports.PlayerSetsFollowTarget.decode(reader, reader.uint32()),
                    };
                    continue;
                case 111:
                    if (tag !== 890) {
                        break;
                    }
                    message.event = {
                        $case: "playerRequestsToLead",
                        playerRequestsToLead: exports.PlayerRequestsToLead.decode(reader, reader.uint32()),
                    };
                    continue;
                case 112:
                    if (tag !== 898) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsManualVideoSrc",
                        playerSetsManualVideoSrc: exports.PlayerSetsManualVideoSrc.decode(reader, reader.uint32()),
                    };
                    continue;
                case 113:
                    if (tag !== 906) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsIsNpc",
                        playerSetsIsNpc: exports.PlayerSetsIsNpc.decode(reader, reader.uint32()),
                    };
                    continue;
                case 114:
                    if (tag !== 914) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsSubtitle",
                        playerSetsSubtitle: exports.PlayerSetsSubtitle.decode(reader, reader.uint32()),
                    };
                    continue;
                case 115:
                    if (tag !== 922) {
                        break;
                    }
                    message.event = {
                        $case: "mapCommitsChanges",
                        mapCommitsChanges: exports.MapCommitsChanges.decode(reader, reader.uint32()),
                    };
                    continue;
                case 117:
                    if (tag !== 938) {
                        break;
                    }
                    message.event = { $case: "mapMoveObject", mapMoveObject: exports.MapMoveObject.decode(reader, reader.uint32()) };
                    continue;
                case 118:
                    if (tag !== 946) {
                        break;
                    }
                    message.event = {
                        $case: "playerEditsChatMessage",
                        playerEditsChatMessage: exports.PlayerEditsChatMessage.decode(reader, reader.uint32()),
                    };
                    continue;
                case 119:
                    if (tag !== 954) {
                        break;
                    }
                    message.event = { $case: "fxShakeObject", fxShakeObject: exports.FXShakeObject.decode(reader, reader.uint32()) };
                    continue;
                case 120:
                    if (tag !== 962) {
                        break;
                    }
                    message.event = { $case: "fxShakeCamera", fxShakeCamera: exports.FXShakeCamera.decode(reader, reader.uint32()) };
                    continue;
                case 121:
                    if (tag !== 970) {
                        break;
                    }
                    message.event = {
                        $case: "playerSendsCommand",
                        playerSendsCommand: exports.PlayerSendsCommand.decode(reader, reader.uint32()),
                    };
                    continue;
                case 122:
                    if (tag !== 978) {
                        break;
                    }
                    message.event = {
                        $case: "spaceRegistersCommand",
                        spaceRegistersCommand: exports.SpaceRegistersCommand.decode(reader, reader.uint32()),
                    };
                    continue;
                case 123:
                    if (tag !== 986) {
                        break;
                    }
                    message.event = {
                        $case: "speakerUpdatesSession",
                        speakerUpdatesSession: exports.SpeakerUpdatesSession.decode(reader, reader.uint32()),
                    };
                    continue;
                case 124:
                    if (tag !== 994) {
                        break;
                    }
                    message.event = {
                        $case: "playerUpdatesInventory",
                        playerUpdatesInventory: exports.PlayerUpdatesInventory.decode(reader, reader.uint32()),
                    };
                    continue;
                case 125:
                    if (tag !== 1002) {
                        break;
                    }
                    message.event = {
                        $case: "spaceUpdatesItems",
                        spaceUpdatesItems: exports.SpaceUpdatesItems.decode(reader, reader.uint32()),
                    };
                    continue;
                case 126:
                    if (tag !== 1010) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsVehicleId",
                        playerSetsVehicleId: exports.PlayerSetsVehicleId.decode(reader, reader.uint32()),
                    };
                    continue;
                case 127:
                    if (tag !== 1018) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsSpeedModifier",
                        playerSetsSpeedModifier: exports.PlayerSetsSpeedModifier.decode(reader, reader.uint32()),
                    };
                    continue;
                case 128:
                    if (tag !== 1026) {
                        break;
                    }
                    message.event = {
                        $case: "playerHighFives",
                        playerHighFives: exports.PlayerHighFives.decode(reader, reader.uint32()),
                    };
                    continue;
                case 130:
                    if (tag !== 1042) {
                        break;
                    }
                    message.event = {
                        $case: "spaceStopsSound",
                        spaceStopsSound: exports.SpaceStopsSound.decode(reader, reader.uint32()),
                    };
                    continue;
                case 131:
                    if (tag !== 1050) {
                        break;
                    }
                    message.event = { $case: "hipToBeSquare", hipToBeSquare: exports.HipToBeSquare.decode(reader, reader.uint32()) };
                    continue;
                case 132:
                    if (tag !== 1058) {
                        break;
                    }
                    message.event = { $case: "playerCrafts", playerCrafts: exports.PlayerCrafts.decode(reader, reader.uint32()) };
                    continue;
                case 133:
                    if (tag !== 1066) {
                        break;
                    }
                    message.event = {
                        $case: "playerTriggersInventoryItem",
                        playerTriggersInventoryItem: exports.PlayerTriggersInventoryItem.decode(reader, reader.uint32()),
                    };
                    continue;
                case 134:
                    if (tag !== 1074) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsAllowScreenPointer",
                        playerSetsAllowScreenPointer: exports.PlayerSetsAllowScreenPointer.decode(reader, reader.uint32()),
                    };
                    continue;
                case 135:
                    if (tag !== 1082) {
                        break;
                    }
                    message.event = {
                        $case: "precomputedEnterLocation",
                        precomputedEnterLocation: exports.PrecomputedEnterLocation.decode(reader, reader.uint32()),
                    };
                    continue;
                case 136:
                    if (tag !== 1090) {
                        break;
                    }
                    message.event = { $case: "gotRequestMute", gotRequestMute: exports.GotRequestMute.decode(reader, reader.uint32()) };
                    continue;
                case 137:
                    if (tag !== 1098) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsDeskInfo",
                        playerSetsDeskInfo: exports.PlayerSetsDeskInfo.decode(reader, reader.uint32()),
                    };
                    continue;
                case 138:
                    if (tag !== 1106) {
                        break;
                    }
                    message.event = { $case: "mapSetNooks", mapSetNooks: exports.MapSetNooks.decode(reader, reader.uint32()) };
                    continue;
                case 139:
                    if (tag !== 1114) {
                        break;
                    }
                    message.event = { $case: "dynamicGates", dynamicGates: exports.DynamicGates.decode(reader, reader.uint32()) };
                    continue;
                case 140:
                    if (tag !== 1122) {
                        break;
                    }
                    message.event = { $case: "playerWaves", playerWaves: exports.PlayerWaves.decode(reader, reader.uint32()) };
                    continue;
                case 141:
                    if (tag !== 1130) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsPronouns",
                        playerSetsPronouns: exports.PlayerSetsPronouns.decode(reader, reader.uint32()),
                    };
                    continue;
                case 142:
                    if (tag !== 1138) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsTitle",
                        playerSetsTitle: exports.PlayerSetsTitle.decode(reader, reader.uint32()),
                    };
                    continue;
                case 143:
                    if (tag !== 1146) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsTimezone",
                        playerSetsTimezone: exports.PlayerSetsTimezone.decode(reader, reader.uint32()),
                    };
                    continue;
                case 144:
                    if (tag !== 1154) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsDescription",
                        playerSetsDescription: exports.PlayerSetsDescription.decode(reader, reader.uint32()),
                    };
                    continue;
                case 145:
                    if (tag !== 1162) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsPhone",
                        playerSetsPhone: exports.PlayerSetsPhone.decode(reader, reader.uint32()),
                    };
                    continue;
                case 146:
                    if (tag !== 1170) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsPersonalImageUrl",
                        playerSetsPersonalImageUrl: exports.PlayerSetsPersonalImageUrl.decode(reader, reader.uint32()),
                    };
                    continue;
                case 147:
                    if (tag !== 1178) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsProfileImageUrl",
                        playerSetsProfileImageUrl: exports.PlayerSetsProfileImageUrl.decode(reader, reader.uint32()),
                    };
                    continue;
                case 148:
                    if (tag !== 1186) {
                        break;
                    }
                    message.event = {
                        $case: "spaceSetsCapacity",
                        spaceSetsCapacity: exports.SpaceSetsCapacity.decode(reader, reader.uint32()),
                    };
                    continue;
                case 149:
                    if (tag !== 1194) {
                        break;
                    }
                    message.event = {
                        $case: "spaceOverCapacityDeniesUser",
                        spaceOverCapacityDeniesUser: exports.SpaceOverCapacityDeniesUser.decode(reader, reader.uint32()),
                    };
                    continue;
                case 150:
                    if (tag !== 1202) {
                        break;
                    }
                    message.event = { $case: "playerSetsAway", playerSetsAway: exports.PlayerSetsAway.decode(reader, reader.uint32()) };
                    continue;
                case 151:
                    if (tag !== 1210) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetCollisionsBits",
                        mapSetCollisionsBits: exports.MapSetCollisionsBits.decode(reader, reader.uint32()),
                    };
                    continue;
                case 152:
                    if (tag !== 1218) {
                        break;
                    }
                    message.event = { $case: "playerSetsCity", playerSetsCity: exports.PlayerSetsCity.decode(reader, reader.uint32()) };
                    continue;
                case 153:
                    if (tag !== 1226) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsCountry",
                        playerSetsCountry: exports.PlayerSetsCountry.decode(reader, reader.uint32()),
                    };
                    continue;
                case 154:
                    if (tag !== 1234) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsStartDate",
                        playerSetsStartDate: exports.PlayerSetsStartDate.decode(reader, reader.uint32()),
                    };
                    continue;
                case 157:
                    if (tag !== 1258) {
                        break;
                    }
                    message.event = {
                        $case: "accessRequestsUpdated",
                        accessRequestsUpdated: exports.AccessRequestsUpdated.decode(reader, reader.uint32()),
                    };
                    continue;
                case 158:
                    if (tag !== 1266) {
                        break;
                    }
                    message.event = {
                        $case: "accessRequestRespondedTo",
                        accessRequestRespondedTo: exports.AccessRequestRespondedTo.decode(reader, reader.uint32()),
                    };
                    continue;
                case 160:
                    if (tag !== 1282) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsAvailability",
                        playerSetsAvailability: exports.PlayerSetsAvailability.decode(reader, reader.uint32()),
                    };
                    continue;
                case 161:
                    if (tag !== 1290) {
                        break;
                    }
                    message.event = {
                        $case: "subscriptionsUpdated",
                        subscriptionsUpdated: exports.SubscriptionsUpdated.decode(reader, reader.uint32()),
                    };
                    continue;
                case 164:
                    if (tag !== 1314) {
                        break;
                    }
                    message.event = {
                        $case: "spaceRolePermissionOverrideUpdated",
                        spaceRolePermissionOverrideUpdated: exports.SpaceRolePermissionOverrideUpdated.decode(reader, reader.uint32()),
                    };
                    continue;
                case 165:
                    if (tag !== 1322) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsLastRaisedHand",
                        playerSetsLastRaisedHand: exports.PlayerSetsLastRaisedHand.decode(reader, reader.uint32()),
                    };
                    continue;
                case 166:
                    if (tag !== 1330) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsCurrentlyEquippedWearables",
                        playerSetsCurrentlyEquippedWearables: exports.PlayerSetsCurrentlyEquippedWearables.decode(reader, reader.uint32()),
                    };
                    continue;
                case 168:
                    if (tag !== 1346) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsDisplayEmail",
                        playerSetsDisplayEmail: exports.PlayerSetsDisplayEmail.decode(reader, reader.uint32()),
                    };
                    continue;
                case 169:
                    if (tag !== 1354) {
                        break;
                    }
                    message.event = {
                        $case: "mapDeleteObjectByKey",
                        mapDeleteObjectByKey: exports.MapDeleteObjectByKey.decode(reader, reader.uint32()),
                    };
                    continue;
                case 170:
                    if (tag !== 1362) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetObjectsV2",
                        mapSetObjectsV2: exports.MapSetObjectsV2.decode(reader, reader.uint32()),
                    };
                    continue;
                case 171:
                    if (tag !== 1370) {
                        break;
                    }
                    message.event = {
                        $case: "playerInteractsWithObject",
                        playerInteractsWithObject: exports.PlayerInteractsWithObject.decode(reader, reader.uint32()),
                    };
                    continue;
                case 172:
                    if (tag !== 1378) {
                        break;
                    }
                    message.event = {
                        $case: "playerTriggersObject",
                        playerTriggersObject: exports.PlayerTriggersObject.decode(reader, reader.uint32()),
                    };
                    continue;
                case 173:
                    if (tag !== 1386) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsAmbientPlayersMuted",
                        playerSetsAmbientPlayersMuted: exports.PlayerSetsAmbientPlayersMuted.decode(reader, reader.uint32()),
                    };
                    continue;
                case 174:
                    if (tag !== 1394) {
                        break;
                    }
                    message.event = {
                        $case: "spaceSetsActiveMobileUsers",
                        spaceSetsActiveMobileUsers: exports.SpaceSetsActiveMobileUsers.decode(reader, reader.uint32()),
                    };
                    continue;
                case 175:
                    if (tag !== 1402) {
                        break;
                    }
                    message.event = {
                        $case: "playerRequestsToLeadV2",
                        playerRequestsToLeadV2: exports.PlayerRequestsToLeadV2.decode(reader, reader.uint32()),
                    };
                    continue;
                case 176:
                    if (tag !== 1410) {
                        break;
                    }
                    message.event = {
                        $case: "requestToLeadCanceled",
                        requestToLeadCanceled: exports.RequestToLeadCanceled.decode(reader, reader.uint32()),
                    };
                    continue;
                case 177:
                    if (tag !== 1418) {
                        break;
                    }
                    message.event = {
                        $case: "requestToLeadRespondedTo",
                        requestToLeadRespondedTo: exports.RequestToLeadRespondedTo.decode(reader, reader.uint32()),
                    };
                    continue;
                case 178:
                    if (tag !== 1426) {
                        break;
                    }
                    message.event = {
                        $case: "mapSetInitialInfo",
                        mapSetInitialInfo: exports.MapSetInitialInfo.decode(reader, reader.uint32()),
                    };
                    continue;
                case 179:
                    if (tag !== 1434) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsActivityStatus",
                        playerSetsActivityStatus: exports.PlayerSetsActivityStatus.decode(reader, reader.uint32()),
                    };
                    continue;
                case 180:
                    if (tag !== 1442) {
                        break;
                    }
                    message.event = {
                        $case: "playerRequestsToCowork",
                        playerRequestsToCowork: exports.PlayerRequestsToCowork.decode(reader, reader.uint32()),
                    };
                    continue;
                case 181:
                    if (tag !== 1450) {
                        break;
                    }
                    message.event = { $case: "mapSetDeskPods", mapSetDeskPods: exports.MapSetDeskPods.decode(reader, reader.uint32()) };
                    continue;
                case 182:
                    if (tag !== 1458) {
                        break;
                    }
                    message.event = {
                        $case: "chatSetsSessionToken",
                        chatSetsSessionToken: exports.ChatSetsSessionToken.decode(reader, reader.uint32()),
                    };
                    continue;
                case 183:
                    if (tag !== 1466) {
                        break;
                    }
                    message.event = {
                        $case: "chatCreatesGroupDmChannel",
                        chatCreatesGroupDmChannel: exports.ChatCreatesGroupDmChannel.decode(reader, reader.uint32()),
                    };
                    continue;
                case 184:
                    if (tag !== 1474) {
                        break;
                    }
                    message.event = {
                        $case: "playerPromotesToMember",
                        playerPromotesToMember: exports.PlayerPromotesToMember.decode(reader, reader.uint32()),
                    };
                    continue;
                case 185:
                    if (tag !== 1482) {
                        break;
                    }
                    message.event = {
                        $case: "playerInvitesAsMember",
                        playerInvitesAsMember: exports.PlayerInvitesAsMember.decode(reader, reader.uint32()),
                    };
                    continue;
                case 186:
                    if (tag !== 1490) {
                        break;
                    }
                    message.event = {
                        $case: "playerShouldSendGrapes",
                        playerShouldSendGrapes: exports.PlayerShouldSendGrapes.decode(reader, reader.uint32()),
                    };
                    continue;
                case 187:
                    if (tag !== 1498) {
                        break;
                    }
                    message.event = {
                        $case: "offlinePlayerSetsDeskInfo",
                        offlinePlayerSetsDeskInfo: exports.OfflinePlayerSetsDeskInfo.decode(reader, reader.uint32()),
                    };
                    continue;
                case 188:
                    if (tag !== 1506) {
                        break;
                    }
                    message.event = {
                        $case: "nookAccessRequestRespondedTo",
                        nookAccessRequestRespondedTo: exports.NookAccessRequestRespondedTo.decode(reader, reader.uint32()),
                    };
                    continue;
                case 189:
                    if (tag !== 1514) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsPersonalImageId",
                        playerSetsPersonalImageId: exports.PlayerSetsPersonalImageId.decode(reader, reader.uint32()),
                    };
                    continue;
                case 190:
                    if (tag !== 1522) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsProfileImageId",
                        playerSetsProfileImageId: exports.PlayerSetsProfileImageId.decode(reader, reader.uint32()),
                    };
                    continue;
                case 191:
                    if (tag !== 1530) {
                        break;
                    }
                    message.event = {
                        $case: "chatReactsToGift",
                        chatReactsToGift: exports.ChatReactsToGift.decode(reader, reader.uint32()),
                    };
                    continue;
                case 192:
                    if (tag !== 1538) {
                        break;
                    }
                    message.event = {
                        $case: "chatV2Notification",
                        chatV2Notification: exports.ChatV2Notification.decode(reader, reader.uint32()),
                    };
                    continue;
                case 193:
                    if (tag !== 1546) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsStatusV2",
                        playerSetsStatusV2: exports.PlayerSetsStatusV2.decode(reader, reader.uint32()),
                    };
                    continue;
                case 194:
                    if (tag !== 1554) {
                        break;
                    }
                    message.event = {
                        $case: "mapApplyChanges",
                        mapApplyChanges: exports.MapApplyChanges.decode(reader, reader.uint32()),
                    };
                    continue;
                case 195:
                    if (tag !== 1562) {
                        break;
                    }
                    message.event = {
                        $case: "playerSetsHandRaisedAt",
                        playerSetsHandRaisedAt: exports.PlayerSetsHandRaisedAt.decode(reader, reader.uint32()),
                    };
                    continue;
                case 197:
                    if (tag !== 1578) {
                        break;
                    }
                    message.event = {
                        $case: "playerLiveCursor",
                        playerLiveCursor: exports.PlayerLiveCursor.decode(reader, reader.uint32()),
                    };
                    continue;
                case 198:
                    if (tag !== 1586) {
                        break;
                    }
                    message.event = { $case: "playerShimmys", playerShimmys: exports.PlayerShimmys.decode(reader, reader.uint32()) };
                    continue;
                case 199:
                    if (tag !== 1594) {
                        break;
                    }
                    message.event = {
                        $case: "playerStartsAnnotationSession",
                        playerStartsAnnotationSession: exports.AnnotationSession.decode(reader, reader.uint32()),
                    };
                    continue;
                case 200:
                    if (tag !== 1602) {
                        break;
                    }
                    message.event = {
                        $case: "playerRequestsAnnotation",
                        playerRequestsAnnotation: exports.AnnotationRequest.decode(reader, reader.uint32()),
                    };
                    continue;
                case 201:
                    if (tag !== 1610) {
                        break;
                    }
                    message.event = {
                        $case: "requestedAnnotationSessionNotFound",
                        requestedAnnotationSessionNotFound: exports.AnnotationSessionNotFound.decode(reader, reader.uint32()),
                    };
                    continue;
                case 203:
                    if (tag !== 1626) {
                        break;
                    }
                    message.event = {
                        $case: "endAnnotationSession",
                        endAnnotationSession: exports.ClearAllAnnotations.decode(reader, reader.uint32()),
                    };
                    continue;
                case 204:
                    if (tag !== 1634) {
                        break;
                    }
                    message.event = {
                        $case: "clearPlayersAnnotations",
                        clearPlayersAnnotations: exports.ClearAnnotations.decode(reader, reader.uint32()),
                    };
                    continue;
                case 205:
                    if (tag !== 1642) {
                        break;
                    }
                    message.event = {
                        $case: "annotationSessionLoaded",
                        annotationSessionLoaded: exports.AnnotationSession.decode(reader, reader.uint32()),
                    };
                    continue;
                case 207:
                    if (tag !== 1658) {
                        break;
                    }
                    message.event = {
                        $case: "annotationSessionRequested",
                        annotationSessionRequested: exports.AnnotationSession.decode(reader, reader.uint32()),
                    };
                    continue;
                case 208:
                    if (tag !== 1666) {
                        break;
                    }
                    message.event = {
                        $case: "denyAnnotationRequest",
                        denyAnnotationRequest: exports.AnnotationRequestDenied.decode(reader, reader.uint32()),
                    };
                    continue;
                case 209:
                    if (tag !== 1674) {
                        break;
                    }
                    message.event = {
                        $case: "annotationDeltaFanout",
                        annotationDeltaFanout: exports.AnnotationDelta.decode(reader, reader.uint32()),
                    };
                    continue;
                case 210:
                    if (tag !== 1682) {
                        break;
                    }
                    message.event = {
                        $case: "playerRequestsPromoteToMember",
                        playerRequestsPromoteToMember: exports.PlayerRequestsPromoteToMember.decode(reader, reader.uint32()),
                    };
                    continue;
                case 211:
                    if (tag !== 1690) {
                        break;
                    }
                    message.event = {
                        $case: "promoteToMemberRespondedTo",
                        promoteToMemberRespondedTo: exports.PromoteToMemberRespondedTo.decode(reader, reader.uint32()),
                    };
                    continue;
                case 212:
                    if (tag !== 1698) {
                        break;
                    }
                    message.event = {
                        $case: "activeAnnotationSessions",
                        activeAnnotationSessions: exports.ActiveAnnotationSessions.decode(reader, reader.uint32()),
                    };
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSubscriptionsUpdated() {
    return { subscriptions: [] };
}
exports.SubscriptionsUpdated = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.subscriptions) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptionsUpdated();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subscriptions.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseServerHeartbeat() {
    return { lastRTT: 0 };
}
exports.ServerHeartbeat = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.lastRTT !== 0) {
            writer.uint32(8).uint32(message.lastRTT);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseServerHeartbeat();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.lastRTT = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseInfo() {
    return { message: "" };
}
exports.Info = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWarn() {
    return { message: "" };
}
exports.Warn = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWarn();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseErrorEvent() {
    return { message: "", code: 0 };
}
exports.ErrorEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.code !== 0) {
            writer.uint32(16).uint32(message.code);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseErrorEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.code = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseReady() {
    return { id: "" };
}
exports.Ready = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReady();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseTransactionStatus() {
    return { txnId: 0, succeeded: false };
}
exports.TransactionStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txnId !== 0) {
            writer.uint32(8).uint32(message.txnId);
        }
        if (message.succeeded === true) {
            writer.uint32(16).bool(message.succeeded);
        }
        if (message.reason !== undefined) {
            writer.uint32(26).string(message.reason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransactionStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.txnId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.succeeded = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.reason = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerJoins() {
    return { encId: 0 };
}
exports.PlayerJoins = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.userUuid !== undefined) {
            writer.uint32(18).string(message.userUuid);
        }
        if (message.spaceUserUuid !== undefined) {
            writer.uint32(26).string(message.spaceUserUuid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerJoins();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.userUuid = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.spaceUserUuid = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseGotRequestMute() {
    return { muterId: "", video: false };
}
exports.GotRequestMute = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.muterId !== "") {
            writer.uint32(10).string(message.muterId);
        }
        if (message.video === true) {
            writer.uint32(16).bool(message.video);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGotRequestMute();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.muterId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.video = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerMoves() {
    return { encId: 0, lastInputId: 0 };
}
exports.PlayerMoves = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.x !== undefined) {
            writer.uint32(16).uint32(message.x);
        }
        if (message.y !== undefined) {
            writer.uint32(24).uint32(message.y);
        }
        if (message.direction !== undefined) {
            writer.uint32(32).int32(message.direction);
        }
        if (message.mapId !== undefined) {
            writer.uint32(42).string(message.mapId);
        }
        if (message.lastInputId !== 0) {
            writer.uint32(48).uint32(message.lastInputId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerMoves();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.direction = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.lastInputId = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsStatus() {
    return { encId: 0, busy: false };
}
exports.PlayerSetsStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.busy === true) {
            writer.uint32(16).bool(message.busy);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.busy = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsAvailability() {
    return { encId: 0, status: "" };
}
exports.PlayerSetsAvailability = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.status !== "") {
            writer.uint32(18).string(message.status);
        }
        if (message.statusUpdatedAt !== undefined) {
            writer.uint32(26).string(message.statusUpdatedAt);
        }
        if (message.statusEndOption !== undefined) {
            writer.uint32(34).string(message.statusEndOption);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsAvailability();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.status = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.statusUpdatedAt = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.statusEndOption = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsStatusV2() {
    return { encId: 0, status: "" };
}
exports.PlayerSetsStatusV2 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.status !== "") {
            writer.uint32(18).string(message.status);
        }
        if (message.statusChangeSource !== undefined) {
            writer.uint32(26).string(message.statusChangeSource);
        }
        if (message.statusExpiresAt !== undefined) {
            writer.uint32(34).string(message.statusExpiresAt);
        }
        if (message.statusExpiresToStatus !== undefined) {
            writer.uint32(42).string(message.statusExpiresToStatus);
        }
        if (message.statusExpiresToChangeSource !== undefined) {
            writer.uint32(50).string(message.statusExpiresToChangeSource);
        }
        if (message.statusExpiresToExpireTime !== undefined) {
            writer.uint32(58).string(message.statusExpiresToExpireTime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsStatusV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.status = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.statusChangeSource = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.statusExpiresAt = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.statusExpiresToStatus = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.statusExpiresToChangeSource = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.statusExpiresToExpireTime = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSpotlights() {
    return { encId: 0, spotlightedBy: 0, spotlighted: 0 };
}
exports.PlayerSpotlights = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(16).uint32(message.encId);
        }
        if (message.spotlightedBy !== 0) {
            writer.uint32(8).uint32(message.spotlightedBy);
        }
        if (message.spotlighted !== 0) {
            writer.uint32(24).uint32(message.spotlighted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSpotlights();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.spotlightedBy = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.spotlighted = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerRings() {
    return { encId: 0 };
}
exports.PlayerRings = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerRings();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsImagePointer() {
    return { encId: 0, objectId: "", x: 0, y: 0 };
}
exports.PlayerSetsImagePointer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.objectId !== "") {
            writer.uint32(18).string(message.objectId);
        }
        if (message.x !== 0) {
            writer.uint32(25).double(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(33).double(message.y);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsImagePointer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.objectId = reader.string();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.x = reader.double();
                    continue;
                case 4:
                    if (tag !== 33) {
                        break;
                    }
                    message.y = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetScreenPointerServer() {
    return { encId: 0, screenId: "", x: 0, y: 0, color: "" };
}
exports.SetScreenPointerServer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.screenId !== "") {
            writer.uint32(18).string(message.screenId);
        }
        if (message.x !== 0) {
            writer.uint32(25).double(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(33).double(message.y);
        }
        if (message.color !== "") {
            writer.uint32(42).string(message.color);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetScreenPointerServer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.screenId = reader.string();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.x = reader.double();
                    continue;
                case 4:
                    if (tag !== 33) {
                        break;
                    }
                    message.y = reader.double();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAnnotation() {
    return {
        annotationId: 0,
        drawerId: "",
        drawerName: "",
        pointerType: "",
        pressure: false,
        tool: 0,
        size: 0,
        color: "",
        strength: 0,
        points: [],
        dimsWidth: 0,
        dimsHeight: 0,
    };
}
exports.Annotation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.annotationId !== 0) {
            writer.uint32(8).uint64(message.annotationId);
        }
        if (message.drawerId !== "") {
            writer.uint32(18).string(message.drawerId);
        }
        if (message.drawerName !== "") {
            writer.uint32(26).string(message.drawerName);
        }
        if (message.pointerType !== "") {
            writer.uint32(34).string(message.pointerType);
        }
        if (message.pressure === true) {
            writer.uint32(40).bool(message.pressure);
        }
        if (message.tool !== 0) {
            writer.uint32(48).int32(message.tool);
        }
        if (message.size !== 0) {
            writer.uint32(57).double(message.size);
        }
        if (message.color !== "") {
            writer.uint32(66).string(message.color);
        }
        if (message.strength !== 0) {
            writer.uint32(73).double(message.strength);
        }
        for (const v of message.points) {
            exports.Annotation_Point.encode(v, writer.uint32(82).fork()).ldelim();
        }
        if (message.serverDrawTime !== undefined) {
            writer.uint32(89).double(message.serverDrawTime);
        }
        if (message.dimsWidth !== 0) {
            writer.uint32(97).double(message.dimsWidth);
        }
        if (message.dimsHeight !== 0) {
            writer.uint32(105).double(message.dimsHeight);
        }
        if (message.dpi !== undefined) {
            writer.uint32(113).double(message.dpi);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAnnotation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.annotationId = longToNumber(reader.uint64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.drawerId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.drawerName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.pointerType = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.pressure = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.tool = reader.int32();
                    continue;
                case 7:
                    if (tag !== 57) {
                        break;
                    }
                    message.size = reader.double();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
                case 9:
                    if (tag !== 73) {
                        break;
                    }
                    message.strength = reader.double();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.points.push(exports.Annotation_Point.decode(reader, reader.uint32()));
                    continue;
                case 11:
                    if (tag !== 89) {
                        break;
                    }
                    message.serverDrawTime = reader.double();
                    continue;
                case 12:
                    if (tag !== 97) {
                        break;
                    }
                    message.dimsWidth = reader.double();
                    continue;
                case 13:
                    if (tag !== 105) {
                        break;
                    }
                    message.dimsHeight = reader.double();
                    continue;
                case 14:
                    if (tag !== 113) {
                        break;
                    }
                    message.dpi = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAnnotation_Point() {
    return { x: 0, y: 0, pressure: 0 };
}
exports.Annotation_Point = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.x !== 0) {
            writer.uint32(9).double(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(17).double(message.y);
        }
        if (message.pressure !== 0) {
            writer.uint32(25).double(message.pressure);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAnnotation_Point();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.x = reader.double();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.y = reader.double();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.pressure = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAnnotationDelta() {
    return { annotationSessionId: "", type: 0, annotation: undefined };
}
exports.AnnotationDelta = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.annotationSessionId !== "") {
            writer.uint32(10).string(message.annotationSessionId);
        }
        if (message.type !== 0) {
            writer.uint32(16).int32(message.type);
        }
        if (message.annotation !== undefined) {
            exports.Annotation.encode(message.annotation, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAnnotationDelta();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.annotationSessionId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.annotation = exports.Annotation.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAnnotationSessionNotFound() {
    return {};
}
exports.AnnotationSessionNotFound = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAnnotationSessionNotFound();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseStartAnnotationSession() {
    return { annotationSessionId: "" };
}
exports.StartAnnotationSession = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.annotationSessionId !== "") {
            writer.uint32(10).string(message.annotationSessionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStartAnnotationSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.annotationSessionId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseLoadAnnotationSession() {
    return { annotationSessionId: "" };
}
exports.LoadAnnotationSession = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.annotationSessionId !== "") {
            writer.uint32(10).string(message.annotationSessionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLoadAnnotationSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.annotationSessionId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSendAnnotationSession() {
    return { annotationSessionId: "" };
}
exports.SendAnnotationSession = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.annotationSessionId !== "") {
            writer.uint32(10).string(message.annotationSessionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendAnnotationSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.annotationSessionId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAnnotationSession() {
    return { annotationHostId: "", annotationSessionId: "", annotations: [] };
}
exports.AnnotationSession = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.annotationHostId !== "") {
            writer.uint32(10).string(message.annotationHostId);
        }
        if (message.annotationSessionId !== "") {
            writer.uint32(18).string(message.annotationSessionId);
        }
        for (const v of message.annotations) {
            exports.Annotation.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAnnotationSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.annotationHostId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.annotationSessionId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.annotations.push(exports.Annotation.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseActiveAnnotationSessions() {
    return { annotationSessions: [] };
}
exports.ActiveAnnotationSessions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.annotationSessions) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseActiveAnnotationSessions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.annotationSessions.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAnnotationRequestDenied() {
    return { requesterId: "", requesterName: "", screenSharerName: "", screenSharerId: "" };
}
exports.AnnotationRequestDenied = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.requesterId !== "") {
            writer.uint32(10).string(message.requesterId);
        }
        if (message.requesterName !== "") {
            writer.uint32(18).string(message.requesterName);
        }
        if (message.screenSharerName !== "") {
            writer.uint32(26).string(message.screenSharerName);
        }
        if (message.screenSharerId !== "") {
            writer.uint32(34).string(message.screenSharerId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAnnotationRequestDenied();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.requesterId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.requesterName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.screenSharerName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.screenSharerId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAnnotationRequest() {
    return { requesterId: "", screenShareHostId: "", requestedAtUnixTime: 0, requesterName: "", notify: false };
}
exports.AnnotationRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.requesterId !== "") {
            writer.uint32(10).string(message.requesterId);
        }
        if (message.screenShareHostId !== "") {
            writer.uint32(18).string(message.screenShareHostId);
        }
        if (message.requestedAtUnixTime !== 0) {
            writer.uint32(24).uint64(message.requestedAtUnixTime);
        }
        if (message.requesterName !== "") {
            writer.uint32(34).string(message.requesterName);
        }
        if (message.notify === true) {
            writer.uint32(40).bool(message.notify);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAnnotationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.requesterId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.screenShareHostId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.requestedAtUnixTime = longToNumber(reader.uint64());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.requesterName = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.notify = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestAnnotationSession() {
    return { screenSharerId: "", notify: false, requesterName: "" };
}
exports.RequestAnnotationSession = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.screenSharerId !== "") {
            writer.uint32(10).string(message.screenSharerId);
        }
        if (message.notify === true) {
            writer.uint32(16).bool(message.notify);
        }
        if (message.requesterName !== "") {
            writer.uint32(26).string(message.requesterName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestAnnotationSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.screenSharerId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.notify = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.requesterName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestAnnotations() {
    return { annotationSessionId: "" };
}
exports.RequestAnnotations = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.annotationSessionId !== "") {
            writer.uint32(10).string(message.annotationSessionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestAnnotations();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.annotationSessionId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseClearAllAnnotations() {
    return { annotationSessionId: "" };
}
exports.ClearAllAnnotations = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.annotationSessionId !== "") {
            writer.uint32(10).string(message.annotationSessionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClearAllAnnotations();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.annotationSessionId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseClearAnnotations() {
    return { annotationSessionId: "" };
}
exports.ClearAnnotations = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.annotationSessionId !== "") {
            writer.uint32(10).string(message.annotationSessionId);
        }
        if (message.playerId !== undefined) {
            writer.uint32(18).string(message.playerId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClearAnnotations();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.annotationSessionId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.playerId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerChats() {
    return { senderId: "", recipient: "", contents: "", senderName: "", messageType: "", unixTime: 0 };
}
exports.PlayerChats = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.senderId !== "") {
            writer.uint32(10).string(message.senderId);
        }
        if (message.recipient !== "") {
            writer.uint32(18).string(message.recipient);
        }
        if (message.contents !== "") {
            writer.uint32(26).string(message.contents);
        }
        if (message.senderName !== "") {
            writer.uint32(34).string(message.senderName);
        }
        if (message.timestamp !== undefined) {
            exports.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        }
        if (message.messageType !== "") {
            writer.uint32(50).string(message.messageType);
        }
        if (message.unixTime !== 0) {
            writer.uint32(57).double(message.unixTime);
        }
        if (message.id !== undefined) {
            writer.uint32(66).string(message.id);
        }
        if (message.roomId !== undefined) {
            writer.uint32(74).string(message.roomId);
        }
        if (message.approved !== undefined) {
            writer.uint32(80).bool(message.approved);
        }
        if (message.nookId !== undefined) {
            writer.uint32(90).string(message.nookId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerChats();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.senderId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.recipient = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.contents = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.senderName = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.timestamp = exports.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.messageType = reader.string();
                    continue;
                case 7:
                    if (tag !== 57) {
                        break;
                    }
                    message.unixTime = reader.double();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.roomId = reader.string();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.approved = reader.bool();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.nookId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatV2Notification() {
    return {
        channelUrl: "",
        channelType: 0,
        senderUserId: "",
        actionType: 0,
        messageId: "",
        content: "",
        mentionedUserIds: [],
    };
}
exports.ChatV2Notification = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channelUrl !== "") {
            writer.uint32(10).string(message.channelUrl);
        }
        if (message.channelType !== 0) {
            writer.uint32(16).int32(message.channelType);
        }
        if (message.senderUserId !== "") {
            writer.uint32(26).string(message.senderUserId);
        }
        if (message.actionType !== 0) {
            writer.uint32(32).int32(message.actionType);
        }
        if (message.messageId !== "") {
            writer.uint32(42).string(message.messageId);
        }
        if (message.content !== "") {
            writer.uint32(50).string(message.content);
        }
        for (const v of message.mentionedUserIds) {
            writer.uint32(58).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatV2Notification();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channelUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.channelType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.senderUserId = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.actionType = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.messageId = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.mentionedUserIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerWaves() {
    return { encId: 0, targetId: "", isReply: false };
}
exports.PlayerWaves = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.targetId !== "") {
            writer.uint32(18).string(message.targetId);
        }
        if (message.isReply === true) {
            writer.uint32(24).bool(message.isReply);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerWaves();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isReply = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseTimestamp() {
    return { seconds: 0, nanoseconds: 0 };
}
exports.Timestamp = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.seconds !== 0) {
            writer.uint32(13).float(message.seconds);
        }
        if (message.nanoseconds !== 0) {
            writer.uint32(21).float(message.nanoseconds);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTimestamp();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.seconds = reader.float();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.nanoseconds = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerInteractsWithObject() {
    return { encId: 0, mapId: "", key: "" };
}
exports.PlayerInteractsWithObject = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.mapId !== "") {
            writer.uint32(18).string(message.mapId);
        }
        if (message.key !== "") {
            writer.uint32(26).string(message.key);
        }
        if (message.dataJson !== undefined) {
            writer.uint32(34).string(message.dataJson);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerInteractsWithObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.dataJson = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerGhosts() {
    return { encId: 0, ghost: 0 };
}
exports.PlayerGhosts = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.ghost !== 0) {
            writer.uint32(16).uint32(message.ghost);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerGhosts();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.ghost = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerShimmys() {
    return { encId: 0, shimmy: false };
}
exports.PlayerShimmys = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.shimmy === true) {
            writer.uint32(16).bool(message.shimmy);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerShimmys();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.shimmy = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerEntersWhisper() {
    return { encId: 0, whisperRecipient: "", whisperId: "" };
}
exports.PlayerEntersWhisper = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.whisperRecipient !== "") {
            writer.uint32(18).string(message.whisperRecipient);
        }
        if (message.whisperId !== "") {
            writer.uint32(26).string(message.whisperId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerEntersWhisper();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.whisperRecipient = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.whisperId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerEntersWhisperV2() {
    return { encId: 0, encIdTarget: 0, whisperId: "" };
}
exports.PlayerEntersWhisperV2 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.encIdTarget !== 0) {
            writer.uint32(16).uint32(message.encIdTarget);
        }
        if (message.whisperId !== "") {
            writer.uint32(26).string(message.whisperId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerEntersWhisperV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.encIdTarget = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.whisperId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerLeavesWhisper() {
    return { encId: 0 };
}
exports.PlayerLeavesWhisper = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerLeavesWhisper();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerActivelySpeaks() {
    return { encId: 0, activelySpeaking: 0 };
}
exports.PlayerActivelySpeaks = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.activelySpeaking !== 0) {
            writer.uint32(16).uint32(message.activelySpeaking);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerActivelySpeaks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.activelySpeaking = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsEmoteV2() {
    return { encId: 0 };
}
exports.PlayerSetsEmoteV2 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.emote !== undefined) {
            writer.uint32(18).string(message.emote);
        }
        if (message.count !== undefined) {
            writer.uint32(24).uint32(message.count);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsEmoteV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.emote = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.count = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsHandRaisedAt() {
    return { encId: 0, handRaisedAt: "" };
}
exports.PlayerSetsHandRaisedAt = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.handRaisedAt !== "") {
            writer.uint32(18).string(message.handRaisedAt);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsHandRaisedAt();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.handRaisedAt = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsLastRaisedHand() {
    return { encId: 0, lastRaisedHand: "" };
}
exports.PlayerSetsLastRaisedHand = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.lastRaisedHand !== "") {
            writer.uint32(18).string(message.lastRaisedHand);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsLastRaisedHand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.lastRaisedHand = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsLastActive() {
    return { encId: 0, lastActive: "" };
}
exports.PlayerSetsLastActive = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.lastActive !== "") {
            writer.uint32(18).string(message.lastActive);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsLastActive();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.lastActive = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsName() {
    return { encId: 0, name: "" };
}
exports.PlayerSetsName = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsName();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsTextStatus() {
    return { encId: 0, textStatus: "" };
}
exports.PlayerSetsTextStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.textStatus !== "") {
            writer.uint32(18).string(message.textStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsTextStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.textStatus = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsPronouns() {
    return { encId: 0, pronouns: "" };
}
exports.PlayerSetsPronouns = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.pronouns !== "") {
            writer.uint32(18).string(message.pronouns);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsPronouns();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.pronouns = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsTitle() {
    return { encId: 0, title: "" };
}
exports.PlayerSetsTitle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.title !== "") {
            writer.uint32(18).string(message.title);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsTitle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsCity() {
    return { encId: 0, city: "" };
}
exports.PlayerSetsCity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.city !== "") {
            writer.uint32(18).string(message.city);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsCity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.city = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsCountry() {
    return { encId: 0, country: "" };
}
exports.PlayerSetsCountry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.country !== "") {
            writer.uint32(18).string(message.country);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsCountry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.country = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsStartDate() {
    return { encId: 0, startDate: "" };
}
exports.PlayerSetsStartDate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.startDate !== "") {
            writer.uint32(18).string(message.startDate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsStartDate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.startDate = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsTimezone() {
    return { encId: 0, timezone: "" };
}
exports.PlayerSetsTimezone = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.timezone !== "") {
            writer.uint32(18).string(message.timezone);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsTimezone();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.timezone = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsPhone() {
    return { encId: 0, phone: "" };
}
exports.PlayerSetsPhone = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.phone !== "") {
            writer.uint32(18).string(message.phone);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsPhone();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.phone = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsDisplayEmail() {
    return { encId: 0, displayEmail: "" };
}
exports.PlayerSetsDisplayEmail = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.displayEmail !== "") {
            writer.uint32(18).string(message.displayEmail);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsDisplayEmail();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.displayEmail = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsDescription() {
    return { encId: 0, description: "" };
}
exports.PlayerSetsDescription = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsDescription();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsProfileImageId() {
    return { encId: 0, profileImageId: "" };
}
exports.PlayerSetsProfileImageId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.profileImageId !== "") {
            writer.uint32(18).string(message.profileImageId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsProfileImageId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.profileImageId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsPersonalImageId() {
    return { encId: 0, personalImageId: "" };
}
exports.PlayerSetsPersonalImageId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.personalImageId !== "") {
            writer.uint32(18).string(message.personalImageId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsPersonalImageId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.personalImageId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsProfileImageUrl() {
    return { encId: 0, profileImageUrl: "" };
}
exports.PlayerSetsProfileImageUrl = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.profileImageUrl !== "") {
            writer.uint32(18).string(message.profileImageUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsProfileImageUrl();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.profileImageUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsPersonalImageUrl() {
    return { encId: 0, personalImageUrl: "" };
}
exports.PlayerSetsPersonalImageUrl = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.personalImageUrl !== "") {
            writer.uint32(18).string(message.personalImageUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsPersonalImageUrl();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.personalImageUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsIsMobile() {
    return { encId: 0, isMobile: false };
}
exports.PlayerSetsIsMobile = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.isMobile === true) {
            writer.uint32(16).bool(message.isMobile);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsIsMobile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.isMobile = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsEmojiStatus() {
    return { encId: 0, emojiStatus: "" };
}
exports.PlayerSetsEmojiStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.emojiStatus !== "") {
            writer.uint32(18).string(message.emojiStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsEmojiStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.emojiStatus = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsAffiliation() {
    return { encId: 0, affiliation: "" };
}
exports.PlayerSetsAffiliation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.affiliation !== "") {
            writer.uint32(18).string(message.affiliation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsAffiliation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.affiliation = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerExits() {
    return { encId: 0 };
}
exports.PlayerExits = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerExits();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsCurrentlyEquippedWearables() {
    return { encId: 0, currentlyEquippedWearables: undefined };
}
exports.PlayerSetsCurrentlyEquippedWearables = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.currentlyEquippedWearables !== undefined) {
            exports.DBOutfit.encode(message.currentlyEquippedWearables, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsCurrentlyEquippedWearables();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.currentlyEquippedWearables = exports.DBOutfit.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsIsSignedIn() {
    return { encId: 0, isSignedIn: false };
}
exports.PlayerSetsIsSignedIn = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.isSignedIn === true) {
            writer.uint32(16).bool(message.isSignedIn);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsIsSignedIn();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.isSignedIn = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceOverwrites() {
    return { spaceData: "" };
}
exports.SpaceOverwrites = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceData !== "") {
            writer.uint32(10).string(message.spaceData);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceOverwrites();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceData = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseDynamicGate() {
    return { exposure: 0, spaces: [] };
}
exports.DynamicGate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.exposure !== 0) {
            writer.uint32(13).float(message.exposure);
        }
        for (const v of message.spaces) {
            writer.uint32(18).string(v);
        }
        if (message.refreshOnChange !== undefined) {
            writer.uint32(24).bool(message.refreshOnChange);
        }
        if (message.minimumBuildTimestamp !== undefined) {
            writer.uint32(32).uint64(message.minimumBuildTimestamp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDynamicGate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.exposure = reader.float();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.spaces.push(reader.string());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.refreshOnChange = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.minimumBuildTimestamp = longToNumber(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseDynamicGates() {
    return { livekitEnabled: undefined };
}
exports.DynamicGates = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.livekitEnabled !== undefined) {
            exports.DynamicGate.encode(message.livekitEnabled, writer.uint32(10).fork()).ldelim();
        }
        if (message.livekitSelfhostEnabled !== undefined) {
            exports.DynamicGate.encode(message.livekitSelfhostEnabled, writer.uint32(18).fork()).ldelim();
        }
        if (message.agoraEnabled !== undefined) {
            exports.DynamicGate.encode(message.agoraEnabled, writer.uint32(26).fork()).ldelim();
        }
        if (message.gatherEnabled !== undefined) {
            exports.DynamicGate.encode(message.gatherEnabled, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDynamicGates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.livekitEnabled = exports.DynamicGate.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.livekitSelfhostEnabled = exports.DynamicGate.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.agoraEnabled = exports.DynamicGate.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.gatherEnabled = exports.DynamicGate.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireSpaceUser() {
    return { role: "" };
}
exports.WireSpaceUser = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.role !== "") {
            writer.uint32(10).string(message.role);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireSpaceUser();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.role = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceSetsSpaceUsers() {
    return { spaceUsers: {} };
}
exports.SpaceSetsSpaceUsers = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.spaceUsers).forEach(([key, value]) => {
            exports.SpaceSetsSpaceUsers_SpaceUsersEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceSetsSpaceUsers();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.SpaceSetsSpaceUsers_SpaceUsersEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.spaceUsers[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceSetsSpaceUsers_SpaceUsersEntry() {
    return { key: "", value: undefined };
}
exports.SpaceSetsSpaceUsers_SpaceUsersEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.WireSpaceUser.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceSetsSpaceUsers_SpaceUsersEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.WireSpaceUser.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceIsClosed() {
    return {};
}
exports.SpaceIsClosed = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceIsClosed();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerEntersPortal() {
    return { targetUrl: "" };
}
exports.PlayerEntersPortal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.targetUrl !== "") {
            writer.uint32(10).string(message.targetUrl);
        }
        if (message.bypassPrompt !== undefined) {
            writer.uint32(16).bool(message.bypassPrompt);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerEntersPortal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.targetUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.bypassPrompt = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseCookieFound() {
    return { encId: 0 };
}
exports.CookieFound = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCookieFound();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWireSpaceActiveMobileUser() {
    return { mobileLastActive: "" };
}
exports.WireSpaceActiveMobileUser = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mobileLastActive !== "") {
            writer.uint32(10).string(message.mobileLastActive);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWireSpaceActiveMobileUser();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mobileLastActive = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceSetsActiveMobileUsers() {
    return { mobileUsers: {} };
}
exports.SpaceSetsActiveMobileUsers = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.mobileUsers).forEach(([key, value]) => {
            exports.SpaceSetsActiveMobileUsers_MobileUsersEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceSetsActiveMobileUsers();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.SpaceSetsActiveMobileUsers_MobileUsersEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.mobileUsers[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceSetsActiveMobileUsers_MobileUsersEntry() {
    return { key: "", value: undefined };
}
exports.SpaceSetsActiveMobileUsers_MobileUsersEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.WireSpaceActiveMobileUser.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceSetsActiveMobileUsers_MobileUsersEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.WireSpaceActiveMobileUser.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceSetsIdMapping() {
    return { uid: "", encId: 0 };
}
exports.SpaceSetsIdMapping = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.uid !== "") {
            writer.uint32(10).string(message.uid);
        }
        if (message.encId !== 0) {
            writer.uint32(16).uint32(message.encId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceSetsIdMapping();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.uid = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerShootsConfetti() {
    return { encId: 0 };
}
exports.PlayerShootsConfetti = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerShootsConfetti();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsEventStatus() {
    return { encId: 0, eventStatus: "" };
}
exports.PlayerSetsEventStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.eventStatus !== "") {
            writer.uint32(18).string(message.eventStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsEventStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.eventStatus = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsInConversation() {
    return { encId: 0, inConversation: false };
}
exports.PlayerSetsInConversation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.inConversation === true) {
            writer.uint32(16).bool(message.inConversation);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsInConversation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.inConversation = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsGoKartId() {
    return { encId: 0, goKartId: "" };
}
exports.PlayerSetsGoKartId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.goKartId !== "") {
            writer.uint32(18).string(message.goKartId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsGoKartId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.goKartId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsVehicleId() {
    return { encId: 0, vehicleId: "", action: "", previousVehicleId: "" };
}
exports.PlayerSetsVehicleId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.vehicleId !== "") {
            writer.uint32(18).string(message.vehicleId);
        }
        if (message.action !== "") {
            writer.uint32(26).string(message.action);
        }
        if (message.previousVehicleId !== "") {
            writer.uint32(34).string(message.previousVehicleId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsVehicleId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.vehicleId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.action = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.previousVehicleId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsSpeedModifier() {
    return { encId: 0, speedModifier: 0 };
}
exports.PlayerSetsSpeedModifier = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.speedModifier !== 0) {
            writer.uint32(21).float(message.speedModifier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsSpeedModifier();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.speedModifier = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsIsAlone() {
    return { encId: 0, isAlone: false };
}
exports.PlayerSetsIsAlone = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.isAlone === true) {
            writer.uint32(16).bool(message.isAlone);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsIsAlone();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.isAlone = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpacePlaysSound() {
    return { src: "", volume: 0 };
}
exports.SpacePlaysSound = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.src !== "") {
            writer.uint32(18).string(message.src);
        }
        if (message.volume !== 0) {
            writer.uint32(29).float(message.volume);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpacePlaysSound();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.src = reader.string();
                    continue;
                case 3:
                    if (tag !== 29) {
                        break;
                    }
                    message.volume = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceStopsSound() {
    return { src: "" };
}
exports.SpaceStopsSound = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.src !== "") {
            writer.uint32(18).string(message.src);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceStopsSound();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.src = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsFocusModeEndTime() {
    return { encId: 0, focusModeEndTime: "" };
}
exports.PlayerSetsFocusModeEndTime = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.focusModeEndTime !== "") {
            writer.uint32(18).string(message.focusModeEndTime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsFocusModeEndTime();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.focusModeEndTime = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsAmbientPlayersMuted() {
    return { encId: 0, ambientPlayersMuted: {} };
}
exports.PlayerSetsAmbientPlayersMuted = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        Object.entries(message.ambientPlayersMuted).forEach(([key, value]) => {
            exports.PlayerSetsAmbientPlayersMuted_AmbientPlayersMutedEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsAmbientPlayersMuted();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.PlayerSetsAmbientPlayersMuted_AmbientPlayersMutedEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.ambientPlayersMuted[entry2.key] = entry2.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsAmbientPlayersMuted_AmbientPlayersMutedEntry() {
    return { key: "", value: false };
}
exports.PlayerSetsAmbientPlayersMuted_AmbientPlayersMutedEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value === true) {
            writer.uint32(16).bool(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsAmbientPlayersMuted_AmbientPlayersMutedEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.value = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsActivityStatus() {
    return { encId: 0, activityStatus: undefined };
}
exports.PlayerSetsActivityStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.activityStatus !== undefined) {
            exports.ActivityStatus.encode(message.activityStatus, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsActivityStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.activityStatus = exports.ActivityStatus.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerBlocks() {
    return { blockedBy: "", blocked: false };
}
exports.PlayerBlocks = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.blockedBy !== "") {
            writer.uint32(10).string(message.blockedBy);
        }
        if (message.blocked === true) {
            writer.uint32(16).bool(message.blocked);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerBlocks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.blockedBy = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.blocked = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseCustomEvent() {
    return { name: "", payload: "" };
}
exports.CustomEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.payload !== "") {
            writer.uint32(18).string(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCustomEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerUpdatesFocusModeStatus() {
    return { encId: 0, isInFocusMode: false };
}
exports.PlayerUpdatesFocusModeStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.isInFocusMode === true) {
            writer.uint32(16).bool(message.isInFocusMode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerUpdatesFocusModeStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.isInFocusMode = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsItemString() {
    return { encId: 0, itemString: "" };
}
exports.PlayerSetsItemString = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.itemString !== "") {
            writer.uint32(18).string(message.itemString);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsItemString();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.itemString = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerTriggersObject() {
    return { encId: 0 };
}
exports.PlayerTriggersObject = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.mapId !== undefined) {
            writer.uint32(18).string(message.mapId);
        }
        if (message.key !== undefined) {
            writer.uint32(26).string(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerTriggersObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerNotifies() {
    return { encId: 0, notification: "" };
}
exports.PlayerNotifies = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.notification !== "") {
            writer.uint32(18).string(message.notification);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerNotifies();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.notification = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsFollowTarget() {
    return { encId: 0, followTarget: "" };
}
exports.PlayerSetsFollowTarget = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.followTarget !== "") {
            writer.uint32(18).string(message.followTarget);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsFollowTarget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.followTarget = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerRequestsToLead() {
    return { encId: 0, snapshot: "" };
}
exports.PlayerRequestsToLead = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.snapshot !== "") {
            writer.uint32(18).string(message.snapshot);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerRequestsToLead();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.snapshot = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerRequestsToLeadV2() {
    return { encId: 0, snapshot: "", requestedAt: "" };
}
exports.PlayerRequestsToLeadV2 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.snapshot !== "") {
            writer.uint32(18).string(message.snapshot);
        }
        if (message.requestedAt !== "") {
            writer.uint32(26).string(message.requestedAt);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerRequestsToLeadV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.snapshot = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.requestedAt = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestToLeadCanceled() {
    return { requesterId: "" };
}
exports.RequestToLeadCanceled = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.requesterId !== "") {
            writer.uint32(10).string(message.requesterId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestToLeadCanceled();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.requesterId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestToLeadRespondedTo() {
    return { encId: 0, response: 0 };
}
exports.RequestToLeadRespondedTo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.response !== 0) {
            writer.uint32(16).int32(message.response);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestToLeadRespondedTo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.response = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsManualVideoSrc() {
    return { encId: 0, manualVideoSrc: "" };
}
exports.PlayerSetsManualVideoSrc = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.manualVideoSrc !== "") {
            writer.uint32(18).string(message.manualVideoSrc);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsManualVideoSrc();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.manualVideoSrc = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsIsNpc() {
    return { encId: 0, isNpc: false };
}
exports.PlayerSetsIsNpc = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.isNpc === true) {
            writer.uint32(16).bool(message.isNpc);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsIsNpc();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.isNpc = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsSubtitle() {
    return { encId: 0, subtitle: "" };
}
exports.PlayerSetsSubtitle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.subtitle !== "") {
            writer.uint32(18).string(message.subtitle);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsSubtitle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subtitle = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerCrafts() {
    return { encId: 0, inputs: {} };
}
exports.PlayerCrafts = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        Object.entries(message.inputs).forEach(([key, value]) => {
            exports.PlayerCrafts_InputsEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerCrafts();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.PlayerCrafts_InputsEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.inputs[entry2.key] = entry2.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerCrafts_InputsEntry() {
    return { key: "", value: 0 };
}
exports.PlayerCrafts_InputsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== 0) {
            writer.uint32(16).uint32(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerCrafts_InputsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.value = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapMoveObject() {
    return { mapId: "", objectId: "", targetX: 0, targetY: 0, duration: 0 };
}
exports.MapMoveObject = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.objectId !== "") {
            writer.uint32(18).string(message.objectId);
        }
        if (message.targetX !== 0) {
            writer.uint32(29).float(message.targetX);
        }
        if (message.targetY !== 0) {
            writer.uint32(37).float(message.targetY);
        }
        if (message.targetXOffset !== undefined) {
            writer.uint32(45).float(message.targetXOffset);
        }
        if (message.targetYOffset !== undefined) {
            writer.uint32(53).float(message.targetYOffset);
        }
        if (message.duration !== 0) {
            writer.uint32(61).float(message.duration);
        }
        if (message.easing !== undefined) {
            writer.uint32(66).string(message.easing);
        }
        if (message.overwritableChange !== undefined) {
            writer.uint32(72).bool(message.overwritableChange);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapMoveObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.objectId = reader.string();
                    continue;
                case 3:
                    if (tag !== 29) {
                        break;
                    }
                    message.targetX = reader.float();
                    continue;
                case 4:
                    if (tag !== 37) {
                        break;
                    }
                    message.targetY = reader.float();
                    continue;
                case 5:
                    if (tag !== 45) {
                        break;
                    }
                    message.targetXOffset = reader.float();
                    continue;
                case 6:
                    if (tag !== 53) {
                        break;
                    }
                    message.targetYOffset = reader.float();
                    continue;
                case 7:
                    if (tag !== 61) {
                        break;
                    }
                    message.duration = reader.float();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.easing = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.overwritableChange = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerEditsChatMessage() {
    return { id: "" };
}
exports.PlayerEditsChatMessage = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.likes !== undefined) {
            writer.uint32(16).uint32(message.likes);
        }
        if (message.replied !== undefined) {
            writer.uint32(24).bool(message.replied);
        }
        if (message.reply !== undefined) {
            exports.ChatReply.encode(message.reply, writer.uint32(34).fork()).ldelim();
        }
        if (message.approved !== undefined) {
            writer.uint32(40).bool(message.approved);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerEditsChatMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.likes = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.replied = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.reply = exports.ChatReply.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.approved = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseFXShakeObject() {
    return { mapId: "", targetId: "" };
}
exports.FXShakeObject = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.targetId !== "") {
            writer.uint32(18).string(message.targetId);
        }
        if (message.intensity !== undefined) {
            writer.uint32(29).float(message.intensity);
        }
        if (message.durationMs !== undefined) {
            writer.uint32(37).float(message.durationMs);
        }
        if (message.mode !== undefined) {
            writer.uint32(40).uint32(message.mode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFXShakeObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
                case 3:
                    if (tag !== 29) {
                        break;
                    }
                    message.intensity = reader.float();
                    continue;
                case 4:
                    if (tag !== 37) {
                        break;
                    }
                    message.durationMs = reader.float();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.mode = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseFXShakeCamera() {
    return {};
}
exports.FXShakeCamera = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.intensity !== undefined) {
            writer.uint32(13).float(message.intensity);
        }
        if (message.durationMs !== undefined) {
            writer.uint32(21).float(message.durationMs);
        }
        if (message.mapId !== undefined) {
            writer.uint32(26).string(message.mapId);
        }
        if (message.targetUserId !== undefined) {
            writer.uint32(34).string(message.targetUserId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFXShakeCamera();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.intensity = reader.float();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.durationMs = reader.float();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.targetUserId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerHighFives() {
    return { encId: 0, encIdTarget: 0 };
}
exports.PlayerHighFives = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.encIdTarget !== 0) {
            writer.uint32(16).uint32(message.encIdTarget);
        }
        if (message.emote !== undefined) {
            writer.uint32(26).string(message.emote);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerHighFives();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.encIdTarget = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.emote = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSendsCommand() {
    return { encId: 0, command: "" };
}
exports.PlayerSendsCommand = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.command !== "") {
            writer.uint32(18).string(message.command);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSendsCommand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.command = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceRegistersCommand() {
    return { command: "" };
}
exports.SpaceRegistersCommand = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.command !== "") {
            writer.uint32(18).string(message.command);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceRegistersCommand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.command = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerUpdatesInventory() {
    return { encId: 0, items: {}, order: {} };
}
exports.PlayerUpdatesInventory = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        Object.entries(message.items).forEach(([key, value]) => {
            exports.PlayerUpdatesInventory_ItemsEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        Object.entries(message.order).forEach(([key, value]) => {
            exports.PlayerUpdatesInventory_OrderEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerUpdatesInventory();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.PlayerUpdatesInventory_ItemsEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.items[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    const entry3 = exports.PlayerUpdatesInventory_OrderEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.order[entry3.key] = entry3.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerUpdatesInventory_ItemsEntry() {
    return { key: "", value: undefined };
}
exports.PlayerUpdatesInventory_ItemsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.InventoryItem.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerUpdatesInventory_ItemsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.InventoryItem.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerUpdatesInventory_OrderEntry() {
    return { key: "", value: "" };
}
exports.PlayerUpdatesInventory_OrderEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerUpdatesInventory_OrderEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceUpdatesItems() {
    return { items: {} };
}
exports.SpaceUpdatesItems = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.items).forEach(([key, value]) => {
            exports.SpaceUpdatesItems_ItemsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceUpdatesItems();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.SpaceUpdatesItems_ItemsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.items[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceUpdatesItems_ItemsEntry() {
    return { key: "", value: undefined };
}
exports.SpaceUpdatesItems_ItemsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.SpaceItem.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceUpdatesItems_ItemsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.SpaceItem.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerTriggersInventoryItem() {
    return { encId: 0, itemId: "", abilityId: "" };
}
exports.PlayerTriggersInventoryItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.itemId !== "") {
            writer.uint32(18).string(message.itemId);
        }
        if (message.abilityId !== "") {
            writer.uint32(26).string(message.abilityId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerTriggersInventoryItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.abilityId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsAllowScreenPointer() {
    return { encId: 0, allowScreenPointer: false };
}
exports.PlayerSetsAllowScreenPointer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.allowScreenPointer === true) {
            writer.uint32(16).bool(message.allowScreenPointer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsAllowScreenPointer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.allowScreenPointer = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePrecomputedEnterLocation() {
    return { enterLocation: undefined };
}
exports.PrecomputedEnterLocation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.enterLocation !== undefined) {
            exports.MapLocation.encode(message.enterLocation, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePrecomputedEnterLocation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.enterLocation = exports.MapLocation.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsDeskInfo() {
    return { encId: 0, deskInfo: undefined };
}
exports.PlayerSetsDeskInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.deskInfo !== undefined) {
            exports.DeskInfoV2.encode(message.deskInfo, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsDeskInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.deskInfo = exports.DeskInfoV2.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceSetsCapacity() {
    return { capacity: 0 };
}
exports.SpaceSetsCapacity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.capacity !== 0) {
            writer.uint32(8).uint32(message.capacity);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceSetsCapacity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.capacity = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceOverCapacityDeniesUser() {
    return { userId: "" };
}
exports.SpaceOverCapacityDeniesUser = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceOverCapacityDeniesUser();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerSetsAway() {
    return { encId: 0, away: false };
}
exports.PlayerSetsAway = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.away === true) {
            writer.uint32(16).bool(message.away);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerSetsAway();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.away = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAccessRequest() {
    return { guestId: "", memberId: "", requestedAtUnixTime: 0, guestName: "" };
}
exports.AccessRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.guestId !== "") {
            writer.uint32(10).string(message.guestId);
        }
        if (message.memberId !== "") {
            writer.uint32(18).string(message.memberId);
        }
        if (message.requestedAtUnixTime !== 0) {
            writer.uint32(24).uint64(message.requestedAtUnixTime);
        }
        if (message.guestName !== "") {
            writer.uint32(34).string(message.guestName);
        }
        if (message.guestCurrentlyEquippedWearables !== undefined) {
            exports.DBOutfit.encode(message.guestCurrentlyEquippedWearables, writer.uint32(50).fork()).ldelim();
        }
        if (message.isMobile !== undefined) {
            writer.uint32(56).bool(message.isMobile);
        }
        if (message.meetingLink !== undefined) {
            writer.uint32(66).string(message.meetingLink);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccessRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.guestId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.memberId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.requestedAtUnixTime = longToNumber(reader.uint64());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.guestName = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.guestCurrentlyEquippedWearables = exports.DBOutfit.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.isMobile = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.meetingLink = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAccessRequestsUpdated() {
    return { requests: [] };
}
exports.AccessRequestsUpdated = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.requests) {
            exports.AccessRequest.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccessRequestsUpdated();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.requests.push(exports.AccessRequest.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAccessRequestRespondedTo() {
    return { targetId: "", accepted: false, location: undefined };
}
exports.AccessRequestRespondedTo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.targetId !== "") {
            writer.uint32(10).string(message.targetId);
        }
        if (message.accepted === true) {
            writer.uint32(16).bool(message.accepted);
        }
        if (message.location !== undefined) {
            exports.MapLocation.encode(message.location, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAccessRequestRespondedTo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.accepted = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.location = exports.MapLocation.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerGuestPassStatus() {
    return { userId: "", guestPassStatus: "" };
}
exports.PlayerGuestPassStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        if (message.guestPassStatus !== "") {
            writer.uint32(18).string(message.guestPassStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerGuestPassStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.guestPassStatus = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetDeskFromNextAvailableDesk() {
    return { desksToIgnore: [] };
}
exports.SetDeskFromNextAvailableDesk = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.targetId !== undefined) {
            writer.uint32(10).string(message.targetId);
        }
        if (message.preferredDesk !== undefined) {
            exports.MapAndDesk.encode(message.preferredDesk, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.desksToIgnore) {
            exports.MapAndDesk.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.deskTemplateId !== undefined) {
            writer.uint32(34).string(message.deskTemplateId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetDeskFromNextAvailableDesk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.preferredDesk = exports.MapAndDesk.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.desksToIgnore.push(exports.MapAndDesk.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.deskTemplateId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpaceRolePermissionOverrideUpdated() {
    return { role: "", permission: "", enabled: false };
}
exports.SpaceRolePermissionOverrideUpdated = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.role !== "") {
            writer.uint32(10).string(message.role);
        }
        if (message.permission !== "") {
            writer.uint32(18).string(message.permission);
        }
        if (message.enabled === true) {
            writer.uint32(24).bool(message.enabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpaceRolePermissionOverrideUpdated();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.role = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.permission = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.enabled = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerRequestsToCowork() {
    return { encId: 0, nookId: "" };
}
exports.PlayerRequestsToCowork = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.nookId !== "") {
            writer.uint32(18).string(message.nookId);
        }
        if (message.autoInvite !== undefined) {
            writer.uint32(24).bool(message.autoInvite);
        }
        if (message.mapId !== undefined) {
            writer.uint32(34).string(message.mapId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerRequestsToCowork();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.nookId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.autoInvite = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatSetsSessionToken() {
    return { token: "" };
}
exports.ChatSetsSessionToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.token !== "") {
            writer.uint32(10).string(message.token);
        }
        if (message.expiresAt !== undefined) {
            writer.uint32(18).string(message.expiresAt);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatSetsSessionToken();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.expiresAt = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatCreatesGroupDmChannel() {
    return { playerIds: [], channelUrl: "" };
}
exports.ChatCreatesGroupDmChannel = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.playerIds) {
            writer.uint32(10).string(v);
        }
        if (message.channelUrl !== "") {
            writer.uint32(18).string(message.channelUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatCreatesGroupDmChannel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.playerIds.push(reader.string());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.channelUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerPromotesToMember() {
    return { userId: "", promoterId: "" };
}
exports.PlayerPromotesToMember = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        if (message.promoterId !== "") {
            writer.uint32(18).string(message.promoterId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerPromotesToMember();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.promoterId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerRequestsPromoteToMember() {
    return { requesterId: "" };
}
exports.PlayerRequestsPromoteToMember = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.requesterId !== "") {
            writer.uint32(10).string(message.requesterId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerRequestsPromoteToMember();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.requesterId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePromoteToMemberRespondedTo() {
    return { encId: 0, requesterId: "", response: 0 };
}
exports.PromoteToMemberRespondedTo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encId !== 0) {
            writer.uint32(8).uint32(message.encId);
        }
        if (message.requesterId !== "") {
            writer.uint32(18).string(message.requesterId);
        }
        if (message.response !== 0) {
            writer.uint32(24).int32(message.response);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePromoteToMemberRespondedTo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.encId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.requesterId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.response = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestPromoteToMemberResponseEnum() {
    return {};
}
exports.RequestPromoteToMemberResponseEnum = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestPromoteToMemberResponseEnum();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRespondToRequestPromoteToMember() {
    return { requesterId: "", response: 0 };
}
exports.RespondToRequestPromoteToMember = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.requesterId !== "") {
            writer.uint32(10).string(message.requesterId);
        }
        if (message.response !== 0) {
            writer.uint32(16).int32(message.response);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRespondToRequestPromoteToMember();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.requesterId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.response = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerInvitesAsMember() {
    return { inviteToken: "", inviterId: "" };
}
exports.PlayerInvitesAsMember = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.inviteToken !== "") {
            writer.uint32(10).string(message.inviteToken);
        }
        if (message.inviterId !== "") {
            writer.uint32(18).string(message.inviterId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerInvitesAsMember();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.inviteToken = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.inviterId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerShouldSendGrapes() {
    return { userId: "" };
}
exports.PlayerShouldSendGrapes = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerShouldSendGrapes();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseOfflinePlayerSetsDeskInfo() {
    return { userId: "", deskInfo: undefined };
}
exports.OfflinePlayerSetsDeskInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        if (message.deskInfo !== undefined) {
            exports.DeskInfoV2.encode(message.deskInfo, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOfflinePlayerSetsDeskInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.deskInfo = exports.DeskInfoV2.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseNookAccessRequestRespondedTo() {
    return { accepted: false, mapId: "", nookId: "" };
}
exports.NookAccessRequestRespondedTo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.accepted === true) {
            writer.uint32(8).bool(message.accepted);
        }
        if (message.mapId !== "") {
            writer.uint32(18).string(message.mapId);
        }
        if (message.nookId !== "") {
            writer.uint32(26).string(message.nookId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNookAccessRequestRespondedTo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.accepted = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.nookId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatReactsToGift() {
    return { channelUrl: "" };
}
exports.ChatReactsToGift = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channelUrl !== "") {
            writer.uint32(10).string(message.channelUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatReactsToGift();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channelUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlayerLiveCursor() {
    return { playerId: "", screenId: "", enabled: false };
}
exports.PlayerLiveCursor = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.playerId !== "") {
            writer.uint32(10).string(message.playerId);
        }
        if (message.screenId !== "") {
            writer.uint32(18).string(message.screenId);
        }
        if (message.enabled === true) {
            writer.uint32(24).bool(message.enabled);
        }
        if (message.color !== undefined) {
            writer.uint32(34).string(message.color);
        }
        if (message.x !== undefined) {
            writer.uint32(45).float(message.x);
        }
        if (message.y !== undefined) {
            writer.uint32(53).float(message.y);
        }
        if (message.toolId !== undefined) {
            writer.uint32(58).string(message.toolId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlayerLiveCursor();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.playerId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.screenId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.enabled = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
                case 5:
                    if (tag !== 45) {
                        break;
                    }
                    message.x = reader.float();
                    continue;
                case 6:
                    if (tag !== 53) {
                        break;
                    }
                    message.y = reader.float();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.toolId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseClientServerBatch() {
    return { actions: [] };
}
exports.ClientServerBatch = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.actions) {
            exports.ClientServerAction.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientServerBatch();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.actions.push(exports.ClientServerAction.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseClientServerAction() {
    return { action: undefined };
}
exports.ClientServerAction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.txnId !== undefined) {
            writer.uint32(800).uint32(message.txnId);
        }
        switch (message.action?.$case) {
            case "clientHeartbeat":
                exports.ClientHeartbeat.encode(message.action.clientHeartbeat, writer.uint32(10).fork()).ldelim();
                break;
            case "clientBackupHeartbeat":
                exports.ClientBackupHeartbeat.encode(message.action.clientBackupHeartbeat, writer.uint32(18).fork()).ldelim();
                break;
            case "updateSubscriptions":
                exports.UpdateSubscriptions.encode(message.action.updateSubscriptions, writer.uint32(26).fork()).ldelim();
                break;
            case "move":
                exports.Move.encode(message.action.move, writer.uint32(42).fork()).ldelim();
                break;
            case "setAffiliation":
                exports.SetAffiliation.encode(message.action.setAffiliation, writer.uint32(58).fork()).ldelim();
                break;
            case "setStatus":
                exports.SetStatus.encode(message.action.setStatus, writer.uint32(66).fork()).ldelim();
                break;
            case "spotlight":
                exports.Spotlight.encode(message.action.spotlight, writer.uint32(74).fork()).ldelim();
                break;
            case "ring":
                exports.Ring.encode(message.action.ring, writer.uint32(82).fork()).ldelim();
                break;
            case "ban":
                exports.Ban.encode(message.action.ban, writer.uint32(98).fork()).ldelim();
                break;
            case "kick":
                exports.Kick.encode(message.action.kick, writer.uint32(106).fork()).ldelim();
                break;
            case "setImpassable":
                exports.SetImpassable.encode(message.action.setImpassable, writer.uint32(114).fork()).ldelim();
                break;
            case "chat":
                exports.Chat.encode(message.action.chat, writer.uint32(122).fork()).ldelim();
                break;
            case "interact":
                exports.Deprecated.encode(message.action.interact, writer.uint32(146).fork()).ldelim();
                break;
            case "enterWhisper":
                exports.EnterWhisper.encode(message.action.enterWhisper, writer.uint32(154).fork()).ldelim();
                break;
            case "leaveWhisper":
                exports.LeaveWhisper.encode(message.action.leaveWhisper, writer.uint32(162).fork()).ldelim();
                break;
            case "setEmojiStatus":
                exports.SetEmojiStatus.encode(message.action.setEmojiStatus, writer.uint32(170).fork()).ldelim();
                break;
            case "activelySpeaking":
                exports.ActivelySpeaking.encode(message.action.activelySpeaking, writer.uint32(178).fork()).ldelim();
                break;
            case "setName":
                exports.SetName.encode(message.action.setName, writer.uint32(194).fork()).ldelim();
                break;
            case "setTextStatus":
                exports.SetTextStatus.encode(message.action.setTextStatus, writer.uint32(202).fork()).ldelim();
                break;
            case "teleport":
                exports.Teleport.encode(message.action.teleport, writer.uint32(210).fork()).ldelim();
                break;
            case "exit":
                exports.Exit.encode(message.action.exit, writer.uint32(218).fork()).ldelim();
                break;
            case "enter":
                exports.Enter.encode(message.action.enter, writer.uint32(226).fork()).ldelim();
                break;
            case "setWorkCondition":
                exports.Deprecated.encode(message.action.setWorkCondition, writer.uint32(234).fork()).ldelim();
                break;
            case "respawn":
                exports.Respawn.encode(message.action.respawn, writer.uint32(242).fork()).ldelim();
                break;
            case "spawn":
                exports.Spawn.encode(message.action.spawn, writer.uint32(250).fork()).ldelim();
                break;
            case "ghost":
                exports.Ghost.encode(message.action.ghost, writer.uint32(258).fork()).ldelim();
                break;
            case "init":
                exports.Init.encode(message.action.init, writer.uint32(266).fork()).ldelim();
                break;
            case "setOutfitString":
                exports.Deprecated.encode(message.action.setOutfitString, writer.uint32(274).fork()).ldelim();
                break;
            case "shootConfetti":
                exports.ShootConfetti.encode(message.action.shootConfetti, writer.uint32(290).fork()).ldelim();
                break;
            case "setEventStatus":
                exports.SetEventStatus.encode(message.action.setEventStatus, writer.uint32(298).fork()).ldelim();
                break;
            case "setInConversation":
                exports.SetInConversation.encode(message.action.setInConversation, writer.uint32(306).fork()).ldelim();
                break;
            case "setCurrentDesk":
                exports.Deprecated.encode(message.action.setCurrentDesk, writer.uint32(314).fork()).ldelim();
                break;
            case "setCurrentArea":
                exports.Deprecated.encode(message.action.setCurrentArea, writer.uint32(322).fork()).ldelim();
                break;
            case "setImagePointer":
                exports.SetImagePointer.encode(message.action.setImagePointer, writer.uint32(330).fork()).ldelim();
                break;
            case "setGoKartId":
                exports.Deprecated.encode(message.action.setGoKartId, writer.uint32(338).fork()).ldelim();
                break;
            case "mapSetDimensions":
                exports.Deprecated.encode(message.action.mapSetDimensions, writer.uint32(346).fork()).ldelim();
                break;
            case "mapSetCollisions":
                exports.MapSetCollisions.encode(message.action.mapSetCollisions, writer.uint32(354).fork()).ldelim();
                break;
            case "mapSetBackgroundImagePath":
                exports.MapSetBackgroundImagePath.encode(message.action.mapSetBackgroundImagePath, writer.uint32(362).fork()).ldelim();
                break;
            case "mapSetForegroundImagePath":
                exports.MapSetForegroundImagePath.encode(message.action.mapSetForegroundImagePath, writer.uint32(370).fork()).ldelim();
                break;
            case "mapSetSprites":
                exports.Deprecated.encode(message.action.mapSetSprites, writer.uint32(378).fork()).ldelim();
                break;
            case "mapSetSpawns":
                exports.MapSetSpawns.encode(message.action.mapSetSpawns, writer.uint32(386).fork()).ldelim();
                break;
            case "mapSetSpaces":
                exports.Deprecated.encode(message.action.mapSetSpaces, writer.uint32(394).fork()).ldelim();
                break;
            case "mapSetPortals":
                exports.MapSetPortals.encode(message.action.mapSetPortals, writer.uint32(402).fork()).ldelim();
                break;
            case "mapSetAnnouncer":
                exports.MapSetAnnouncer.encode(message.action.mapSetAnnouncer, writer.uint32(410).fork()).ldelim();
                break;
            case "mapSetAssets":
                exports.MapSetAssets.encode(message.action.mapSetAssets, writer.uint32(434).fork()).ldelim();
                break;
            case "mapSetObjects":
                exports.Deprecated.encode(message.action.mapSetObjects, writer.uint32(442).fork()).ldelim();
                break;
            case "mapSetName":
                exports.MapSetName.encode(message.action.mapSetName, writer.uint32(450).fork()).ldelim();
                break;
            case "mapSetMuteOnEntry":
                exports.MapSetMuteOnEntry.encode(message.action.mapSetMuteOnEntry, writer.uint32(466).fork()).ldelim();
                break;
            case "mapSetUseDrawnBG":
                exports.MapSetUseDrawnBG.encode(message.action.mapSetUseDrawnBG, writer.uint32(474).fork()).ldelim();
                break;
            case "mapSetWalls":
                exports.MapSetWalls.encode(message.action.mapSetWalls, writer.uint32(482).fork()).ldelim();
                break;
            case "mapSetFloors":
                exports.MapSetFloors.encode(message.action.mapSetFloors, writer.uint32(490).fork()).ldelim();
                break;
            case "mapSetAreas":
                exports.MapSetAreas.encode(message.action.mapSetAreas, writer.uint32(498).fork()).ldelim();
                break;
            case "mapAddObject":
                exports.MapAddObject.encode(message.action.mapAddObject, writer.uint32(506).fork()).ldelim();
                break;
            case "mapDeleteObject":
                exports.Deprecated.encode(message.action.mapDeleteObject, writer.uint32(514).fork()).ldelim();
                break;
            case "mapSetSpawn":
                exports.MapSetSpawn.encode(message.action.mapSetSpawn, writer.uint32(522).fork()).ldelim();
                break;
            case "setIsAlone":
                exports.SetIsAlone.encode(message.action.setIsAlone, writer.uint32(530).fork()).ldelim();
                break;
            case "mapSetMiniMapImagePath":
                exports.MapSetMiniMapImagePath.encode(message.action.mapSetMiniMapImagePath, writer.uint32(538).fork()).ldelim();
                break;
            case "mapSetEnabledChats":
                exports.MapSetEnabledChats.encode(message.action.mapSetEnabledChats, writer.uint32(546).fork()).ldelim();
                break;
            case "mapSetDescription":
                exports.MapSetDescription.encode(message.action.mapSetDescription, writer.uint32(554).fork()).ldelim();
                break;
            case "mapSetDecoration":
                exports.MapSetDecoration.encode(message.action.mapSetDecoration, writer.uint32(562).fork()).ldelim();
                break;
            case "mapSetTutorialTasks":
                exports.MapSetTutorialTasks.encode(message.action.mapSetTutorialTasks, writer.uint32(570).fork()).ldelim();
                break;
            case "playSound":
                exports.PlaySound.encode(message.action.playSound, writer.uint32(578).fork()).ldelim();
                break;
            case "mapSetScript":
                exports.Deprecated.encode(message.action.mapSetScript, writer.uint32(586).fork()).ldelim();
                break;
            case "setIsMobile":
                exports.SetIsMobile.encode(message.action.setIsMobile, writer.uint32(602).fork()).ldelim();
                break;
            case "setScreenPointer":
                exports.SetScreenPointer.encode(message.action.setScreenPointer, writer.uint32(610).fork()).ldelim();
                break;
            case "setEmoteV2":
                exports.SetEmoteV2.encode(message.action.setEmoteV2, writer.uint32(618).fork()).ldelim();
                break;
            case "setFocusModeEndTime":
                exports.SetFocusModeEndTime.encode(message.action.setFocusModeEndTime, writer.uint32(626).fork()).ldelim();
                break;
            case "mapDeleteObjectById":
                exports.MapDeleteObjectById.encode(message.action.mapDeleteObjectById, writer.uint32(634).fork()).ldelim();
                break;
            case "customAction":
                exports.CustomAction.encode(message.action.customAction, writer.uint32(642).fork()).ldelim();
                break;
            case "block":
                exports.Block.encode(message.action.block, writer.uint32(658).fork()).ldelim();
                break;
            case "setItemString":
                exports.SetItemString.encode(message.action.setItemString, writer.uint32(666).fork()).ldelim();
                break;
            case "triggerItem":
                exports.Deprecated.encode(message.action.triggerItem, writer.uint32(674).fork()).ldelim();
                break;
            case "notify":
                exports.Notify.encode(message.action.notify, writer.uint32(682).fork()).ldelim();
                break;
            case "setFollowTarget":
                exports.SetFollowTarget.encode(message.action.setFollowTarget, writer.uint32(690).fork()).ldelim();
                break;
            case "requestToLead":
                exports.RequestToLead.encode(message.action.requestToLead, writer.uint32(698).fork()).ldelim();
                break;
            case "enterPortal":
                exports.EnterPortal.encode(message.action.enterPortal, writer.uint32(706).fork()).ldelim();
                break;
            case "setManualVideoSrc":
                exports.SetManualVideoSrc.encode(message.action.setManualVideoSrc, writer.uint32(714).fork()).ldelim();
                break;
            case "setSubtitle":
                exports.SetSubtitle.encode(message.action.setSubtitle, writer.uint32(722).fork()).ldelim();
                break;
            case "playerUpdatesSession":
                exports.Deprecated.encode(message.action.playerUpdatesSession, writer.uint32(730).fork()).ldelim();
                break;
            case "mapMoveObject":
                exports.MapMoveObject.encode(message.action.mapMoveObject, writer.uint32(738).fork()).ldelim();
                break;
            case "chatMessageUpdated":
                exports.ChatMessageUpdated.encode(message.action.chatMessageUpdated, writer.uint32(746).fork()).ldelim();
                break;
            case "fxShakeObject":
                exports.FXShakeObject.encode(message.action.fxShakeObject, writer.uint32(754).fork()).ldelim();
                break;
            case "fxShakeCamera":
                exports.FXShakeCamera.encode(message.action.fxShakeCamera, writer.uint32(762).fork()).ldelim();
                break;
            case "registerCommand":
                exports.RegisterCommand.encode(message.action.registerCommand, writer.uint32(770).fork()).ldelim();
                break;
            case "sendCommand":
                exports.SendCommand.encode(message.action.sendCommand, writer.uint32(778).fork()).ldelim();
                break;
            case "speakerUpdatesSession":
                exports.SpeakerUpdatesSession.encode(message.action.speakerUpdatesSession, writer.uint32(786).fork()).ldelim();
                break;
            case "addInventoryItem":
                exports.AddInventoryItem.encode(message.action.addInventoryItem, writer.uint32(810).fork()).ldelim();
                break;
            case "removeInventoryItem":
                exports.RemoveInventoryItem.encode(message.action.removeInventoryItem, writer.uint32(818).fork()).ldelim();
                break;
            case "setVehicleId":
                exports.SetVehicleId.encode(message.action.setVehicleId, writer.uint32(826).fork()).ldelim();
                break;
            case "setSpeedModifier":
                exports.SetSpeedModifier.encode(message.action.setSpeedModifier, writer.uint32(834).fork()).ldelim();
                break;
            case "highFive":
                exports.HighFive.encode(message.action.highFive, writer.uint32(842).fork()).ldelim();
                break;
            case "updateSpaceItems":
                exports.SpaceUpdatesItems.encode(message.action.updateSpaceItems, writer.uint32(858).fork()).ldelim();
                break;
            case "stopSound":
                exports.StopSound.encode(message.action.stopSound, writer.uint32(866).fork()).ldelim();
                break;
            case "hipToBeSquare":
                exports.HipToBeSquare.encode(message.action.hipToBeSquare, writer.uint32(874).fork()).ldelim();
                break;
            case "craft":
                exports.Craft.encode(message.action.craft, writer.uint32(882).fork()).ldelim();
                break;
            case "triggerInventoryItem":
                exports.TriggerInventoryItem.encode(message.action.triggerInventoryItem, writer.uint32(890).fork()).ldelim();
                break;
            case "setAllowScreenPointer":
                exports.SetAllowScreenPointer.encode(message.action.setAllowScreenPointer, writer.uint32(898).fork()).ldelim();
                break;
            case "precomputeEnter":
                exports.PrecomputeEnter.encode(message.action.precomputeEnter, writer.uint32(906).fork()).ldelim();
                break;
            case "requestMute":
                exports.RequestMute.encode(message.action.requestMute, writer.uint32(914).fork()).ldelim();
                break;
            case "setDeskInfo":
                exports.SetDeskInfo.encode(message.action.setDeskInfo, writer.uint32(922).fork()).ldelim();
                break;
            case "mapSetNooks":
                exports.MapSetNooks.encode(message.action.mapSetNooks, writer.uint32(930).fork()).ldelim();
                break;
            case "requestToJoinNook":
                exports.RequestToJoinNook.encode(message.action.requestToJoinNook, writer.uint32(938).fork()).ldelim();
                break;
            case "updateNookPermission":
                exports.UpdateNookPermission.encode(message.action.updateNookPermission, writer.uint32(946).fork()).ldelim();
                break;
            case "wave":
                exports.Wave.encode(message.action.wave, writer.uint32(954).fork()).ldelim();
                break;
            case "setPronouns":
                exports.SetPronouns.encode(message.action.setPronouns, writer.uint32(962).fork()).ldelim();
                break;
            case "setTitle":
                exports.SetTitle.encode(message.action.setTitle, writer.uint32(970).fork()).ldelim();
                break;
            case "setTimezone":
                exports.SetTimezone.encode(message.action.setTimezone, writer.uint32(978).fork()).ldelim();
                break;
            case "setPhone":
                exports.SetPhone.encode(message.action.setPhone, writer.uint32(986).fork()).ldelim();
                break;
            case "setDescription":
                exports.SetDescription.encode(message.action.setDescription, writer.uint32(994).fork()).ldelim();
                break;
            case "setProfileImageUrl":
                exports.SetProfileImageUrl.encode(message.action.setProfileImageUrl, writer.uint32(1002).fork()).ldelim();
                break;
            case "setPersonalImageUrl":
                exports.SetPersonalImageUrl.encode(message.action.setPersonalImageUrl, writer.uint32(1010).fork()).ldelim();
                break;
            case "setAway":
                exports.SetAway.encode(message.action.setAway, writer.uint32(1018).fork()).ldelim();
                break;
            case "setCity":
                exports.SetCity.encode(message.action.setCity, writer.uint32(1026).fork()).ldelim();
                break;
            case "setCountry":
                exports.SetCountry.encode(message.action.setCountry, writer.uint32(1034).fork()).ldelim();
                break;
            case "setStartDate":
                exports.SetStartDate.encode(message.action.setStartDate, writer.uint32(1042).fork()).ldelim();
                break;
            case "oldDeprecatedStartRecording":
                exports.Deprecated.encode(message.action.oldDeprecatedStartRecording, writer.uint32(1050).fork()).ldelim();
                break;
            case "requestAccessViaCheckIn":
                exports.RequestAccessViaCheckIn.encode(message.action.requestAccessViaCheckIn, writer.uint32(1058).fork()).ldelim();
                break;
            case "respondToAccessRequest":
                exports.RespondToAccessRequest.encode(message.action.respondToAccessRequest, writer.uint32(1066).fork()).ldelim();
                break;
            case "setAvailability":
                exports.SetAvailability.encode(message.action.setAvailability, writer.uint32(1074).fork()).ldelim();
                break;
            case "respawnAtDesk":
                exports.RespawnAtDesk.encode(message.action.respawnAtDesk, writer.uint32(1098).fork()).ldelim();
                break;
            case "setDeskFromNextAvailableDesk":
                exports.SetDeskFromNextAvailableDesk.encode(message.action.setDeskFromNextAvailableDesk, writer.uint32(1106).fork())
                    .ldelim();
                break;
            case "setSpaceRolePermissionOverride":
                exports.SetSpaceRolePermissionOverride.encode(message.action.setSpaceRolePermissionOverride, writer.uint32(1114).fork())
                    .ldelim();
                break;
            case "setCurrentlyEquippedWearables":
                exports.SetCurrentlyEquippedWearables.encode(message.action.setCurrentlyEquippedWearables, writer.uint32(1122).fork())
                    .ldelim();
                break;
            case "setDisplayEmail":
                exports.SetDisplayEmail.encode(message.action.setDisplayEmail, writer.uint32(1130).fork()).ldelim();
                break;
            case "mapDeleteObjectByKey":
                exports.MapDeleteObjectByKey.encode(message.action.mapDeleteObjectByKey, writer.uint32(1138).fork()).ldelim();
                break;
            case "mapUpdateObjects":
                exports.MapUpdateObjects.encode(message.action.mapUpdateObjects, writer.uint32(1146).fork()).ldelim();
                break;
            case "interactWithObject":
                exports.InteractWithObject.encode(message.action.interactWithObject, writer.uint32(1154).fork()).ldelim();
                break;
            case "triggerObject":
                exports.TriggerObject.encode(message.action.triggerObject, writer.uint32(1162).fork()).ldelim();
                break;
            case "joinChimeMeeting":
                exports.Deprecated.encode(message.action.joinChimeMeeting, writer.uint32(1170).fork()).ldelim();
                break;
            case "setAmbientPlayersMuted":
                exports.SetAmbientPlayersMuted.encode(message.action.setAmbientPlayersMuted, writer.uint32(1178).fork()).ldelim();
                break;
            case "setMobileLastActive":
                exports.SetMobileLastActive.encode(message.action.setMobileLastActive, writer.uint32(1186).fork()).ldelim();
                break;
            case "cancelRequestToLead":
                exports.CancelRequestToLead.encode(message.action.cancelRequestToLead, writer.uint32(1194).fork()).ldelim();
                break;
            case "respondToRequestToLead":
                exports.RespondToRequestToLead.encode(message.action.respondToRequestToLead, writer.uint32(1202).fork()).ldelim();
                break;
            case "setActivityStatus":
                exports.SetActivityStatus.encode(message.action.setActivityStatus, writer.uint32(1210).fork()).ldelim();
                break;
            case "startRecording":
                exports.StartRecording.encode(message.action.startRecording, writer.uint32(1218).fork()).ldelim();
                break;
            case "stopRecording":
                exports.StopRecording.encode(message.action.stopRecording, writer.uint32(1226).fork()).ldelim();
                break;
            case "requestToCowork":
                exports.RequestToCowork.encode(message.action.requestToCowork, writer.uint32(1234).fork()).ldelim();
                break;
            case "setCoworkingAreaStatus":
                exports.Deprecated.encode(message.action.setCoworkingAreaStatus, writer.uint32(1242).fork()).ldelim();
                break;
            case "mapSetDeskPods":
                exports.MapSetDeskPods.encode(message.action.mapSetDeskPods, writer.uint32(1250).fork()).ldelim();
                break;
            case "chatRefreshSessionToken":
                exports.ChatRefreshSessionToken.encode(message.action.chatRefreshSessionToken, writer.uint32(1258).fork()).ldelim();
                break;
            case "chatInitiateDm":
                exports.ChatInitiateDm.encode(message.action.chatInitiateDm, writer.uint32(1266).fork()).ldelim();
                break;
            case "mapAddObjects":
                exports.MapAddObjects.encode(message.action.mapAddObjects, writer.uint32(1274).fork()).ldelim();
                break;
            case "mapDeleteObjectsById":
                exports.MapDeleteObjectsById.encode(message.action.mapDeleteObjectsById, writer.uint32(1282).fork()).ldelim();
                break;
            case "promoteToMember":
                exports.PromoteToMember.encode(message.action.promoteToMember, writer.uint32(1290).fork()).ldelim();
                break;
            case "invokeGrapes":
                exports.InvokeGrapes.encode(message.action.invokeGrapes, writer.uint32(1298).fork()).ldelim();
                break;
            case "setProfileImageId":
                exports.SetProfileImageId.encode(message.action.setProfileImageId, writer.uint32(1306).fork()).ldelim();
                break;
            case "setPersonalImageId":
                exports.SetPersonalImageId.encode(message.action.setPersonalImageId, writer.uint32(1314).fork()).ldelim();
                break;
            case "reactToObject":
                exports.ReactToObject.encode(message.action.reactToObject, writer.uint32(1322).fork()).ldelim();
                break;
            case "chatAddUsersToGroupChannel":
                exports.ChatAddUsersToGroupChannel.encode(message.action.chatAddUsersToGroupChannel, writer.uint32(1330).fork())
                    .ldelim();
                break;
            case "chatV2":
                exports.ChatV2.encode(message.action.chatV2, writer.uint32(1338).fork()).ldelim();
                break;
            case "setStatusV2":
                exports.SetStatusV2.encode(message.action.setStatusV2, writer.uint32(1346).fork()).ldelim();
                break;
            case "mapApplyEditActions":
                exports.MapApplyEditActions.encode(message.action.mapApplyEditActions, writer.uint32(1354).fork()).ldelim();
                break;
            case "setHandRaised":
                exports.SetHandRaised.encode(message.action.setHandRaised, writer.uint32(1362).fork()).ldelim();
                break;
            case "liveCursor":
                exports.LiveCursor.encode(message.action.liveCursor, writer.uint32(1370).fork()).ldelim();
                break;
            case "shimmy":
                exports.Shimmy.encode(message.action.shimmy, writer.uint32(1378).fork()).ldelim();
                break;
            case "startAnnotationSession":
                exports.StartAnnotationSession.encode(message.action.startAnnotationSession, writer.uint32(1386).fork()).ldelim();
                break;
            case "requestAnnotationSession":
                exports.RequestAnnotationSession.encode(message.action.requestAnnotationSession, writer.uint32(1394).fork()).ldelim();
                break;
            case "clearAllAnnotations":
                exports.ClearAllAnnotations.encode(message.action.clearAllAnnotations, writer.uint32(1410).fork()).ldelim();
                break;
            case "clearPlayersAnnotations":
                exports.ClearAnnotations.encode(message.action.clearPlayersAnnotations, writer.uint32(1418).fork()).ldelim();
                break;
            case "loadAnnotationSession":
                exports.LoadAnnotationSession.encode(message.action.loadAnnotationSession, writer.uint32(1426).fork()).ldelim();
                break;
            case "sendAnnotationSession":
                exports.SendAnnotationSession.encode(message.action.sendAnnotationSession, writer.uint32(1442).fork()).ldelim();
                break;
            case "annotationRequestDenied":
                exports.AnnotationRequestDenied.encode(message.action.annotationRequestDenied, writer.uint32(1450).fork()).ldelim();
                break;
            case "playerSendsAnnotationDelta":
                exports.AnnotationDelta.encode(message.action.playerSendsAnnotationDelta, writer.uint32(1458).fork()).ldelim();
                break;
            case "requestPromoteToMember":
                exports.RequestPromoteToMember.encode(message.action.requestPromoteToMember, writer.uint32(1466).fork()).ldelim();
                break;
            case "respondToRequestPromoteToMember":
                exports.RespondToRequestPromoteToMember.encode(message.action.respondToRequestPromoteToMember, writer.uint32(1474).fork()).ldelim();
                break;
            case "chatTombstoneMessage":
                exports.ChatTombstoneMessage.encode(message.action.chatTombstoneMessage, writer.uint32(1482).fork()).ldelim();
                break;
            case "chatV2SendMessage":
                exports.ChatV2SendMessage.encode(message.action.chatV2SendMessage, writer.uint32(1490).fork()).ldelim();
                break;
            case "getAnnotationSessions":
                exports.GetAnnotationSessions.encode(message.action.getAnnotationSessions, writer.uint32(1498).fork()).ldelim();
                break;
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientServerAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 100:
                    if (tag !== 800) {
                        break;
                    }
                    message.txnId = reader.uint32();
                    continue;
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.action = {
                        $case: "clientHeartbeat",
                        clientHeartbeat: exports.ClientHeartbeat.decode(reader, reader.uint32()),
                    };
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.action = {
                        $case: "clientBackupHeartbeat",
                        clientBackupHeartbeat: exports.ClientBackupHeartbeat.decode(reader, reader.uint32()),
                    };
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.action = {
                        $case: "updateSubscriptions",
                        updateSubscriptions: exports.UpdateSubscriptions.decode(reader, reader.uint32()),
                    };
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.action = { $case: "move", move: exports.Move.decode(reader, reader.uint32()) };
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.action = { $case: "setAffiliation", setAffiliation: exports.SetAffiliation.decode(reader, reader.uint32()) };
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.action = { $case: "setStatus", setStatus: exports.SetStatus.decode(reader, reader.uint32()) };
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.action = { $case: "spotlight", spotlight: exports.Spotlight.decode(reader, reader.uint32()) };
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.action = { $case: "ring", ring: exports.Ring.decode(reader, reader.uint32()) };
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.action = { $case: "ban", ban: exports.Ban.decode(reader, reader.uint32()) };
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.action = { $case: "kick", kick: exports.Kick.decode(reader, reader.uint32()) };
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.action = { $case: "setImpassable", setImpassable: exports.SetImpassable.decode(reader, reader.uint32()) };
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.action = { $case: "chat", chat: exports.Chat.decode(reader, reader.uint32()) };
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.action = { $case: "interact", interact: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.action = { $case: "enterWhisper", enterWhisper: exports.EnterWhisper.decode(reader, reader.uint32()) };
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.action = { $case: "leaveWhisper", leaveWhisper: exports.LeaveWhisper.decode(reader, reader.uint32()) };
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.action = { $case: "setEmojiStatus", setEmojiStatus: exports.SetEmojiStatus.decode(reader, reader.uint32()) };
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.action = {
                        $case: "activelySpeaking",
                        activelySpeaking: exports.ActivelySpeaking.decode(reader, reader.uint32()),
                    };
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.action = { $case: "setName", setName: exports.SetName.decode(reader, reader.uint32()) };
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.action = { $case: "setTextStatus", setTextStatus: exports.SetTextStatus.decode(reader, reader.uint32()) };
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.action = { $case: "teleport", teleport: exports.Teleport.decode(reader, reader.uint32()) };
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.action = { $case: "exit", exit: exports.Exit.decode(reader, reader.uint32()) };
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.action = { $case: "enter", enter: exports.Enter.decode(reader, reader.uint32()) };
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.action = { $case: "setWorkCondition", setWorkCondition: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.action = { $case: "respawn", respawn: exports.Respawn.decode(reader, reader.uint32()) };
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.action = { $case: "spawn", spawn: exports.Spawn.decode(reader, reader.uint32()) };
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.action = { $case: "ghost", ghost: exports.Ghost.decode(reader, reader.uint32()) };
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.action = { $case: "init", init: exports.Init.decode(reader, reader.uint32()) };
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.action = { $case: "setOutfitString", setOutfitString: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.action = { $case: "shootConfetti", shootConfetti: exports.ShootConfetti.decode(reader, reader.uint32()) };
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.action = { $case: "setEventStatus", setEventStatus: exports.SetEventStatus.decode(reader, reader.uint32()) };
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.action = {
                        $case: "setInConversation",
                        setInConversation: exports.SetInConversation.decode(reader, reader.uint32()),
                    };
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.action = { $case: "setCurrentDesk", setCurrentDesk: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.action = { $case: "setCurrentArea", setCurrentArea: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.action = {
                        $case: "setImagePointer",
                        setImagePointer: exports.SetImagePointer.decode(reader, reader.uint32()),
                    };
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.action = { $case: "setGoKartId", setGoKartId: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.action = { $case: "mapSetDimensions", mapSetDimensions: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 44:
                    if (tag !== 354) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetCollisions",
                        mapSetCollisions: exports.MapSetCollisions.decode(reader, reader.uint32()),
                    };
                    continue;
                case 45:
                    if (tag !== 362) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetBackgroundImagePath",
                        mapSetBackgroundImagePath: exports.MapSetBackgroundImagePath.decode(reader, reader.uint32()),
                    };
                    continue;
                case 46:
                    if (tag !== 370) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetForegroundImagePath",
                        mapSetForegroundImagePath: exports.MapSetForegroundImagePath.decode(reader, reader.uint32()),
                    };
                    continue;
                case 47:
                    if (tag !== 378) {
                        break;
                    }
                    message.action = { $case: "mapSetSprites", mapSetSprites: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 48:
                    if (tag !== 386) {
                        break;
                    }
                    message.action = { $case: "mapSetSpawns", mapSetSpawns: exports.MapSetSpawns.decode(reader, reader.uint32()) };
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.action = { $case: "mapSetSpaces", mapSetSpaces: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.action = { $case: "mapSetPortals", mapSetPortals: exports.MapSetPortals.decode(reader, reader.uint32()) };
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetAnnouncer",
                        mapSetAnnouncer: exports.MapSetAnnouncer.decode(reader, reader.uint32()),
                    };
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.action = { $case: "mapSetAssets", mapSetAssets: exports.MapSetAssets.decode(reader, reader.uint32()) };
                    continue;
                case 55:
                    if (tag !== 442) {
                        break;
                    }
                    message.action = { $case: "mapSetObjects", mapSetObjects: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 56:
                    if (tag !== 450) {
                        break;
                    }
                    message.action = { $case: "mapSetName", mapSetName: exports.MapSetName.decode(reader, reader.uint32()) };
                    continue;
                case 58:
                    if (tag !== 466) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetMuteOnEntry",
                        mapSetMuteOnEntry: exports.MapSetMuteOnEntry.decode(reader, reader.uint32()),
                    };
                    continue;
                case 59:
                    if (tag !== 474) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetUseDrawnBG",
                        mapSetUseDrawnBG: exports.MapSetUseDrawnBG.decode(reader, reader.uint32()),
                    };
                    continue;
                case 60:
                    if (tag !== 482) {
                        break;
                    }
                    message.action = { $case: "mapSetWalls", mapSetWalls: exports.MapSetWalls.decode(reader, reader.uint32()) };
                    continue;
                case 61:
                    if (tag !== 490) {
                        break;
                    }
                    message.action = { $case: "mapSetFloors", mapSetFloors: exports.MapSetFloors.decode(reader, reader.uint32()) };
                    continue;
                case 62:
                    if (tag !== 498) {
                        break;
                    }
                    message.action = { $case: "mapSetAreas", mapSetAreas: exports.MapSetAreas.decode(reader, reader.uint32()) };
                    continue;
                case 63:
                    if (tag !== 506) {
                        break;
                    }
                    message.action = { $case: "mapAddObject", mapAddObject: exports.MapAddObject.decode(reader, reader.uint32()) };
                    continue;
                case 64:
                    if (tag !== 514) {
                        break;
                    }
                    message.action = { $case: "mapDeleteObject", mapDeleteObject: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 65:
                    if (tag !== 522) {
                        break;
                    }
                    message.action = { $case: "mapSetSpawn", mapSetSpawn: exports.MapSetSpawn.decode(reader, reader.uint32()) };
                    continue;
                case 66:
                    if (tag !== 530) {
                        break;
                    }
                    message.action = { $case: "setIsAlone", setIsAlone: exports.SetIsAlone.decode(reader, reader.uint32()) };
                    continue;
                case 67:
                    if (tag !== 538) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetMiniMapImagePath",
                        mapSetMiniMapImagePath: exports.MapSetMiniMapImagePath.decode(reader, reader.uint32()),
                    };
                    continue;
                case 68:
                    if (tag !== 546) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetEnabledChats",
                        mapSetEnabledChats: exports.MapSetEnabledChats.decode(reader, reader.uint32()),
                    };
                    continue;
                case 69:
                    if (tag !== 554) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetDescription",
                        mapSetDescription: exports.MapSetDescription.decode(reader, reader.uint32()),
                    };
                    continue;
                case 70:
                    if (tag !== 562) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetDecoration",
                        mapSetDecoration: exports.MapSetDecoration.decode(reader, reader.uint32()),
                    };
                    continue;
                case 71:
                    if (tag !== 570) {
                        break;
                    }
                    message.action = {
                        $case: "mapSetTutorialTasks",
                        mapSetTutorialTasks: exports.MapSetTutorialTasks.decode(reader, reader.uint32()),
                    };
                    continue;
                case 72:
                    if (tag !== 578) {
                        break;
                    }
                    message.action = { $case: "playSound", playSound: exports.PlaySound.decode(reader, reader.uint32()) };
                    continue;
                case 73:
                    if (tag !== 586) {
                        break;
                    }
                    message.action = { $case: "mapSetScript", mapSetScript: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 75:
                    if (tag !== 602) {
                        break;
                    }
                    message.action = { $case: "setIsMobile", setIsMobile: exports.SetIsMobile.decode(reader, reader.uint32()) };
                    continue;
                case 76:
                    if (tag !== 610) {
                        break;
                    }
                    message.action = {
                        $case: "setScreenPointer",
                        setScreenPointer: exports.SetScreenPointer.decode(reader, reader.uint32()),
                    };
                    continue;
                case 77:
                    if (tag !== 618) {
                        break;
                    }
                    message.action = { $case: "setEmoteV2", setEmoteV2: exports.SetEmoteV2.decode(reader, reader.uint32()) };
                    continue;
                case 78:
                    if (tag !== 626) {
                        break;
                    }
                    message.action = {
                        $case: "setFocusModeEndTime",
                        setFocusModeEndTime: exports.SetFocusModeEndTime.decode(reader, reader.uint32()),
                    };
                    continue;
                case 79:
                    if (tag !== 634) {
                        break;
                    }
                    message.action = {
                        $case: "mapDeleteObjectById",
                        mapDeleteObjectById: exports.MapDeleteObjectById.decode(reader, reader.uint32()),
                    };
                    continue;
                case 80:
                    if (tag !== 642) {
                        break;
                    }
                    message.action = { $case: "customAction", customAction: exports.CustomAction.decode(reader, reader.uint32()) };
                    continue;
                case 82:
                    if (tag !== 658) {
                        break;
                    }
                    message.action = { $case: "block", block: exports.Block.decode(reader, reader.uint32()) };
                    continue;
                case 83:
                    if (tag !== 666) {
                        break;
                    }
                    message.action = { $case: "setItemString", setItemString: exports.SetItemString.decode(reader, reader.uint32()) };
                    continue;
                case 84:
                    if (tag !== 674) {
                        break;
                    }
                    message.action = { $case: "triggerItem", triggerItem: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 85:
                    if (tag !== 682) {
                        break;
                    }
                    message.action = { $case: "notify", notify: exports.Notify.decode(reader, reader.uint32()) };
                    continue;
                case 86:
                    if (tag !== 690) {
                        break;
                    }
                    message.action = {
                        $case: "setFollowTarget",
                        setFollowTarget: exports.SetFollowTarget.decode(reader, reader.uint32()),
                    };
                    continue;
                case 87:
                    if (tag !== 698) {
                        break;
                    }
                    message.action = { $case: "requestToLead", requestToLead: exports.RequestToLead.decode(reader, reader.uint32()) };
                    continue;
                case 88:
                    if (tag !== 706) {
                        break;
                    }
                    message.action = { $case: "enterPortal", enterPortal: exports.EnterPortal.decode(reader, reader.uint32()) };
                    continue;
                case 89:
                    if (tag !== 714) {
                        break;
                    }
                    message.action = {
                        $case: "setManualVideoSrc",
                        setManualVideoSrc: exports.SetManualVideoSrc.decode(reader, reader.uint32()),
                    };
                    continue;
                case 90:
                    if (tag !== 722) {
                        break;
                    }
                    message.action = { $case: "setSubtitle", setSubtitle: exports.SetSubtitle.decode(reader, reader.uint32()) };
                    continue;
                case 91:
                    if (tag !== 730) {
                        break;
                    }
                    message.action = {
                        $case: "playerUpdatesSession",
                        playerUpdatesSession: exports.Deprecated.decode(reader, reader.uint32()),
                    };
                    continue;
                case 92:
                    if (tag !== 738) {
                        break;
                    }
                    message.action = { $case: "mapMoveObject", mapMoveObject: exports.MapMoveObject.decode(reader, reader.uint32()) };
                    continue;
                case 93:
                    if (tag !== 746) {
                        break;
                    }
                    message.action = {
                        $case: "chatMessageUpdated",
                        chatMessageUpdated: exports.ChatMessageUpdated.decode(reader, reader.uint32()),
                    };
                    continue;
                case 94:
                    if (tag !== 754) {
                        break;
                    }
                    message.action = { $case: "fxShakeObject", fxShakeObject: exports.FXShakeObject.decode(reader, reader.uint32()) };
                    continue;
                case 95:
                    if (tag !== 762) {
                        break;
                    }
                    message.action = { $case: "fxShakeCamera", fxShakeCamera: exports.FXShakeCamera.decode(reader, reader.uint32()) };
                    continue;
                case 96:
                    if (tag !== 770) {
                        break;
                    }
                    message.action = {
                        $case: "registerCommand",
                        registerCommand: exports.RegisterCommand.decode(reader, reader.uint32()),
                    };
                    continue;
                case 97:
                    if (tag !== 778) {
                        break;
                    }
                    message.action = { $case: "sendCommand", sendCommand: exports.SendCommand.decode(reader, reader.uint32()) };
                    continue;
                case 98:
                    if (tag !== 786) {
                        break;
                    }
                    message.action = {
                        $case: "speakerUpdatesSession",
                        speakerUpdatesSession: exports.SpeakerUpdatesSession.decode(reader, reader.uint32()),
                    };
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.action = {
                        $case: "addInventoryItem",
                        addInventoryItem: exports.AddInventoryItem.decode(reader, reader.uint32()),
                    };
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.action = {
                        $case: "removeInventoryItem",
                        removeInventoryItem: exports.RemoveInventoryItem.decode(reader, reader.uint32()),
                    };
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.action = { $case: "setVehicleId", setVehicleId: exports.SetVehicleId.decode(reader, reader.uint32()) };
                    continue;
                case 104:
                    if (tag !== 834) {
                        break;
                    }
                    message.action = {
                        $case: "setSpeedModifier",
                        setSpeedModifier: exports.SetSpeedModifier.decode(reader, reader.uint32()),
                    };
                    continue;
                case 105:
                    if (tag !== 842) {
                        break;
                    }
                    message.action = { $case: "highFive", highFive: exports.HighFive.decode(reader, reader.uint32()) };
                    continue;
                case 107:
                    if (tag !== 858) {
                        break;
                    }
                    message.action = {
                        $case: "updateSpaceItems",
                        updateSpaceItems: exports.SpaceUpdatesItems.decode(reader, reader.uint32()),
                    };
                    continue;
                case 108:
                    if (tag !== 866) {
                        break;
                    }
                    message.action = { $case: "stopSound", stopSound: exports.StopSound.decode(reader, reader.uint32()) };
                    continue;
                case 109:
                    if (tag !== 874) {
                        break;
                    }
                    message.action = { $case: "hipToBeSquare", hipToBeSquare: exports.HipToBeSquare.decode(reader, reader.uint32()) };
                    continue;
                case 110:
                    if (tag !== 882) {
                        break;
                    }
                    message.action = { $case: "craft", craft: exports.Craft.decode(reader, reader.uint32()) };
                    continue;
                case 111:
                    if (tag !== 890) {
                        break;
                    }
                    message.action = {
                        $case: "triggerInventoryItem",
                        triggerInventoryItem: exports.TriggerInventoryItem.decode(reader, reader.uint32()),
                    };
                    continue;
                case 112:
                    if (tag !== 898) {
                        break;
                    }
                    message.action = {
                        $case: "setAllowScreenPointer",
                        setAllowScreenPointer: exports.SetAllowScreenPointer.decode(reader, reader.uint32()),
                    };
                    continue;
                case 113:
                    if (tag !== 906) {
                        break;
                    }
                    message.action = {
                        $case: "precomputeEnter",
                        precomputeEnter: exports.PrecomputeEnter.decode(reader, reader.uint32()),
                    };
                    continue;
                case 114:
                    if (tag !== 914) {
                        break;
                    }
                    message.action = { $case: "requestMute", requestMute: exports.RequestMute.decode(reader, reader.uint32()) };
                    continue;
                case 115:
                    if (tag !== 922) {
                        break;
                    }
                    message.action = { $case: "setDeskInfo", setDeskInfo: exports.SetDeskInfo.decode(reader, reader.uint32()) };
                    continue;
                case 116:
                    if (tag !== 930) {
                        break;
                    }
                    message.action = { $case: "mapSetNooks", mapSetNooks: exports.MapSetNooks.decode(reader, reader.uint32()) };
                    continue;
                case 117:
                    if (tag !== 938) {
                        break;
                    }
                    message.action = {
                        $case: "requestToJoinNook",
                        requestToJoinNook: exports.RequestToJoinNook.decode(reader, reader.uint32()),
                    };
                    continue;
                case 118:
                    if (tag !== 946) {
                        break;
                    }
                    message.action = {
                        $case: "updateNookPermission",
                        updateNookPermission: exports.UpdateNookPermission.decode(reader, reader.uint32()),
                    };
                    continue;
                case 119:
                    if (tag !== 954) {
                        break;
                    }
                    message.action = { $case: "wave", wave: exports.Wave.decode(reader, reader.uint32()) };
                    continue;
                case 120:
                    if (tag !== 962) {
                        break;
                    }
                    message.action = { $case: "setPronouns", setPronouns: exports.SetPronouns.decode(reader, reader.uint32()) };
                    continue;
                case 121:
                    if (tag !== 970) {
                        break;
                    }
                    message.action = { $case: "setTitle", setTitle: exports.SetTitle.decode(reader, reader.uint32()) };
                    continue;
                case 122:
                    if (tag !== 978) {
                        break;
                    }
                    message.action = { $case: "setTimezone", setTimezone: exports.SetTimezone.decode(reader, reader.uint32()) };
                    continue;
                case 123:
                    if (tag !== 986) {
                        break;
                    }
                    message.action = { $case: "setPhone", setPhone: exports.SetPhone.decode(reader, reader.uint32()) };
                    continue;
                case 124:
                    if (tag !== 994) {
                        break;
                    }
                    message.action = { $case: "setDescription", setDescription: exports.SetDescription.decode(reader, reader.uint32()) };
                    continue;
                case 125:
                    if (tag !== 1002) {
                        break;
                    }
                    message.action = {
                        $case: "setProfileImageUrl",
                        setProfileImageUrl: exports.SetProfileImageUrl.decode(reader, reader.uint32()),
                    };
                    continue;
                case 126:
                    if (tag !== 1010) {
                        break;
                    }
                    message.action = {
                        $case: "setPersonalImageUrl",
                        setPersonalImageUrl: exports.SetPersonalImageUrl.decode(reader, reader.uint32()),
                    };
                    continue;
                case 127:
                    if (tag !== 1018) {
                        break;
                    }
                    message.action = { $case: "setAway", setAway: exports.SetAway.decode(reader, reader.uint32()) };
                    continue;
                case 128:
                    if (tag !== 1026) {
                        break;
                    }
                    message.action = { $case: "setCity", setCity: exports.SetCity.decode(reader, reader.uint32()) };
                    continue;
                case 129:
                    if (tag !== 1034) {
                        break;
                    }
                    message.action = { $case: "setCountry", setCountry: exports.SetCountry.decode(reader, reader.uint32()) };
                    continue;
                case 130:
                    if (tag !== 1042) {
                        break;
                    }
                    message.action = { $case: "setStartDate", setStartDate: exports.SetStartDate.decode(reader, reader.uint32()) };
                    continue;
                case 131:
                    if (tag !== 1050) {
                        break;
                    }
                    message.action = {
                        $case: "oldDeprecatedStartRecording",
                        oldDeprecatedStartRecording: exports.Deprecated.decode(reader, reader.uint32()),
                    };
                    continue;
                case 132:
                    if (tag !== 1058) {
                        break;
                    }
                    message.action = {
                        $case: "requestAccessViaCheckIn",
                        requestAccessViaCheckIn: exports.RequestAccessViaCheckIn.decode(reader, reader.uint32()),
                    };
                    continue;
                case 133:
                    if (tag !== 1066) {
                        break;
                    }
                    message.action = {
                        $case: "respondToAccessRequest",
                        respondToAccessRequest: exports.RespondToAccessRequest.decode(reader, reader.uint32()),
                    };
                    continue;
                case 134:
                    if (tag !== 1074) {
                        break;
                    }
                    message.action = {
                        $case: "setAvailability",
                        setAvailability: exports.SetAvailability.decode(reader, reader.uint32()),
                    };
                    continue;
                case 137:
                    if (tag !== 1098) {
                        break;
                    }
                    message.action = { $case: "respawnAtDesk", respawnAtDesk: exports.RespawnAtDesk.decode(reader, reader.uint32()) };
                    continue;
                case 138:
                    if (tag !== 1106) {
                        break;
                    }
                    message.action = {
                        $case: "setDeskFromNextAvailableDesk",
                        setDeskFromNextAvailableDesk: exports.SetDeskFromNextAvailableDesk.decode(reader, reader.uint32()),
                    };
                    continue;
                case 139:
                    if (tag !== 1114) {
                        break;
                    }
                    message.action = {
                        $case: "setSpaceRolePermissionOverride",
                        setSpaceRolePermissionOverride: exports.SetSpaceRolePermissionOverride.decode(reader, reader.uint32()),
                    };
                    continue;
                case 140:
                    if (tag !== 1122) {
                        break;
                    }
                    message.action = {
                        $case: "setCurrentlyEquippedWearables",
                        setCurrentlyEquippedWearables: exports.SetCurrentlyEquippedWearables.decode(reader, reader.uint32()),
                    };
                    continue;
                case 141:
                    if (tag !== 1130) {
                        break;
                    }
                    message.action = {
                        $case: "setDisplayEmail",
                        setDisplayEmail: exports.SetDisplayEmail.decode(reader, reader.uint32()),
                    };
                    continue;
                case 142:
                    if (tag !== 1138) {
                        break;
                    }
                    message.action = {
                        $case: "mapDeleteObjectByKey",
                        mapDeleteObjectByKey: exports.MapDeleteObjectByKey.decode(reader, reader.uint32()),
                    };
                    continue;
                case 143:
                    if (tag !== 1146) {
                        break;
                    }
                    message.action = {
                        $case: "mapUpdateObjects",
                        mapUpdateObjects: exports.MapUpdateObjects.decode(reader, reader.uint32()),
                    };
                    continue;
                case 144:
                    if (tag !== 1154) {
                        break;
                    }
                    message.action = {
                        $case: "interactWithObject",
                        interactWithObject: exports.InteractWithObject.decode(reader, reader.uint32()),
                    };
                    continue;
                case 145:
                    if (tag !== 1162) {
                        break;
                    }
                    message.action = { $case: "triggerObject", triggerObject: exports.TriggerObject.decode(reader, reader.uint32()) };
                    continue;
                case 146:
                    if (tag !== 1170) {
                        break;
                    }
                    message.action = { $case: "joinChimeMeeting", joinChimeMeeting: exports.Deprecated.decode(reader, reader.uint32()) };
                    continue;
                case 147:
                    if (tag !== 1178) {
                        break;
                    }
                    message.action = {
                        $case: "setAmbientPlayersMuted",
                        setAmbientPlayersMuted: exports.SetAmbientPlayersMuted.decode(reader, reader.uint32()),
                    };
                    continue;
                case 148:
                    if (tag !== 1186) {
                        break;
                    }
                    message.action = {
                        $case: "setMobileLastActive",
                        setMobileLastActive: exports.SetMobileLastActive.decode(reader, reader.uint32()),
                    };
                    continue;
                case 149:
                    if (tag !== 1194) {
                        break;
                    }
                    message.action = {
                        $case: "cancelRequestToLead",
                        cancelRequestToLead: exports.CancelRequestToLead.decode(reader, reader.uint32()),
                    };
                    continue;
                case 150:
                    if (tag !== 1202) {
                        break;
                    }
                    message.action = {
                        $case: "respondToRequestToLead",
                        respondToRequestToLead: exports.RespondToRequestToLead.decode(reader, reader.uint32()),
                    };
                    continue;
                case 151:
                    if (tag !== 1210) {
                        break;
                    }
                    message.action = {
                        $case: "setActivityStatus",
                        setActivityStatus: exports.SetActivityStatus.decode(reader, reader.uint32()),
                    };
                    continue;
                case 152:
                    if (tag !== 1218) {
                        break;
                    }
                    message.action = { $case: "startRecording", startRecording: exports.StartRecording.decode(reader, reader.uint32()) };
                    continue;
                case 153:
                    if (tag !== 1226) {
                        break;
                    }
                    message.action = { $case: "stopRecording", stopRecording: exports.StopRecording.decode(reader, reader.uint32()) };
                    continue;
                case 154:
                    if (tag !== 1234) {
                        break;
                    }
                    message.action = {
                        $case: "requestToCowork",
                        requestToCowork: exports.RequestToCowork.decode(reader, reader.uint32()),
                    };
                    continue;
                case 155:
                    if (tag !== 1242) {
                        break;
                    }
                    message.action = {
                        $case: "setCoworkingAreaStatus",
                        setCoworkingAreaStatus: exports.Deprecated.decode(reader, reader.uint32()),
                    };
                    continue;
                case 156:
                    if (tag !== 1250) {
                        break;
                    }
                    message.action = { $case: "mapSetDeskPods", mapSetDeskPods: exports.MapSetDeskPods.decode(reader, reader.uint32()) };
                    continue;
                case 157:
                    if (tag !== 1258) {
                        break;
                    }
                    message.action = {
                        $case: "chatRefreshSessionToken",
                        chatRefreshSessionToken: exports.ChatRefreshSessionToken.decode(reader, reader.uint32()),
                    };
                    continue;
                case 158:
                    if (tag !== 1266) {
                        break;
                    }
                    message.action = { $case: "chatInitiateDm", chatInitiateDm: exports.ChatInitiateDm.decode(reader, reader.uint32()) };
                    continue;
                case 159:
                    if (tag !== 1274) {
                        break;
                    }
                    message.action = { $case: "mapAddObjects", mapAddObjects: exports.MapAddObjects.decode(reader, reader.uint32()) };
                    continue;
                case 160:
                    if (tag !== 1282) {
                        break;
                    }
                    message.action = {
                        $case: "mapDeleteObjectsById",
                        mapDeleteObjectsById: exports.MapDeleteObjectsById.decode(reader, reader.uint32()),
                    };
                    continue;
                case 161:
                    if (tag !== 1290) {
                        break;
                    }
                    message.action = {
                        $case: "promoteToMember",
                        promoteToMember: exports.PromoteToMember.decode(reader, reader.uint32()),
                    };
                    continue;
                case 162:
                    if (tag !== 1298) {
                        break;
                    }
                    message.action = { $case: "invokeGrapes", invokeGrapes: exports.InvokeGrapes.decode(reader, reader.uint32()) };
                    continue;
                case 163:
                    if (tag !== 1306) {
                        break;
                    }
                    message.action = {
                        $case: "setProfileImageId",
                        setProfileImageId: exports.SetProfileImageId.decode(reader, reader.uint32()),
                    };
                    continue;
                case 164:
                    if (tag !== 1314) {
                        break;
                    }
                    message.action = {
                        $case: "setPersonalImageId",
                        setPersonalImageId: exports.SetPersonalImageId.decode(reader, reader.uint32()),
                    };
                    continue;
                case 165:
                    if (tag !== 1322) {
                        break;
                    }
                    message.action = { $case: "reactToObject", reactToObject: exports.ReactToObject.decode(reader, reader.uint32()) };
                    continue;
                case 166:
                    if (tag !== 1330) {
                        break;
                    }
                    message.action = {
                        $case: "chatAddUsersToGroupChannel",
                        chatAddUsersToGroupChannel: exports.ChatAddUsersToGroupChannel.decode(reader, reader.uint32()),
                    };
                    continue;
                case 167:
                    if (tag !== 1338) {
                        break;
                    }
                    message.action = { $case: "chatV2", chatV2: exports.ChatV2.decode(reader, reader.uint32()) };
                    continue;
                case 168:
                    if (tag !== 1346) {
                        break;
                    }
                    message.action = { $case: "setStatusV2", setStatusV2: exports.SetStatusV2.decode(reader, reader.uint32()) };
                    continue;
                case 169:
                    if (tag !== 1354) {
                        break;
                    }
                    message.action = {
                        $case: "mapApplyEditActions",
                        mapApplyEditActions: exports.MapApplyEditActions.decode(reader, reader.uint32()),
                    };
                    continue;
                case 170:
                    if (tag !== 1362) {
                        break;
                    }
                    message.action = { $case: "setHandRaised", setHandRaised: exports.SetHandRaised.decode(reader, reader.uint32()) };
                    continue;
                case 171:
                    if (tag !== 1370) {
                        break;
                    }
                    message.action = { $case: "liveCursor", liveCursor: exports.LiveCursor.decode(reader, reader.uint32()) };
                    continue;
                case 172:
                    if (tag !== 1378) {
                        break;
                    }
                    message.action = { $case: "shimmy", shimmy: exports.Shimmy.decode(reader, reader.uint32()) };
                    continue;
                case 173:
                    if (tag !== 1386) {
                        break;
                    }
                    message.action = {
                        $case: "startAnnotationSession",
                        startAnnotationSession: exports.StartAnnotationSession.decode(reader, reader.uint32()),
                    };
                    continue;
                case 174:
                    if (tag !== 1394) {
                        break;
                    }
                    message.action = {
                        $case: "requestAnnotationSession",
                        requestAnnotationSession: exports.RequestAnnotationSession.decode(reader, reader.uint32()),
                    };
                    continue;
                case 176:
                    if (tag !== 1410) {
                        break;
                    }
                    message.action = {
                        $case: "clearAllAnnotations",
                        clearAllAnnotations: exports.ClearAllAnnotations.decode(reader, reader.uint32()),
                    };
                    continue;
                case 177:
                    if (tag !== 1418) {
                        break;
                    }
                    message.action = {
                        $case: "clearPlayersAnnotations",
                        clearPlayersAnnotations: exports.ClearAnnotations.decode(reader, reader.uint32()),
                    };
                    continue;
                case 178:
                    if (tag !== 1426) {
                        break;
                    }
                    message.action = {
                        $case: "loadAnnotationSession",
                        loadAnnotationSession: exports.LoadAnnotationSession.decode(reader, reader.uint32()),
                    };
                    continue;
                case 180:
                    if (tag !== 1442) {
                        break;
                    }
                    message.action = {
                        $case: "sendAnnotationSession",
                        sendAnnotationSession: exports.SendAnnotationSession.decode(reader, reader.uint32()),
                    };
                    continue;
                case 181:
                    if (tag !== 1450) {
                        break;
                    }
                    message.action = {
                        $case: "annotationRequestDenied",
                        annotationRequestDenied: exports.AnnotationRequestDenied.decode(reader, reader.uint32()),
                    };
                    continue;
                case 182:
                    if (tag !== 1458) {
                        break;
                    }
                    message.action = {
                        $case: "playerSendsAnnotationDelta",
                        playerSendsAnnotationDelta: exports.AnnotationDelta.decode(reader, reader.uint32()),
                    };
                    continue;
                case 183:
                    if (tag !== 1466) {
                        break;
                    }
                    message.action = {
                        $case: "requestPromoteToMember",
                        requestPromoteToMember: exports.RequestPromoteToMember.decode(reader, reader.uint32()),
                    };
                    continue;
                case 184:
                    if (tag !== 1474) {
                        break;
                    }
                    message.action = {
                        $case: "respondToRequestPromoteToMember",
                        respondToRequestPromoteToMember: exports.RespondToRequestPromoteToMember.decode(reader, reader.uint32()),
                    };
                    continue;
                case 185:
                    if (tag !== 1482) {
                        break;
                    }
                    message.action = {
                        $case: "chatTombstoneMessage",
                        chatTombstoneMessage: exports.ChatTombstoneMessage.decode(reader, reader.uint32()),
                    };
                    continue;
                case 186:
                    if (tag !== 1490) {
                        break;
                    }
                    message.action = {
                        $case: "chatV2SendMessage",
                        chatV2SendMessage: exports.ChatV2SendMessage.decode(reader, reader.uint32()),
                    };
                    continue;
                case 187:
                    if (tag !== 1498) {
                        break;
                    }
                    message.action = {
                        $case: "getAnnotationSessions",
                        getAnnotationSessions: exports.GetAnnotationSessions.decode(reader, reader.uint32()),
                    };
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseClientHeartbeat() {
    return {};
}
exports.ClientHeartbeat = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientHeartbeat();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseClientBackupHeartbeat() {
    return {};
}
exports.ClientBackupHeartbeat = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientBackupHeartbeat();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateSubscriptions() {
    return { subscriptions: {}, mapUpdateIds: {} };
}
exports.UpdateSubscriptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.subscriptions).forEach(([key, value]) => {
            exports.UpdateSubscriptions_SubscriptionsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        Object.entries(message.mapUpdateIds).forEach(([key, value]) => {
            exports.UpdateSubscriptions_MapUpdateIdsEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateSubscriptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.UpdateSubscriptions_SubscriptionsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.subscriptions[entry1.key] = entry1.value;
                    }
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.UpdateSubscriptions_MapUpdateIdsEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.mapUpdateIds[entry2.key] = entry2.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateSubscriptions_SubscriptionsEntry() {
    return { key: "", value: false };
}
exports.UpdateSubscriptions_SubscriptionsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value === true) {
            writer.uint32(16).bool(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateSubscriptions_SubscriptionsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.value = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateSubscriptions_MapUpdateIdsEntry() {
    return { key: "", value: 0 };
}
exports.UpdateSubscriptions_MapUpdateIdsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== 0) {
            writer.uint32(16).uint64(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateSubscriptions_MapUpdateIdsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.value = longToNumber(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMove() {
    return { dir: 0, stopped: false, inputId: 0 };
}
exports.Move = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.dir !== 0) {
            writer.uint32(8).int32(message.dir);
        }
        if (message.stopped === true) {
            writer.uint32(16).bool(message.stopped);
        }
        if (message.inputId !== 0) {
            writer.uint32(24).uint32(message.inputId);
        }
        if (message.targetId !== undefined) {
            writer.uint32(34).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMove();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.dir = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.stopped = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.inputId = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestMute() {
    return { target: "", video: false };
}
exports.RequestMute = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.target !== "") {
            writer.uint32(10).string(message.target);
        }
        if (message.video === true) {
            writer.uint32(16).bool(message.video);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestMute();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.target = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.video = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetAffiliation() {
    return { affiliation: "" };
}
exports.SetAffiliation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.affiliation !== "") {
            writer.uint32(10).string(message.affiliation);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetAffiliation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.affiliation = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetStatus() {
    return { status: false };
}
exports.SetStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.status === true) {
            writer.uint32(8).bool(message.status);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.status = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetAvailability() {
    return { availability: "" };
}
exports.SetAvailability = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.availability !== "") {
            writer.uint32(10).string(message.availability);
        }
        if (message.endOption !== undefined) {
            writer.uint32(18).string(message.endOption);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetAvailability();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.availability = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.endOption = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetStatusV2() {
    return { status: "" };
}
exports.SetStatusV2 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.status !== "") {
            writer.uint32(10).string(message.status);
        }
        if (message.statusChangeSource !== undefined) {
            writer.uint32(18).string(message.statusChangeSource);
        }
        if (message.statusExpiresAt !== undefined) {
            writer.uint32(26).string(message.statusExpiresAt);
        }
        if (message.statusExpiresToStatus !== undefined) {
            writer.uint32(34).string(message.statusExpiresToStatus);
        }
        if (message.statusExpiresToChangeSource !== undefined) {
            writer.uint32(42).string(message.statusExpiresToChangeSource);
        }
        if (message.statusExpiresToExpireTime !== undefined) {
            writer.uint32(50).string(message.statusExpiresToExpireTime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetStatusV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.status = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.statusChangeSource = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.statusExpiresAt = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.statusExpiresToStatus = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.statusExpiresToChangeSource = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.statusExpiresToExpireTime = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetCurrentlyEquippedWearables() {
    return { currentlyEquippedWearables: undefined };
}
exports.SetCurrentlyEquippedWearables = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.currentlyEquippedWearables !== undefined) {
            exports.DBOutfit.encode(message.currentlyEquippedWearables, writer.uint32(10).fork()).ldelim();
        }
        if (message.targetId !== undefined) {
            writer.uint32(26).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetCurrentlyEquippedWearables();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.currentlyEquippedWearables = exports.DBOutfit.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpotlight() {
    return { spotlightedUser: "", isSpotlighted: false };
}
exports.Spotlight = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spotlightedUser !== "") {
            writer.uint32(10).string(message.spotlightedUser);
        }
        if (message.isSpotlighted === true) {
            writer.uint32(16).bool(message.isSpotlighted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpotlight();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spotlightedUser = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.isSpotlighted = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRing() {
    return { user: "" };
}
exports.Ring = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== "") {
            writer.uint32(10).string(message.user);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetImagePointer() {
    return { objectId: "", x: 0, y: 0 };
}
exports.SetImagePointer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.objectId !== "") {
            writer.uint32(10).string(message.objectId);
        }
        if (message.x !== 0) {
            writer.uint32(17).double(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(25).double(message.y);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetImagePointer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.objectId = reader.string();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.x = reader.double();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.y = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetScreenPointer() {
    return { screenId: "", x: 0, y: 0 };
}
exports.SetScreenPointer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.screenId !== "") {
            writer.uint32(10).string(message.screenId);
        }
        if (message.x !== 0) {
            writer.uint32(17).double(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(25).double(message.y);
        }
        if (message.color !== undefined) {
            writer.uint32(34).string(message.color);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetScreenPointer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.screenId = reader.string();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.x = reader.double();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.y = reader.double();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseBan() {
    return { user: "" };
}
exports.Ban = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== "") {
            writer.uint32(10).string(message.user);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBan();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseKick() {
    return { user: "" };
}
exports.Kick = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== "") {
            writer.uint32(10).string(message.user);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseKick();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseBlock() {
    return { blockedUserId: "", blocked: false };
}
exports.Block = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.blockedUserId !== "") {
            writer.uint32(10).string(message.blockedUserId);
        }
        if (message.blocked === true) {
            writer.uint32(16).bool(message.blocked);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.blockedUserId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.blocked = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetImpassable() {
    return { mapId: "", x: 0, y: 0, impassable: false };
}
exports.SetImpassable = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.x !== 0) {
            writer.uint32(16).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(24).uint32(message.y);
        }
        if (message.impassable === true) {
            writer.uint32(32).bool(message.impassable);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetImpassable();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.impassable = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChat() {
    return { chatRecipient: "", contents: "", localPlayerIds: [], mapId: "" };
}
exports.Chat = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.chatRecipient !== "") {
            writer.uint32(10).string(message.chatRecipient);
        }
        if (message.contents !== "") {
            writer.uint32(18).string(message.contents);
        }
        for (const v of message.localPlayerIds) {
            writer.uint32(26).string(v);
        }
        if (message.mapId !== "") {
            writer.uint32(34).string(message.mapId);
        }
        if (message.id !== undefined) {
            writer.uint32(42).string(message.id);
        }
        if (message.nookId !== undefined) {
            writer.uint32(50).string(message.nookId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChat();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.chatRecipient = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.contents = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.localPlayerIds.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.nookId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatV2() {
    return {
        channelUrl: "",
        channelType: 0,
        channelMemberUserIds: [],
        actionType: 0,
        messageId: "",
        content: "",
        mentionedUserIds: [],
    };
}
exports.ChatV2 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channelUrl !== "") {
            writer.uint32(10).string(message.channelUrl);
        }
        if (message.channelType !== 0) {
            writer.uint32(16).int32(message.channelType);
        }
        for (const v of message.channelMemberUserIds) {
            writer.uint32(26).string(v);
        }
        if (message.actionType !== 0) {
            writer.uint32(32).int32(message.actionType);
        }
        if (message.messageId !== "") {
            writer.uint32(42).string(message.messageId);
        }
        if (message.content !== "") {
            writer.uint32(50).string(message.content);
        }
        for (const v of message.mentionedUserIds) {
            writer.uint32(58).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channelUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.channelType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.channelMemberUserIds.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.actionType = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.messageId = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.mentionedUserIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatV2SendMessage() {
    return { channelUrl: "", channelType: 0, content: "" };
}
exports.ChatV2SendMessage = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channelUrl !== "") {
            writer.uint32(10).string(message.channelUrl);
        }
        if (message.channelType !== 0) {
            writer.uint32(16).int32(message.channelType);
        }
        if (message.content !== "") {
            writer.uint32(26).string(message.content);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatV2SendMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channelUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.channelType = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseNotify() {
    return { notification: "" };
}
exports.Notify = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.notification !== "") {
            writer.uint32(10).string(message.notification);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNotify();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.notification = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseInteractWithObject() {
    return { mapId: "", key: "" };
}
exports.InteractWithObject = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.key !== "") {
            writer.uint32(18).string(message.key);
        }
        if (message.dataJson !== undefined) {
            writer.uint32(26).string(message.dataJson);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInteractWithObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.dataJson = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseActivelySpeaking() {
    return { activelySpeaking: false };
}
exports.ActivelySpeaking = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.activelySpeaking === true) {
            writer.uint32(8).bool(message.activelySpeaking);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseActivelySpeaking();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.activelySpeaking = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseEnterWhisper() {
    return { recipientId: "", dir: 0 };
}
exports.EnterWhisper = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.recipientId !== "") {
            writer.uint32(10).string(message.recipientId);
        }
        if (message.dir !== 0) {
            writer.uint32(16).int32(message.dir);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEnterWhisper();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.recipientId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.dir = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseInvokeGrapes() {
    return { userId: "" };
}
exports.InvokeGrapes = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInvokeGrapes();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseReactToObject() {
    return { mapId: "", key: "", reaction: "" };
}
exports.ReactToObject = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.key !== "") {
            writer.uint32(18).string(message.key);
        }
        if (message.reaction !== "") {
            writer.uint32(26).string(message.reaction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReactToObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.reaction = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatAddUsersToGroupChannel() {
    return { channelUrl: "", playerIds: [] };
}
exports.ChatAddUsersToGroupChannel = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channelUrl !== "") {
            writer.uint32(10).string(message.channelUrl);
        }
        for (const v of message.playerIds) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatAddUsersToGroupChannel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channelUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.playerIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatTombstoneMessage() {
    return { channelUrl: "", messageId: "" };
}
exports.ChatTombstoneMessage = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channelUrl !== "") {
            writer.uint32(10).string(message.channelUrl);
        }
        if (message.messageId !== "") {
            writer.uint32(18).string(message.messageId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatTombstoneMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channelUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.messageId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseLeaveWhisper() {
    return {};
}
exports.LeaveWhisper = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLeaveWhisper();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseGhost() {
    return { ghost: 0 };
}
exports.Ghost = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ghost !== 0) {
            writer.uint32(8).uint32(message.ghost);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGhost();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.ghost = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseShimmy() {
    return { shimmy: false };
}
exports.Shimmy = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.shimmy === true) {
            writer.uint32(8).bool(message.shimmy);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseShimmy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.shimmy = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetEmoteV2() {
    return {};
}
exports.SetEmoteV2 = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.emote !== undefined) {
            writer.uint32(10).string(message.emote);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        if (message.count !== undefined) {
            writer.uint32(24).uint32(message.count);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetEmoteV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.emote = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.count = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetHandRaised() {
    return { handRaised: false };
}
exports.SetHandRaised = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.handRaised === true) {
            writer.uint32(8).bool(message.handRaised);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetHandRaised();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.handRaised = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetName() {
    return { name: "" };
}
exports.SetName = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetName();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetTextStatus() {
    return { textStatus: "" };
}
exports.SetTextStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.textStatus !== "") {
            writer.uint32(10).string(message.textStatus);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetTextStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.textStatus = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetPronouns() {
    return { pronouns: "" };
}
exports.SetPronouns = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pronouns !== "") {
            writer.uint32(10).string(message.pronouns);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetPronouns();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.pronouns = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetTitle() {
    return { title: "" };
}
exports.SetTitle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetTitle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetCity() {
    return { city: "" };
}
exports.SetCity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.city !== "") {
            writer.uint32(10).string(message.city);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetCity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.city = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetCountry() {
    return { country: "" };
}
exports.SetCountry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.country !== "") {
            writer.uint32(10).string(message.country);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetCountry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.country = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetStartDate() {
    return { startDate: "" };
}
exports.SetStartDate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.startDate !== "") {
            writer.uint32(10).string(message.startDate);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetStartDate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.startDate = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetTimezone() {
    return { timezone: "" };
}
exports.SetTimezone = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.timezone !== "") {
            writer.uint32(10).string(message.timezone);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetTimezone();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.timezone = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetPhone() {
    return { phone: "" };
}
exports.SetPhone = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.phone !== "") {
            writer.uint32(10).string(message.phone);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetPhone();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.phone = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetDisplayEmail() {
    return { displayEmail: "" };
}
exports.SetDisplayEmail = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.displayEmail !== "") {
            writer.uint32(10).string(message.displayEmail);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetDisplayEmail();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.displayEmail = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetDescription() {
    return { description: "" };
}
exports.SetDescription = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.description !== "") {
            writer.uint32(10).string(message.description);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetDescription();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetProfileImageId() {
    return { profileImageId: "" };
}
exports.SetProfileImageId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.profileImageId !== "") {
            writer.uint32(10).string(message.profileImageId);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetProfileImageId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.profileImageId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetPersonalImageId() {
    return { personalImageId: "" };
}
exports.SetPersonalImageId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.personalImageId !== "") {
            writer.uint32(10).string(message.personalImageId);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetPersonalImageId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.personalImageId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetProfileImageUrl() {
    return { profileImageUrl: "" };
}
exports.SetProfileImageUrl = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.profileImageUrl !== "") {
            writer.uint32(10).string(message.profileImageUrl);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetProfileImageUrl();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.profileImageUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetPersonalImageUrl() {
    return { personalImageUrl: "" };
}
exports.SetPersonalImageUrl = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.personalImageUrl !== "") {
            writer.uint32(10).string(message.personalImageUrl);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetPersonalImageUrl();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.personalImageUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseLiveCursor() {
    return { screenId: "", enabled: false, localPlayerIds: [] };
}
exports.LiveCursor = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.screenId !== "") {
            writer.uint32(10).string(message.screenId);
        }
        if (message.enabled === true) {
            writer.uint32(16).bool(message.enabled);
        }
        if (message.color !== undefined) {
            writer.uint32(26).string(message.color);
        }
        if (message.x !== undefined) {
            writer.uint32(37).float(message.x);
        }
        if (message.y !== undefined) {
            writer.uint32(45).float(message.y);
        }
        if (message.toolId !== undefined) {
            writer.uint32(50).string(message.toolId);
        }
        for (const v of message.localPlayerIds) {
            writer.uint32(58).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLiveCursor();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.screenId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.enabled = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.color = reader.string();
                    continue;
                case 4:
                    if (tag !== 37) {
                        break;
                    }
                    message.x = reader.float();
                    continue;
                case 5:
                    if (tag !== 45) {
                        break;
                    }
                    message.y = reader.float();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.toolId = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.localPlayerIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseExit() {
    return {};
}
exports.Exit = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseExit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseEnter() {
    return {};
}
exports.Enter = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.info !== undefined) {
            exports.PlayerInitInfo.encode(message.info, writer.uint32(10).fork()).ldelim();
        }
        if (message.spawnToken !== undefined) {
            writer.uint32(18).string(message.spawnToken);
        }
        if (message.targetId !== undefined) {
            writer.uint32(26).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEnter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.info = exports.PlayerInitInfo.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.spawnToken = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePrecomputeEnter() {
    return {};
}
exports.PrecomputeEnter = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.enterLocation !== undefined) {
            exports.MapLocation.encode(message.enterLocation, writer.uint32(10).fork()).ldelim();
        }
        if (message.spawnToken !== undefined) {
            writer.uint32(18).string(message.spawnToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePrecomputeEnter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.enterLocation = exports.MapLocation.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.spawnToken = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetEmojiStatus() {
    return { emojiStatus: "" };
}
exports.SetEmojiStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.emojiStatus !== "") {
            writer.uint32(10).string(message.emojiStatus);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetEmojiStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.emojiStatus = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseTeleport() {
    return { mapId: "", x: 0, y: 0 };
}
exports.Teleport = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.x !== 0) {
            writer.uint32(16).uint32(message.x);
        }
        if (message.y !== 0) {
            writer.uint32(24).uint32(message.y);
        }
        if (message.targetId !== undefined) {
            writer.uint32(34).string(message.targetId);
        }
        if (message.direction !== undefined) {
            writer.uint32(40).int32(message.direction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTeleport();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.x = reader.uint32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.y = reader.uint32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.direction = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpawn() {
    return { spawnToken: "" };
}
exports.Spawn = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spawnToken !== "") {
            writer.uint32(10).string(message.spawnToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpawn();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spawnToken = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRespawn() {
    return {};
}
exports.Respawn = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRespawn();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRespawnAtDesk() {
    return {};
}
exports.RespawnAtDesk = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRespawnAtDesk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestToJoinNook() {
    return { nookId: "", mapId: "" };
}
exports.RequestToJoinNook = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.nookId !== "") {
            writer.uint32(10).string(message.nookId);
        }
        if (message.mapId !== "") {
            writer.uint32(18).string(message.mapId);
        }
        if (message.name !== undefined) {
            writer.uint32(26).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestToJoinNook();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.nookId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseUpdateNookPermission() {
    return { playerId: "", nookId: "", granted: false };
}
exports.UpdateNookPermission = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.playerId !== "") {
            writer.uint32(10).string(message.playerId);
        }
        if (message.nookId !== "") {
            writer.uint32(18).string(message.nookId);
        }
        if (message.granted === true) {
            writer.uint32(24).bool(message.granted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateNookPermission();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.playerId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.nookId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.granted = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseInit() {
    return { spaceId: "", auth: undefined };
}
exports.Init = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.spaceId !== "") {
            writer.uint32(10).string(message.spaceId);
        }
        switch (message.auth?.$case) {
            case "token":
                writer.uint32(18).string(message.auth.token);
                break;
            case "apiKey":
                writer.uint32(26).string(message.auth.apiKey);
                break;
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.spaceId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.auth = { $case: "token", token: reader.string() };
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.auth = { $case: "apiKey", apiKey: reader.string() };
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapAddObject() {
    return { mapId: "", object: undefined };
}
exports.MapAddObject = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.object !== undefined) {
            exports.WireObject.encode(message.object, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapAddObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.object = exports.WireObject.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapUpdateObjects() {
    return { mapId: "", objects: {} };
}
exports.MapUpdateObjects = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        Object.entries(message.objects).forEach(([key, value]) => {
            exports.MapUpdateObjects_ObjectsEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        if (message.updatesAreOverwrites !== undefined) {
            writer.uint32(24).bool(message.updatesAreOverwrites);
        }
        if (message.overwritableChange !== undefined) {
            writer.uint32(32).bool(message.overwritableChange);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapUpdateObjects();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.MapUpdateObjects_ObjectsEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.objects[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.updatesAreOverwrites = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.overwritableChange = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapUpdateObjects_ObjectsEntry() {
    return { key: "", value: undefined };
}
exports.MapUpdateObjects_ObjectsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.WireObject.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapUpdateObjects_ObjectsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.WireObject.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseShootConfetti() {
    return {};
}
exports.ShootConfetti = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.targetId !== undefined) {
            writer.uint32(10).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseShootConfetti();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetEventStatus() {
    return { eventStatus: "" };
}
exports.SetEventStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.eventStatus !== "") {
            writer.uint32(10).string(message.eventStatus);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetEventStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.eventStatus = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetInConversation() {
    return { inConversation: false };
}
exports.SetInConversation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.inConversation === true) {
            writer.uint32(8).bool(message.inConversation);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetInConversation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.inConversation = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetVehicleId() {
    return { vehicleId: "" };
}
exports.SetVehicleId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.vehicleId !== "") {
            writer.uint32(10).string(message.vehicleId);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        if (message.action !== undefined) {
            writer.uint32(26).string(message.action);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetVehicleId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.vehicleId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.action = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetSpeedModifier() {
    return { speedModifier: 0 };
}
exports.SetSpeedModifier = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.speedModifier !== 0) {
            writer.uint32(13).float(message.speedModifier);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetSpeedModifier();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.speedModifier = reader.float();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetIsAlone() {
    return { isAlone: false };
}
exports.SetIsAlone = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isAlone === true) {
            writer.uint32(8).bool(message.isAlone);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetIsAlone();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.isAlone = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetIsMobile() {
    return { isMobile: false };
}
exports.SetIsMobile = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isMobile === true) {
            writer.uint32(8).bool(message.isMobile);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetIsMobile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.isMobile = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePlaySound() {
    return { src: "", volume: 0 };
}
exports.PlaySound = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.src !== "") {
            writer.uint32(10).string(message.src);
        }
        if (message.volume !== 0) {
            writer.uint32(21).float(message.volume);
        }
        if (message.targetId !== undefined) {
            writer.uint32(26).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlaySound();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.src = reader.string();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.volume = reader.float();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseStopSound() {
    return { src: "" };
}
exports.StopSound = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.src !== "") {
            writer.uint32(10).string(message.src);
        }
        if (message.targetId !== undefined) {
            writer.uint32(26).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStopSound();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.src = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetFocusModeEndTime() {
    return { focusModeEndTime: "" };
}
exports.SetFocusModeEndTime = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.focusModeEndTime !== "") {
            writer.uint32(10).string(message.focusModeEndTime);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetFocusModeEndTime();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.focusModeEndTime = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetAmbientPlayersMuted() {
    return { ambientPlayersMuted: {} };
}
exports.SetAmbientPlayersMuted = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.ambientPlayersMuted).forEach(([key, value]) => {
            exports.SetAmbientPlayersMuted_AmbientPlayersMutedEntry.encode({ key: key, value }, writer.uint32(10).fork())
                .ldelim();
        });
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetAmbientPlayersMuted();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.SetAmbientPlayersMuted_AmbientPlayersMutedEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.ambientPlayersMuted[entry1.key] = entry1.value;
                    }
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetAmbientPlayersMuted_AmbientPlayersMutedEntry() {
    return { key: "", value: false };
}
exports.SetAmbientPlayersMuted_AmbientPlayersMutedEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value === true) {
            writer.uint32(16).bool(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetAmbientPlayersMuted_AmbientPlayersMutedEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.value = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetActivityStatus() {
    return { activityStatus: undefined };
}
exports.SetActivityStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.activityStatus !== undefined) {
            exports.ActivityStatus.encode(message.activityStatus, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetActivityStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.activityStatus = exports.ActivityStatus.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetMobileLastActive() {
    return {};
}
exports.SetMobileLastActive = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetMobileLastActive();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetItemString() {
    return { itemString: "" };
}
exports.SetItemString = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.itemString !== "") {
            writer.uint32(10).string(message.itemString);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetItemString();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemString = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseTriggerObject() {
    return {};
}
exports.TriggerObject = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== undefined) {
            writer.uint32(10).string(message.mapId);
        }
        if (message.key !== undefined) {
            writer.uint32(18).string(message.key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTriggerObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseCustomAction() {
    return { name: "", payload: "", recipients: [] };
}
exports.CustomAction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.payload !== "") {
            writer.uint32(18).string(message.payload);
        }
        for (const v of message.recipients) {
            writer.uint32(26).string(v);
        }
        if (message.sendToAll !== undefined) {
            writer.uint32(32).bool(message.sendToAll);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCustomAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.payload = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.recipients.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.sendToAll = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetFollowTarget() {
    return { followTarget: "" };
}
exports.SetFollowTarget = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.followTarget !== "") {
            writer.uint32(10).string(message.followTarget);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetFollowTarget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.followTarget = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestToLead() {
    return { target: "", snapshot: "" };
}
exports.RequestToLead = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.target !== "") {
            writer.uint32(10).string(message.target);
        }
        if (message.snapshot !== "") {
            writer.uint32(18).string(message.snapshot);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestToLead();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.target = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.snapshot = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseCancelRequestToLead() {
    return { target: "" };
}
exports.CancelRequestToLead = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.target !== "") {
            writer.uint32(10).string(message.target);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCancelRequestToLead();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.target = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRespondToRequestToLead() {
    return { requesterId: "", response: 0 };
}
exports.RespondToRequestToLead = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.requesterId !== "") {
            writer.uint32(10).string(message.requesterId);
        }
        if (message.response !== 0) {
            writer.uint32(16).int32(message.response);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRespondToRequestToLead();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.requesterId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.response = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseEnterPortal() {
    return { targetUrl: "" };
}
exports.EnterPortal = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.targetUrl !== "") {
            writer.uint32(10).string(message.targetUrl);
        }
        if (message.bypassPrompt !== undefined) {
            writer.uint32(16).bool(message.bypassPrompt);
        }
        if (message.targetId !== undefined) {
            writer.uint32(26).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEnterPortal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.targetUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.bypassPrompt = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetManualVideoSrc() {
    return { manualVideoSrc: "" };
}
exports.SetManualVideoSrc = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.manualVideoSrc !== "") {
            writer.uint32(10).string(message.manualVideoSrc);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetManualVideoSrc();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.manualVideoSrc = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetSubtitle() {
    return { subtitle: "" };
}
exports.SetSubtitle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.subtitle !== "") {
            writer.uint32(10).string(message.subtitle);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetSubtitle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subtitle = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapCommitsChanges() {
    return { mapId: "", updateId: 0 };
}
exports.MapCommitsChanges = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        if (message.updateId !== 0) {
            writer.uint32(16).uint64(message.updateId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapCommitsChanges();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.updateId = longToNumber(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSpeakerUpdatesSession() {
    return { sessionId: "" };
}
exports.SpeakerUpdatesSession = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sessionId !== "") {
            writer.uint32(10).string(message.sessionId);
        }
        if (message.customizeRoomEnabled !== undefined) {
            writer.uint32(16).bool(message.customizeRoomEnabled);
        }
        if (message.chatEnabled !== undefined) {
            writer.uint32(24).bool(message.chatEnabled);
        }
        if (message.qaEnabled !== undefined) {
            writer.uint32(32).bool(message.qaEnabled);
        }
        if (message.approveQuestionsEnabled !== undefined) {
            writer.uint32(40).bool(message.approveQuestionsEnabled);
        }
        if (message.massMuteEnabled !== undefined) {
            writer.uint32(48).bool(message.massMuteEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSpeakerUpdatesSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.sessionId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.customizeRoomEnabled = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.chatEnabled = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.qaEnabled = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.approveQuestionsEnabled = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.massMuteEnabled = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatReply() {
    return { senderId: "", senderName: "", contents: "" };
}
exports.ChatReply = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.senderId !== "") {
            writer.uint32(10).string(message.senderId);
        }
        if (message.senderName !== "") {
            writer.uint32(18).string(message.senderName);
        }
        if (message.contents !== "") {
            writer.uint32(26).string(message.contents);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatReply();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.senderId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.senderName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.contents = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatMessageUpdated() {
    return { id: "" };
}
exports.ChatMessageUpdated = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatMessageUpdated();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSendCommand() {
    return { command: "" };
}
exports.SendCommand = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.command !== "") {
            writer.uint32(10).string(message.command);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendCommand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.command = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRegisterCommand() {
    return { command: "" };
}
exports.RegisterCommand = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.command !== "") {
            writer.uint32(10).string(message.command);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRegisterCommand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.command = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseCraft() {
    return { inputs: {} };
}
exports.Craft = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.inputs).forEach(([key, value]) => {
            exports.Craft_InputsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCraft();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.Craft_InputsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.inputs[entry1.key] = entry1.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseCraft_InputsEntry() {
    return { key: "", value: 0 };
}
exports.Craft_InputsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== 0) {
            writer.uint32(16).int32(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCraft_InputsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.value = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseHighFive() {
    return { targetId: "" };
}
exports.HighFive = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.targetId !== "") {
            writer.uint32(10).string(message.targetId);
        }
        if (message.emote !== undefined) {
            writer.uint32(18).string(message.emote);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHighFive();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.emote = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseAddInventoryItem() {
    return { itemId: "", delta: 0, targetId: "" };
}
exports.AddInventoryItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.itemId !== "") {
            writer.uint32(10).string(message.itemId);
        }
        if (message.delta !== 0) {
            writer.uint32(16).uint64(message.delta);
        }
        if (message.targetId !== "") {
            writer.uint32(26).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddInventoryItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.delta = longToNumber(reader.uint64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRemoveInventoryItem() {
    return { itemId: "", delta: 0 };
}
exports.RemoveInventoryItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.itemId !== "") {
            writer.uint32(10).string(message.itemId);
        }
        if (message.delta !== 0) {
            writer.uint32(16).uint64(message.delta);
        }
        if (message.targetId !== undefined) {
            writer.uint32(26).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRemoveInventoryItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.delta = longToNumber(reader.uint64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseHipToBeSquare() {
    return { data: "" };
}
exports.HipToBeSquare = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data !== "") {
            writer.uint32(10).string(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHipToBeSquare();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.data = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseTriggerInventoryItem() {
    return { itemId: "", abilityId: "" };
}
exports.TriggerInventoryItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.itemId !== "") {
            writer.uint32(10).string(message.itemId);
        }
        if (message.abilityId !== "") {
            writer.uint32(18).string(message.abilityId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTriggerInventoryItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.itemId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.abilityId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetAllowScreenPointer() {
    return { allowScreenPointer: false };
}
exports.SetAllowScreenPointer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.allowScreenPointer === true) {
            writer.uint32(8).bool(message.allowScreenPointer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetAllowScreenPointer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.allowScreenPointer = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetDeskInfo() {
    return { deskInfo: undefined };
}
exports.SetDeskInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.deskInfo !== undefined) {
            exports.DeskInfoV2.encode(message.deskInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetDeskInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.deskInfo = exports.DeskInfoV2.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseWave() {
    return { user: "", isReply: false };
}
exports.Wave = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== "") {
            writer.uint32(10).string(message.user);
        }
        if (message.isReply === true) {
            writer.uint32(16).bool(message.isReply);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWave();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.isReply = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetAway() {
    return { away: false };
}
exports.SetAway = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.away === true) {
            writer.uint32(8).bool(message.away);
        }
        if (message.targetId !== undefined) {
            writer.uint32(18).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetAway();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.away = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestAccessViaCheckIn() {
    return { userId: "", canceled: false };
}
exports.RequestAccessViaCheckIn = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        if (message.canceled === true) {
            writer.uint32(16).bool(message.canceled);
        }
        if (message.name !== undefined) {
            writer.uint32(26).string(message.name);
        }
        if (message.currentlyEquippedWearables !== undefined) {
            exports.DBOutfit.encode(message.currentlyEquippedWearables, writer.uint32(42).fork()).ldelim();
        }
        if (message.isMobile !== undefined) {
            writer.uint32(48).bool(message.isMobile);
        }
        if (message.meetingLink !== undefined) {
            writer.uint32(58).string(message.meetingLink);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestAccessViaCheckIn();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.canceled = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.currentlyEquippedWearables = exports.DBOutfit.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.isMobile = reader.bool();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.meetingLink = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRespondToAccessRequest() {
    return { userId: "", accepted: false };
}
exports.RespondToAccessRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        if (message.accepted === true) {
            writer.uint32(16).bool(message.accepted);
        }
        if (message.locationType !== undefined) {
            writer.uint32(24).int32(message.locationType);
        }
        if (message.mapId !== undefined) {
            writer.uint32(34).string(message.mapId);
        }
        if (message.nookId !== undefined) {
            writer.uint32(42).string(message.nookId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRespondToAccessRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.accepted = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.locationType = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.nookId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseSetSpaceRolePermissionOverride() {
    return { role: "", permission: "", enabled: false };
}
exports.SetSpaceRolePermissionOverride = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.role !== "") {
            writer.uint32(10).string(message.role);
        }
        if (message.permission !== "") {
            writer.uint32(18).string(message.permission);
        }
        if (message.enabled === true) {
            writer.uint32(24).bool(message.enabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetSpaceRolePermissionOverride();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.role = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.permission = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.enabled = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseStartRecording() {
    return { fileName: "" };
}
exports.StartRecording = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.fileName !== "") {
            writer.uint32(18).string(message.fileName);
        }
        if (message.summarizable !== undefined) {
            writer.uint32(24).bool(message.summarizable);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStartRecording();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.fileName = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.summarizable = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseStopRecording() {
    return { reason: 0, recordingClientId: "" };
}
exports.StopRecording = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.reason !== 0) {
            writer.uint32(8).int32(message.reason);
        }
        if (message.recordingClientId !== "") {
            writer.uint32(18).string(message.recordingClientId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStopRecording();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.reason = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.recordingClientId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestToCowork() {
    return { targetId: "", nookId: "" };
}
exports.RequestToCowork = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.targetId !== "") {
            writer.uint32(10).string(message.targetId);
        }
        if (message.nookId !== "") {
            writer.uint32(18).string(message.nookId);
        }
        if (message.autoInvite !== undefined) {
            writer.uint32(24).bool(message.autoInvite);
        }
        if (message.mapId !== undefined) {
            writer.uint32(34).string(message.mapId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestToCowork();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.nookId = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.autoInvite = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatRefreshSessionToken() {
    return {};
}
exports.ChatRefreshSessionToken = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatRefreshSessionToken();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseChatInitiateDm() {
    return { playerIds: [] };
}
exports.ChatInitiateDm = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.playerIds) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChatInitiateDm();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.playerIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapAddObjects() {
    return { mapId: "", objects: [] };
}
exports.MapAddObjects = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        for (const v of message.objects) {
            exports.WireObject.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapAddObjects();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.objects.push(exports.WireObject.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseMapDeleteObjectsById() {
    return { mapId: "", ids: [] };
}
exports.MapDeleteObjectsById = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mapId !== "") {
            writer.uint32(10).string(message.mapId);
        }
        for (const v of message.ids) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapDeleteObjectsById();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.mapId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.ids.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBasePromoteToMember() {
    return { targetId: "" };
}
exports.PromoteToMember = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.targetId !== "") {
            writer.uint32(10).string(message.targetId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePromoteToMember();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.targetId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseRequestPromoteToMember() {
    return {};
}
exports.RequestPromoteToMember = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ownerId !== undefined) {
            writer.uint32(10).string(message.ownerId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestPromoteToMember();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.ownerId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
function createBaseGetAnnotationSessions() {
    return {};
}
exports.GetAnnotationSessions = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetAnnotationSessions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
};
const tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new tsProtoGlobalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
exports.protobufWriterLibrary = minimal_1.default;
//# sourceMappingURL=events.js.map